import React, { useState, useEffect, useLayoutEffect, useCallback, useRef } from 'react'
import { createPortal } from 'react-dom'
import { supabase } from '../supabaseClient'
import DocumentosCliente from './DocumentosCliente'
import NovaOrdemServicoModal from './NovaOrdemServicoModal'
import ConfirmModal from './ConfirmModal'
import DocumentosJuridicosModal from './DocumentosJuridicosModal'
import { enviarProcuracaoParaClicksign } from '../services/clicksignProcuracao'
import { baixarPdfAssinadoClicksign } from '../services/clicksignBaixarAssinado'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { buildContratoHtml, wrapContratoHtmlDocumento, nomeArquivoContrato } from '../utils/contratoTemplate'
import { PDFDocument } from 'pdf-lib'
import { Document, Packer, Paragraph, TextRun, AlignmentType } from 'docx'
import { saveAs } from 'file-saver'
import Swal from 'sweetalert2'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './ClientesII.css'
import KitModeloBusca from './KitModeloBusca'
import ClienteDetalhesModal from './ClienteDetalhesModal'
import { buscarCatalogoSolarStack } from '../services/solarStackCatalog'
import { enriquecerClientesComEtapa } from '../utils/clienteEtapaProcesso'
import {
  aplicarCampoUnifilar,
  atualizarInversorUnifilar,
  baixarPdfUnifilar,
  aplicarMemoriaFormularioUnifilar,
  formularioInicialUnifilar,
  inversoresDoFormulario,
  preencherComKit,
  preservarCamposSalvosUnifilar,
  salvarMemoriaFormularioUnifilar,
  opcoesDisjuntorPadrao,
  textoPreviaUnifilar
} from '../utils/projetoUnifilar'

function formatCepDisplay(cep) {
  const d = String(cep || '').replace(/\D/g, '').slice(0, 8)
  if (d.length <= 5) return d
  return `${d.slice(0, 5)}-${d.slice(5)}`
}

const FORMAS_PAGAMENTO_CADASTRO = [
  { value: 'dinheiro', label: 'Dinheiro / À Vista' },
  { value: 'aprazo', label: 'A Prazo' },
  { value: 'pix', label: 'Pix / Transferência' },
  { value: 'cartao', label: 'Cartão de Crédito' },
  { value: 'financiamento', label: 'Financiamento Bancário' }
]

const INSTITUICAO_SLUG_PARA_NOME = {
  solagora: 'Sol Agora',
  bv: 'BV Financeira',
  santander: 'Santander',
  losango: 'Losango',
  outros: 'Outros'
}

const mapearInstituicaoSalva = (valor) => {
  if (!valor) return ''
  return INSTITUICAO_SLUG_PARA_NOME[valor] || valor
}

const novaLinhaKit = () => ({
  key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  marca: '',
  modelo: '',
  potencia: '',
  quantidade: ''
})

const kitSolarVazio = () => ({
  inversores: [novaLinhaKit()],
  modulos: [novaLinhaKit()]
})

const linhaKitTemDado = (linha = {}) => Boolean(
  String(linha.marca || '').trim() ||
  String(linha.modelo || '').trim() ||
  (linha.potencia !== '' && linha.potencia != null) ||
  (linha.quantidade !== '' && linha.quantidade != null)
)

const serializarLinhasKit = (linhas = []) => linhas.filter(linhaKitTemDado).map((linha) => ({
  marca: String(linha.marca || '').trim() || null,
  modelo: String(linha.modelo || '').trim() || null,
  potencia: linha.potencia === '' || linha.potencia == null ? null : parseFloat(linha.potencia),
  quantidade: linha.quantidade === '' || linha.quantidade == null ? null : parseInt(linha.quantidade, 10)
}))

const linhasKitDeFonte = (lista, legado = {}) => {
  let fonte = lista
  if (typeof fonte === 'string') {
    try {
      fonte = JSON.parse(fonte)
    } catch {
      fonte = null
    }
  }
  if (Array.isArray(fonte) && fonte.length > 0) {
    return fonte.map((linha, i) => ({
      key: `kit-${i}-${Math.random().toString(36).slice(2, 8)}`,
      marca: linha.marca || '',
      modelo: linha.modelo || '',
      potencia: linha.potencia ?? '',
      quantidade: linha.quantidade ?? '',
      daLista: Boolean(String(linha.marca || '').trim() && String(linha.modelo || '').trim())
    }))
  }
  if (legado.marca || legado.modelo || legado.potencia || legado.quantidade) {
    return [{
      key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      marca: legado.marca || '',
      modelo: legado.modelo || '',
      potencia: legado.potencia ?? '',
      quantidade: legado.quantidade ?? '',
      daLista: Boolean(String(legado.marca || '').trim() && String(legado.modelo || '').trim())
    }]
  }
  return [novaLinhaKit()]
}

const mapearKitSolarForm = (fonte = {}) => ({
  inversores: linhasKitDeFonte(fonte.inversores, {
    marca: fonte.marca_inversor,
    modelo: fonte.modelo_inversor,
    potencia: fonte.potencia_inversor,
    quantidade: fonte.quantidade_inversor
  }),
  modulos: linhasKitDeFonte(fonte.modulos, {
    marca: fonte.marca_modulo,
    modelo: fonte.modelo_modulo,
    potencia: fonte.potencia_modulo,
    quantidade: fonte.quantidade_modulo
  })
})

const montarPayloadKitSolar = (data) => {
  const inversores = serializarLinhasKit(data.inversores)
  const modulos = serializarLinhasKit(data.modulos)
  const inversor = inversores[0] || {}
  const modulo = modulos[0] || {}
  return {
    inversores,
    modulos,
    marca_inversor: inversor.marca || null,
    modelo_inversor: inversor.modelo || null,
    potencia_inversor: inversor.potencia ?? null,
    quantidade_inversor: inversor.quantidade ?? null,
    marca_modulo: modulo.marca || null,
    modelo_modulo: modulo.modelo || null,
    potencia_modulo: modulo.potencia ?? null,
    quantidade_modulo: modulo.quantidade ?? null
  }
}

const formatarLinhaKitTexto = (linha, unidade) => {
  const marca = linha.marca || '-'
  const modelo = linha.modelo || '-'
  const potencia = linha.potencia != null && linha.potencia !== '' ? `${linha.potencia} ${unidade}` : '-'
  const quantidade = linha.quantidade != null && linha.quantidade !== '' ? linha.quantidade : '-'
  return `Marca ${marca}, modelo ${modelo}, potência ${potencia}, quantidade ${quantidade}`
}

const novaLinhaPagamento = () => ({
  key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  forma_pagamento: '',
  valor: '',
  instituicao_financiadora: '',
  financiamento_terceiro: false,
  documento_titular_url: '',
  documento_titular_file: null,
  documento_titular_nome: ''
})

const mapearFormaPagamentoLegado = (forma) => {
  if (forma === 'credito') return 'cartao'
  if (forma === 'boleto') return 'aprazo'
  if (forma === 'debito') return 'pix'
  return forma || ''
}

/** Dias corridos desde a data de cadastro até hoje (base meia-noite), alinhado à Homologação. */
function diasCorridosDesdeDataCadastro(dataCadastro) {
  if (!dataCadastro) return null
  const from = new Date(dataCadastro)
  const to = new Date()
  if (Number.isNaN(from.getTime())) return null
  from.setHours(0, 0, 0, 0)
  to.setHours(0, 0, 0, 0)
  const diffMs = to.getTime() - from.getTime()
  if (diffMs <= 0) return 0
  return Math.floor(diffMs / (1000 * 60 * 60 * 24))
}

function formatarDataClienteCurta(dataValue) {
  if (!dataValue) return '—'
  const d = new Date(dataValue)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

function formatarDataHoraClienteResumo(dataValue) {
  if (!dataValue) return ''
  const d = new Date(dataValue)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
}

function StatusEtapaCliente({ cliente }) {
  if (cliente.ativo === false) {
    return <span className="badge-status badge-inactive">Inativo</span>
  }
  const etapa = cliente.etapa_processo
  if (!etapa) {
    return <span className="badge-status badge-etapa-cadastro">Cadastro</span>
  }
  return (
    <div className="cliente-status-etapa">
      <span className={`badge-status ${etapa.classe}`}>{etapa.label}</span>
      {etapa.detalhe && etapa.detalhe !== etapa.label ? (
        <div className="cliente-status-etapa-meta">{etapa.detalhe}</div>
      ) : null}
    </div>
  )
}

function ColunaProcessoCliente({ cliente }) {
  if (cliente.homologado === true) {
    return (
      <div className="cliente-processo-cell">
        <span className="cliente-processo-homologado">Homologado</span>
        {cliente.data_homologado ? (
          <div className="cliente-processo-meta">{formatarDataHoraClienteResumo(cliente.data_homologado)}</div>
        ) : null}
      </div>
    )
  }
  const dias = diasCorridosDesdeDataCadastro(cliente.data_cadastro)
  if (!cliente.data_cadastro || dias == null) {
    return <span className="cliente-processo-vazio">—</span>
  }
  return (
    <div className="cliente-processo-cell">
      <span className="cliente-processo-dias">
        {dias} {dias === 1 ? 'dia' : 'dias'}
      </span>
      <div className="cliente-processo-meta">Desde cadastro: {formatarDataClienteCurta(cliente.data_cadastro)}</div>
    </div>
  )
}

function ClienteAcoesDropdown({ aberto, onToggle, onClose, itens }) {
  const botaoRef = useRef(null)
  const menuRef = useRef(null)
  const [posicao, setPosicao] = useState(null)

  useLayoutEffect(() => {
    if (!aberto || !botaoRef.current) {
      setPosicao(null)
      return
    }
    const rect = botaoRef.current.getBoundingClientRect()
    const largura = 250
    const alturaEstimada = Math.min((itens?.length || 1) * 42 + 12, 430)
    let left = rect.right - largura
    if (left < 8) left = 8
    if (left + largura > window.innerWidth - 8) left = window.innerWidth - largura - 8
    let top = rect.bottom + 6
    if (top + alturaEstimada > window.innerHeight - 8) {
      top = Math.max(8, rect.top - alturaEstimada - 6)
    }
    setPosicao({ top, left, width: largura })
  }, [aberto, itens?.length])

  useEffect(() => {
    if (!aberto || !posicao) return
    let ignorarScroll = true
    const liberarScroll = window.setTimeout(() => { ignorarScroll = false }, 200)
    const fecharFora = (e) => {
      if (botaoRef.current?.contains(e.target) || menuRef.current?.contains(e.target)) return
      onClose()
    }
    const fecharScroll = (e) => {
      if (ignorarScroll) return
      if (menuRef.current?.contains(e.target)) return
      onClose()
    }
    document.addEventListener('click', fecharFora)
    window.addEventListener('scroll', fecharScroll, true)
    window.addEventListener('resize', onClose)
    return () => {
      window.clearTimeout(liberarScroll)
      document.removeEventListener('click', fecharFora)
      window.removeEventListener('scroll', fecharScroll, true)
      window.removeEventListener('resize', onClose)
    }
  }, [aberto, posicao, onClose])

  return (
    <div className="cliente-acoes-dropdown">
      <button
        ref={botaoRef}
        type="button"
        className={`cliente-acoes-toggle${aberto ? ' is-open' : ''}`}
        aria-haspopup="menu"
        aria-expanded={aberto}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onToggle()
        }}
      >
        Ações
        <i className={`bi ${aberto ? 'bi-chevron-up' : 'bi-chevron-down'}`} aria-hidden="true" />
      </button>
      {aberto && posicao && createPortal(
        <div
          ref={menuRef}
          className="cliente-acoes-menu"
          role="menu"
          style={{ top: posicao.top, left: posicao.left, width: posicao.width }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          {(itens || []).map((item) => (
            <button
              key={item.key}
              type="button"
              role="menuitem"
              className={`cliente-acoes-item${item.perigo ? ' is-danger' : ''}`}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                const acao = item.onClick
                onClose()
                acao()
              }}
            >
              <span className="cliente-acoes-item-icon">{item.icon}</span>
              <span className="cliente-acoes-item-texto">
                <span>{item.label}</span>
                {item.detalhe ? <small>{item.detalhe}</small> : null}
              </span>
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  )
}

/**
 * Componente de Gestão de Clientes (ClientesII)
 * 
 * Estrutura da tabela: clientes_cadastro (UUID como PRIMARY KEY)
 * - Suporta cadastro completo com dados pessoais, endereço e compra
 * - Integração com API ViaCEP para busca de endereço
 * - Cálculo automático de parcelas para pagamento financiado
 * - Layout responsivo para dispositivos móveis
 * - Visualização em tabela com filtros e ordenação
 * - Sistema de anexar documentos integrado
 */
const ClientesII = ({ onBack, userRole, userEmpresa, userId, dadosIniciais = null, permissoesMenusCache = {}, hasPermissoesCustomizadas = false }) => {
  const canEnviarClicksign = userRole === 'administrador' || permissoesMenusCache.clientes_ii_enviar_clicksign === true
  const [showForm, setShowForm] = useState(false)
  const [formTab, setFormTab] = useState('pessoais')
  const [modoCadastro, setModoCadastro] = useState('venda') // 'venda' ou 'resumido'
  const permitirVendaEmpresa = userEmpresa?.permitir_venda !== false
  const [clientes, setClientes] = useState([])
  const [loading, setLoading] = useState(false)
  const [editingCliente, setEditingCliente] = useState(null)
  const [showDocumentos, setShowDocumentos] = useState(false)
  const [clienteSelecionado, setClienteSelecionado] = useState(null)
  const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '', onConfirm: null, type: 'warning' })
  const [messageModal, setMessageModal] = useState({ show: false, title: '', message: '', type: 'success' })
  const [successModal, setSuccessModal] = useState({ show: false, clienteId: null, viaEsteira: false })
  const [showClienteModal, setShowClienteModal] = useState(false)
  const [clienteModalData, setClienteModalData] = useState(null)
  const [acoesMenuClienteId, setAcoesMenuClienteId] = useState(null)
  const [listaMobile, setListaMobile] = useState(() => (
    typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  ))
  const [formAbertoManualmente, setFormAbertoManualmente] = useState(false)
  
  // Estados para Kit Solar
  const [showKitSolarModal, setShowKitSolarModal] = useState(false)
  const [kitSolarData, setKitSolarData] = useState(() => kitSolarVazio())
  const [catalogoInversores, setCatalogoInversores] = useState([])
  const [catalogoModulos, setCatalogoModulos] = useState([])
  const [cadastroKitModelo, setCadastroKitModelo] = useState({
    aberto: false,
    tipo: 'inversor',
    marca: '',
    modelo: '',
    potencia: '',
    salvando: false
  })
  const podeCadastrarKitModelo = true
  const [currentClienteForKit, setCurrentClienteForKit] = useState(null)
  
  // Estados para modal de geração de documentos
  const [showDocumentosModal, setShowDocumentosModal] = useState(false)
  const [clienteParaDocumento, setClienteParaDocumento] = useState(null)
  const [showNovaOrdemModal, setShowNovaOrdemModal] = useState(false)
  const [clienteParaNovaOrdem, setClienteParaNovaOrdem] = useState(null)

  // Estados para Gerar Projeto PDF (diagrama unifilar)
  const [showProjetoDxfModal, setShowProjetoDxfModal] = useState(false)
  const [clienteParaProjetoDxf, setClienteParaProjetoDxf] = useState(null)
  const [projetoDxfForm, setProjetoDxfForm] = useState(() => formularioInicialUnifilar())
  const projetoPdfClienteRef = useRef(null)
  const [gerandoProjetoDxf, setGerandoProjetoDxf] = useState(false)
  const [gerandoContratoPdf, setGerandoContratoPdf] = useState(false)

  // Estados para Enviar procuração para assinatura (Clicksign)
  const [showClicksignModal, setShowClicksignModal] = useState(false)
  const [clienteClicksign, setClienteClicksign] = useState(null)
  const [clicksignSendVia, setClicksignSendVia] = useState('whatsapp')
  const [clicksignEmailInput, setClicksignEmailInput] = useState('')
  const [clicksignPhoneInput, setClicksignPhoneInput] = useState('')
  const [sendingClicksign, setSendingClicksign] = useState(false)
  const [clicksignProgressMsg, setClicksignProgressMsg] = useState('Enviando para assinatura…')
  const [clicksignResult, setClicksignResult] = useState(null)
  const [enviosProcuracaoPorCliente, setEnviosProcuracaoPorCliente] = useState({})
  const [procuradores, setProcuradores] = useState([])
  const [clicksignModoEnvio, setClicksignModoEnvio] = useState('procuracao_contrato') // 'procuracao_contrato' | 'anexos'
  const [clicksignAnexos, setClicksignAnexos] = useState([]) // arquivos PDF anexados (usado só quando modo = anexos)
  const [assinaturaSucessoModal, setAssinaturaSucessoModal] = useState({ show: false, clienteNome: '' })
  const [baixandoAssinadoClienteId, setBaixandoAssinadoClienteId] = useState(null)
  const [clicksignHubCliente, setClicksignHubCliente] = useState(null)
  const [clienteDocsJuridicos, setClienteDocsJuridicos] = useState(null)

  // Estados para definir quem cadastrou o cliente (id_responsavel)
  const [showResponsavelModal, setShowResponsavelModal] = useState(false)
  const [clienteParaResponsavel, setClienteParaResponsavel] = useState(null)
  const [usuariosResponsaveis, setUsuariosResponsaveis] = useState([])
  const [responsavelSelecionadoId, setResponsavelSelecionadoId] = useState('')
  const [carregandoResponsaveis, setCarregandoResponsaveis] = useState(false)
  const [salvandoResponsavel, setSalvandoResponsavel] = useState(false)
  
  const [formData, setFormData] = useState({
    // Dados pessoais
    nome_completo: '',
    cpf: '',
    rg: '',
    data_nascimento: '',
    telefone: '',
    email: '',
    
    // Endereço
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    link_localizacao: '',
    foto_fachada: '',
    
    // Dados da compra
    tipo_pagamento: 'avista',
    valor_total: '',
    valor_entrada: '',
    valor_financiado: '',
    quantidade_parcelas: '',
    valor_parcela: '',
    data_compra: new Date().toISOString().split('T')[0],
    observacoes: '',
    
    
    // Majoração e Indicação
    majoracao: '',
    indicacao: false,
    cpf_indicador: '',
    nome_indicador: '',
    
    // Metadados
    ativo: true,
    venda_hangsix: false,
    fatura_terceiro: false,
    documento_titular_fatura_url: ''
  })

  // Composição de pagamento (aba Financeiro e Venda)
  const [pagamentosList, setPagamentosList] = useState(() => [novaLinhaPagamento()])
  const [pagamentoValidacaoErro, setPagamentoValidacaoErro] = useState('')
  const [instituicoesFinanciadoras, setInstituicoesFinanciadoras] = useState([])
  const [cadastroInstituicao, setCadastroInstituicao] = useState({ aberto: false, idx: null, nome: '', salvando: false })
  
  const [searchCep, setSearchCep] = useState(false)
  const [uploadingFotoFachada, setUploadingFotoFachada] = useState(false)
  const [fotoFachadaFile, setFotoFachadaFile] = useState(null)
  const [documentoTitularFaturaFile, setDocumentoTitularFaturaFile] = useState(null)
  
  // Estados para filtros
  const [filtroEmpresa, setFiltroEmpresa] = useState('')
  const [filtroNome, setFiltroNome] = useState('')
  const [filtroCpf, setFiltroCpf] = useState('')
  const [empresas, setEmpresas] = useState([])

  // Estados brasileiros
  const estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
    'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
    'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
  ]

  useEffect(() => {
    loadClientes()
    if (userRole === 'administrador') {
      loadEmpresas()
    } else {
      // Limpar filtro de empresa se não for administrador
      setFiltroEmpresa('')
    }
  }, [userRole])

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)')
    const sincronizar = () => {
      setListaMobile(mq.matches)
      setAcoesMenuClienteId(null)
    }
    sincronizar()
    mq.addEventListener('change', sincronizar)
    return () => mq.removeEventListener('change', sincronizar)
  }, [])

  const carregarInstituicoesFinanciadoras = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('bancos_financiadora')
        .select('id, nome')
        .eq('ativo', true)
        .order('nome')
      if (error) throw error
      setInstituicoesFinanciadoras(data || [])
    } catch (error) {
      console.error('Erro ao carregar instituições financiadoras:', error)
    }
  }, [])

  useEffect(() => {
    carregarInstituicoesFinanciadoras()
  }, [carregarInstituicoesFinanciadoras])

  const carregarCatalogoKitSolar = useCallback(async () => {
    try {
      const [invRes, modRes] = await Promise.all([
        supabase.from('inversores').select('id, marca, modelo, potencia').order('marca').order('modelo'),
        supabase.from('modulos').select('id, marca, modelo, potencia').order('marca').order('modelo')
      ])
      if (invRes.error) console.error('Erro ao carregar inversores:', invRes.error)
      if (modRes.error) console.error('Erro ao carregar módulos:', modRes.error)
      setCatalogoInversores(invRes.data || [])
      setCatalogoModulos(modRes.data || [])
    } catch (error) {
      console.error('Erro ao carregar catálogo de kit solar:', error)
    }
  }, [])

  const buscarInversoresSolarStack = useCallback((termo) => buscarCatalogoSolarStack('inverters', termo), [])
  const buscarModulosSolarStack = useCallback((termo) => buscarCatalogoSolarStack('panels', termo), [])

  const gravarModeloKitLocal = useCallback(async (campo, item) => {
    if (!item || item.origem !== 'solar-stack') return
    const marca = String(item.marca || '').trim()
    const modelo = String(item.modelo || '').trim()
    if (!marca || !modelo) return
    const tabela = campo === 'inversores' ? 'inversores' : 'modulos'
    const potencia = item.potencia === '' || item.potencia == null ? null : Number(item.potencia)
    try {
      const { data: existente, error: erroBusca } = await supabase
        .from(tabela)
        .select('id')
        .eq('marca', marca)
        .eq('modelo', modelo)
        .maybeSingle()
      if (erroBusca) throw erroBusca
      if (existente?.id) return
      const { error } = await supabase.from(tabela).insert([{
        marca,
        modelo,
        potencia: Number.isNaN(potencia) ? null : potencia
      }])
      if (error && error.code !== '23505') throw error
      carregarCatalogoKitSolar()
    } catch (err) {
      console.warn('Não foi possível gravar o modelo no catálogo local:', err?.message || err)
    }
  }, [carregarCatalogoKitSolar])

  useEffect(() => {
    if (showForm || showKitSolarModal) {
      carregarCatalogoKitSolar()
    }
  }, [showForm, showKitSolarModal, carregarCatalogoKitSolar])

  // Sincronizar modo de cadastro com permitir_venda da empresa do usuário (não sobrescreve quando veio de proposta)
  useEffect(() => {
    if (userEmpresa == null || dadosIniciais) return
    setModoCadastro(userEmpresa.permitir_venda === false ? 'resumido' : 'venda')
  }, [userEmpresa?.id, userEmpresa?.permitir_venda, dadosIniciais])
  
  // Carregar empresas para o filtro (apenas para administradores)
  const loadEmpresas = async () => {
    try {
      const { data, error } = await supabase
        .from('empresa')
        .select('id, empresa')
        .order('empresa')
      
      if (error) throw error
      setEmpresas(data || [])
    } catch (error) {
      console.error('Erro ao carregar empresas:', error)
    }
  }

  // Preencher formulário com dados iniciais (vindos de Consulta Propostas – proposta = venda = cadastro completo)
  useEffect(() => {
    if (dadosIniciais) {
      // Proposta é venda: usar cadastro completo (modo venda)
      setModoCadastro('venda')

      // Formatar valor total para padrão brasileiro
      const valorTotalFormatado = dadosIniciais.valor_total 
        ? parseFloat(dadosIniciais.valor_total).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : ''

      // Formatar majoração para padrão brasileiro
      const majoracaoFormatada = dadosIniciais.majoracao 
        ? parseFloat(dadosIniciais.majoracao).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : ''

      setFormData(prev => ({
        ...prev,
        nome_completo: dadosIniciais.nome_completo || '',
        cpf: dadosIniciais.cpf || '',
        majoracao: majoracaoFormatada,
        valor_total: valorTotalFormatado
      }))

      const valorProposta = dadosIniciais.valor_total ? parseFloat(dadosIniciais.valor_total) : 0
      if (valorProposta > 0) {
        setPagamentosList([{
          ...novaLinhaPagamento(),
          forma_pagamento: 'pix',
          valor: valorTotalFormatado
        }])
      } else {
        setPagamentosList([novaLinhaPagamento()])
      }
      setPagamentoValidacaoErro('')

      // Abrir o formulário automaticamente
      setFormAbertoManualmente(false) // Não foi aberto manualmente, veio de dados iniciais
      setFormTab('pessoais')
      setShowForm(true)

      // Mostrar notificação informando que os dados foram preenchidos
      showNotification('✅ Formulário preenchido com dados da proposta! Complete as informações restantes.', 'success')
    }
  }, [dadosIniciais])

  useEffect(() => {
    // Recalcular valores quando o tipo de pagamento mudar
    if (formData.tipo_pagamento === 'avista') {
      setFormData(prev => ({
        ...prev,
        valor_financiado: '',
        quantidade_parcelas: '',
        valor_parcela: ''
      }))
    }
  }, [formData.tipo_pagamento])

  // Recalcular parcelas automaticamente quando valores relevantes mudarem
  useEffect(() => {
    if (formData.tipo_pagamento === 'financiado' && 
        formData.valor_total && 
        formData.quantidade_parcelas) {
      
      const valorTotal = parseCurrencyBR(formData.valor_total) || 0
      const valorEntrada = parseCurrencyBR(formData.valor_entrada) || 0
      const quantidadeParcelas = parseInt(formData.quantidade_parcelas) || 1
      
      if (valorTotal > 0 && quantidadeParcelas > 0) {
        const valorFinanciado = valorTotal - valorEntrada
        const valorParcela = valorFinanciado / quantidadeParcelas
        
        setFormData(prev => ({
          ...prev,
          valor_financiado: valorFinanciado.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }),
          valor_parcela: valorParcela.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        }))
      }
    }
  }, [formData.valor_total, formData.valor_entrada, formData.quantidade_parcelas, formData.tipo_pagamento])

  const showNotification = (message, type = 'success') => {
    const title = type === 'success' ? 'Sucesso!' : 'Erro'
    setMessageModal({ show: true, title, message, type })
  }

  const closeMessageModal = () => {
    setMessageModal({ show: false, title: '', message: '', type: 'success' })
  }

  const loadProcuracaoEnvios = useCallback(async () => {
    if (!clientes?.length) {
      setEnviosProcuracaoPorCliente({})
      return
    }
    try {
      const ids = clientes.map(c => c.id)
      const { data, error } = await supabase
        .from('procuracao_clicksign_envios')
        .select('cliente_id, document_key, clicksign_document_id, signing_url, send_via, created_at, signed_at')
        .in('cliente_id', ids)
        .order('created_at', { ascending: false })
      if (error) throw error
      const latest = {}
      for (const row of data || []) {
        if (!latest[row.cliente_id]) latest[row.cliente_id] = row
      }
      setEnviosProcuracaoPorCliente(latest)
    } catch (err) {
      console.error('Erro ao carregar envios de procuração:', err)
      setEnviosProcuracaoPorCliente({})
    }
  }, [clientes])

  useEffect(() => {
    loadProcuracaoEnvios()
  }, [loadProcuracaoEnvios])

  const loadProcuradores = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('procuradores')
        .select('*')
        .eq('ativo', true)
        .order('nome_procurador', { ascending: true })
      if (error) throw error
      setProcuradores(data || [])
    } catch (err) {
      console.error('Erro ao carregar procuradores:', err)
      setProcuradores([])
    }
  }, [])

  useEffect(() => {
    loadProcuradores()
  }, [loadProcuradores])

  // Realtime: atualizar botão e mostrar modal quando o documento for assinado (webhook atualiza signed_at)
  useEffect(() => {
    const channel = supabase
      .channel('procuracao-clicksign-envios-changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'procuracao_clicksign_envios'
        },
        (payload) => {
          const newRow = payload?.new
          const oldRow = payload?.old
          if (newRow?.signed_at && !oldRow?.signed_at) {
            const clienteId = newRow.cliente_id
            const nome = clientes?.find(c => c.id === clienteId)?.nome_completo || 'Cliente'
            setAssinaturaSucessoModal({ show: true, clienteNome: nome })
          }
          loadProcuracaoEnvios()
        }
      )
      .subscribe()
    return () => {
      supabase.removeChannel(channel)
    }
  }, [loadProcuracaoEnvios, clientes])

  // Função para atualizar status da proposta para "Aprovada"
  const atualizarStatusProposta = async (propostaId) => {
    if (!propostaId) return { success: true }
    
    try {
      const { error } = await supabase
        .from('propostas_clientes')
        .update({ status: 4 }) // 4 = Aprovada
        .eq('id', propostaId)

      if (error) {
        console.error('Erro ao atualizar status da proposta:', error)
        return { success: false, error }
      }

      console.log(`✅ Proposta #${propostaId} atualizada para status Aprovada`)
      return { success: true }
    } catch (error) {
      console.error('Erro ao atualizar proposta:', error)
      return { success: false, error }
    }
  }

  // Enriquece a lista de clientes com o nome de quem cadastrou (id_responsavel -> usuarios_sistema.nome)
  const enriquecerComResponsavel = async (clientesList) => {
    try {
      const ids = [...new Set((clientesList || [])
        .map(c => c.id_responsavel)
        .filter(Boolean))]

      if (ids.length === 0) {
        return (clientesList || []).map(c => ({ ...c, responsavel_nome: null }))
      }

      const { data: responsaveis, error } = await supabase
        .from('usuarios_sistema')
        .select('id, nome')
        .in('id', ids)

      if (error) {
        console.error('❌ Erro ao buscar responsáveis pelo cadastro:', error)
        return (clientesList || []).map(c => ({ ...c, responsavel_nome: null }))
      }

      const mapaResponsaveis = new Map((responsaveis || []).map(u => [u.id, u.nome]))
      return (clientesList || []).map(c => ({
        ...c,
        responsavel_nome: c.id_responsavel ? (mapaResponsaveis.get(c.id_responsavel) || null) : null
      }))
    } catch (err) {
      console.error('❌ Erro ao enriquecer clientes com responsável:', err)
      return (clientesList || []).map(c => ({ ...c, responsavel_nome: null }))
    }
  }

  // Abre o modal para definir quem cadastrou o cliente e carrega a lista de usuários
  const abrirResponsavelModal = async (cliente) => {
    setClienteParaResponsavel(cliente)
    setResponsavelSelecionadoId(cliente?.id_responsavel || '')
    setShowResponsavelModal(true)
    setCarregandoResponsaveis(true)
    try {
      let query = supabase
        .from('usuarios_sistema')
        .select('id, nome')
        .eq('status', 'ativo')
        .order('nome')

      if (cliente?.empresa_id) {
        query = query.or(`empresa_id.eq.${cliente.empresa_id},multiempresas.eq.true`)
      }

      const { data, error } = await query
      if (error) throw error

      const lista = data || []
      if (cliente?.id_responsavel && !lista.some((u) => u.id === cliente.id_responsavel)) {
        lista.unshift({
          id: cliente.id_responsavel,
          nome: cliente.responsavel_nome || 'Usuário atual'
        })
      }
      setUsuariosResponsaveis(lista)
    } catch (err) {
      console.error('❌ Erro ao carregar usuários:', err)
      setUsuariosResponsaveis([])
      showNotification('Erro ao carregar usuários: ' + err.message, 'error')
    } finally {
      setCarregandoResponsaveis(false)
    }
  }

  const fecharResponsavelModal = () => {
    if (salvandoResponsavel) return
    setShowResponsavelModal(false)
    setClienteParaResponsavel(null)
    setResponsavelSelecionadoId('')
  }

  // Salva o id_responsavel escolhido no cliente
  const salvarResponsavel = async () => {
    if (!clienteParaResponsavel || !responsavelSelecionadoId) return
    try {
      setSalvandoResponsavel(true)
      const { error } = await supabase
        .from('clientes_cadastro')
        .update({ id_responsavel: responsavelSelecionadoId })
        .eq('id', clienteParaResponsavel.id)

      if (error) throw error

      const nome = usuariosResponsaveis.find(u => u.id === responsavelSelecionadoId)?.nome || null
      setClientes(prev => prev.map(c => (
        c.id === clienteParaResponsavel.id
          ? { ...c, id_responsavel: responsavelSelecionadoId, responsavel_nome: nome }
          : c
      )))

      showNotification(
        clienteParaResponsavel.id_responsavel
          ? 'Responsável pelo cadastro alterado com sucesso!'
          : 'Responsável pelo cadastro definido com sucesso!',
        'success'
      )
      setShowResponsavelModal(false)
      setClienteParaResponsavel(null)
      setResponsavelSelecionadoId('')
    } catch (err) {
      console.error('❌ Erro ao definir responsável:', err)
      showNotification('Erro ao definir responsável: ' + err.message, 'error')
    } finally {
      setSalvandoResponsavel(false)
    }
  }

  const loadClientes = async () => {
    try {
      setLoading(true)
      
      // Administrador, Gerente, Administrativo e Homologador veem clientes da sua empresa
      // (Administrador e Homologador veem todos os clientes)
      if (userRole === 'administrador' || userRole === 'gerente' || userRole === 'administrativo' || userRole === 'homologador') {
        let clientesData = []
        
        // Se for administrador ou homologador, buscar todos os clientes
        if (userRole === 'administrador' || userRole === 'homologador') {
          const { data, error } = await supabase
            .from('clientes_cadastro')
            .select(`
              *,
              kit_solar_cliente (
                marca_inversor,
                modelo_inversor,
                potencia_inversor,
                quantidade_inversor,
                marca_modulo,
                modelo_modulo,
                potencia_modulo,
                quantidade_modulo,
                inversores,
                modulos
              )
            `)
            .eq('venda_hangsix', true)
            .order('data_cadastro', { ascending: false })

          if (error) throw error
          clientesData = data || []
        } else {
          // Para não-administradores, buscar clientes da empresa e também com permissão
          if (userEmpresa?.id) {
            // 1. Buscar clientes da empresa do usuário
            const { data: clientesEmpresa, error: errorEmpresa } = await supabase
              .from('clientes_cadastro')
              .select(`
                *,
                kit_solar_cliente (
                  marca_inversor,
                  modelo_inversor,
                  potencia_inversor,
                  quantidade_inversor,
                  marca_modulo,
                  modelo_modulo,
                  potencia_modulo,
                  quantidade_modulo,
                  inversores,
                  modulos
                )
              `)
              .eq('empresa_id', userEmpresa.id)
              .eq('venda_hangsix', true)
              .order('data_cadastro', { ascending: false })

            if (errorEmpresa) throw errorEmpresa
            const clientesEmpresaList = clientesEmpresa || []
            console.log('📋 Clientes da empresa do usuário:', clientesEmpresaList.length)

            // 2. Buscar permissões de instalações autorizadas
            const { data: permissoes, error: errorPermissoes } = await supabase
              .from('permissoes_instalacoes')
              .select('instalacao_id')
              .eq('empresa_autorizada_id', userEmpresa.id)

            if (errorPermissoes) {
              console.error('❌ Erro ao buscar permissões:', errorPermissoes)
              // Não lançar erro, apenas continuar sem permissões adicionais
            }

            const instalacaoIdsPermitidos = (permissoes || []).map(p => p.instalacao_id)
            console.log('🔐 Instalações autorizadas encontradas:', instalacaoIdsPermitidos.length)

            // 3. Buscar clientes das instalações autorizadas (que não sejam da própria empresa)
            if (instalacaoIdsPermitidos.length > 0) {
              const { data: clientesPermitidos, error: errorPermitidos } = await supabase
                .from('clientes_cadastro')
                .select(`
                  *,
                  kit_solar_cliente (
                    marca_inversor,
                    modelo_inversor,
                    potencia_inversor,
                    quantidade_inversor,
                    marca_modulo,
                    modelo_modulo,
                    potencia_modulo,
                    quantidade_modulo,
                    inversores,
                    modulos
                  )
                `)
                .in('id', instalacaoIdsPermitidos)
                .neq('empresa_id', userEmpresa.id) // Excluir clientes da própria empresa (já estão em clientesEmpresaList)
                .eq('venda_hangsix', true)
                .order('data_cadastro', { ascending: false })

              if (errorPermitidos) {
                console.error('❌ Erro ao buscar clientes permitidos:', errorPermitidos)
                // Não lançar erro, apenas continuar sem clientes adicionais
              } else {
                const clientesPermitidosList = clientesPermitidos || []
                console.log('📋 Clientes permitidos encontrados:', clientesPermitidosList.length)

                // 4. Combinar clientes (usar Map para evitar duplicatas)
                const clientesMap = new Map()
                clientesEmpresaList.forEach(cliente => {
                  clientesMap.set(cliente.id, cliente)
                })
                clientesPermitidosList.forEach(cliente => {
                  clientesMap.set(cliente.id, cliente)
                })

                // Converter para array e ordenar por data
                clientesData = Array.from(clientesMap.values()).sort((a, b) => {
                  const dateA = new Date(a.data_cadastro || 0)
                  const dateB = new Date(b.data_cadastro || 0)
                  return dateB - dateA // Ordem decrescente (mais recente primeiro)
                })
              }
            } else {
              clientesData = clientesEmpresaList
            }

            console.log('📋 Total de clientes encontrados (com permissões):', clientesData.length)
          }
        }

        // Processar dados para incluir Kit Solar no objeto cliente
        const clientesComKitSolar = (clientesData || []).map(cliente => ({
          ...cliente,
          // Incluir dados do Kit Solar diretamente no objeto cliente para compatibilidade
          marca_inversor: cliente.kit_solar_cliente?.[0]?.marca_inversor || null,
          modelo_inversor: cliente.kit_solar_cliente?.[0]?.modelo_inversor || null,
          potencia_inversor: cliente.kit_solar_cliente?.[0]?.potencia_inversor || null,
          quantidade_inversor: cliente.kit_solar_cliente?.[0]?.quantidade_inversor || null,
          marca_modulo: cliente.kit_solar_cliente?.[0]?.marca_modulo || null,
          modelo_modulo: cliente.kit_solar_cliente?.[0]?.modelo_modulo || null,
          potencia_modulo: cliente.kit_solar_cliente?.[0]?.potencia_modulo || null,
          quantidade_modulo: cliente.kit_solar_cliente?.[0]?.quantidade_modulo || null,
          inversores: cliente.kit_solar_cliente?.[0]?.inversores || null,
          modulos: cliente.kit_solar_cliente?.[0]?.modulos || null
        }))
      
        setClientes(await enriquecerClientesComEtapa(await enriquecerComResponsavel(clientesComKitSolar)))
      } 
      // Especialista vê apenas clientes vinculados às suas propostas (id_proposta da proposta onde id_usuario_responsavel = userId)
      else if (userRole === 'especialista') {
        let clientesData = []
        
        if (userEmpresa?.id && userId) {
          // 1. Buscar IDs das propostas do especialista
          const { data: propostasEspecialista, error: errorPropostas } = await supabase
            .from('propostas_clientes')
            .select('id')
            .eq('id_usuario_responsavel', userId)

          if (errorPropostas) {
            console.error('❌ Erro ao buscar propostas do especialista:', errorPropostas)
            setClientes([])
            return
          }

          const idsPropostas = (propostasEspecialista || []).map(p => p.id).filter(Boolean)
          console.log('📋 Propostas do especialista:', idsPropostas.length)

          let clientesFiltrados = []

          // 2a. Buscar clientes da empresa vinculados às propostas do especialista
          if (idsPropostas.length > 0) {
            const { data: clientesPorProposta, error: errorEmpresa } = await supabase
              .from('clientes_cadastro')
              .select(`
                *,
                kit_solar_cliente (
                  marca_inversor,
                  modelo_inversor,
                  potencia_inversor,
                  quantidade_inversor,
                  marca_modulo,
                  modelo_modulo,
                  potencia_modulo,
                  quantidade_modulo,
                  inversores,
                  modulos
                )
              `)
              .eq('empresa_id', userEmpresa.id)
              .eq('venda_hangsix', true)
              .in('id_proposta', idsPropostas)
              .order('data_cadastro', { ascending: false })

            if (errorEmpresa) {
              console.error('❌ Erro ao buscar clientes do especialista (por proposta):', errorEmpresa)
              throw errorEmpresa
            }
            (clientesPorProposta || []).forEach(c => clientesFiltrados.push(c))
          }

          // 2b. Buscar clientes da empresa cadastrados direto pelo especialista (id_responsavel)
          const { data: clientesPorResponsavel, error: errorResponsavel } = await supabase
            .from('clientes_cadastro')
            .select(`
              *,
              kit_solar_cliente (
                marca_inversor,
                modelo_inversor,
                potencia_inversor,
                quantidade_inversor,
                marca_modulo,
                modelo_modulo,
                potencia_modulo,
                quantidade_modulo,
                inversores,
                modulos
              )
            `)
            .eq('empresa_id', userEmpresa.id)
            .eq('venda_hangsix', true)
            .eq('id_responsavel', userId)
            .order('data_cadastro', { ascending: false })

          if (!errorResponsavel && clientesPorResponsavel && clientesPorResponsavel.length > 0) {
            const mapById = new Map(clientesFiltrados.map(c => [c.id, c]))
            clientesPorResponsavel.forEach(c => mapById.set(c.id, c))
            clientesFiltrados = Array.from(mapById.values())
          }

          console.log('📋 Clientes do especialista (da empresa):', clientesFiltrados.length)

          // 3. Buscar permissões de instalações autorizadas (outras empresas que autorizaram esta)
          const { data: permissoes, error: errorPermissoes } = await supabase
            .from('permissoes_instalacoes')
            .select('instalacao_id')
            .eq('empresa_autorizada_id', userEmpresa.id)

          if (errorPermissoes) {
            console.error('❌ Erro ao buscar permissões:', errorPermissoes)
          }

          const instalacaoIdsPermitidos = (permissoes || []).map(p => p.instalacao_id).filter(Boolean)
          console.log('🔐 Instalações autorizadas:', instalacaoIdsPermitidos.length)

          // 4. Buscar clientes de outras empresas (instalações autorizadas): id_proposta nas propostas do especialista OU id_responsavel = userId
          if (instalacaoIdsPermitidos.length > 0) {
            const clientesPermitidosList = []
            if (idsPropostas.length > 0) {
              const { data: porProposta } = await supabase
                .from('clientes_cadastro')
                .select(`
                  *,
                  kit_solar_cliente (
                    marca_inversor,
                    modelo_inversor,
                    potencia_inversor,
                    quantidade_inversor,
                    marca_modulo,
                    modelo_modulo,
                    potencia_modulo,
                    quantidade_modulo,
                    inversores,
                    modulos
                  )
                `)
                .in('id', instalacaoIdsPermitidos)
                .in('id_proposta', idsPropostas)
                .neq('empresa_id', userEmpresa.id)
                .eq('venda_hangsix', true)
                .order('data_cadastro', { ascending: false })
              if (porProposta?.length) clientesPermitidosList.push(...porProposta)
            }
            const { data: porResponsavel } = await supabase
              .from('clientes_cadastro')
              .select(`
                *,
                kit_solar_cliente (
                  marca_inversor,
                  modelo_inversor,
                  potencia_inversor,
                  quantidade_inversor,
                  marca_modulo,
                  modelo_modulo,
                  potencia_modulo,
                  quantidade_modulo,
                  inversores,
                  modulos
                )
              `)
              .in('id', instalacaoIdsPermitidos)
              .eq('id_responsavel', userId)
              .neq('empresa_id', userEmpresa.id)
              .eq('venda_hangsix', true)
              .order('data_cadastro', { ascending: false })
            if (porResponsavel?.length) clientesPermitidosList.push(...porResponsavel)

            if (clientesPermitidosList.length > 0) {
              console.log('📋 Clientes permitidos do especialista (outras empresas):', clientesPermitidosList.length)
              const clientesMap = new Map(clientesFiltrados.map(c => [c.id, c]))
              clientesPermitidosList.forEach(c => clientesMap.set(c.id, c))
              clientesFiltrados = Array.from(clientesMap.values())
            }
          }

          clientesData = clientesFiltrados.sort((a, b) => {
            const dateA = new Date(a.data_cadastro || 0)
            const dateB = new Date(b.data_cadastro || 0)
            return dateB - dateA
          })
          console.log('📋 Total de clientes do especialista:', clientesData.length)
        }
        
        // Processar dados para incluir Kit Solar no objeto cliente
        const clientesComKitSolar = (clientesData || []).map(cliente => ({
          ...cliente,
          marca_inversor: cliente.kit_solar_cliente?.[0]?.marca_inversor || null,
          modelo_inversor: cliente.kit_solar_cliente?.[0]?.modelo_inversor || null,
          potencia_inversor: cliente.kit_solar_cliente?.[0]?.potencia_inversor || null,
          quantidade_inversor: cliente.kit_solar_cliente?.[0]?.quantidade_inversor || null,
          marca_modulo: cliente.kit_solar_cliente?.[0]?.marca_modulo || null,
          modelo_modulo: cliente.kit_solar_cliente?.[0]?.modelo_modulo || null,
          potencia_modulo: cliente.kit_solar_cliente?.[0]?.potencia_modulo || null,
          quantidade_modulo: cliente.kit_solar_cliente?.[0]?.quantidade_modulo || null,
          inversores: cliente.kit_solar_cliente?.[0]?.inversores || null,
          modulos: cliente.kit_solar_cliente?.[0]?.modulos || null
        }))
        
        setClientes(await enriquecerClientesComEtapa(await enriquecerComResponsavel(clientesComKitSolar)))
      }
      // Outros tipos de usuário não têm acesso
      else {
        setClientes([])
      }
    } catch (error) {
      console.error('Erro ao carregar clientes:', error)
      showNotification('Erro ao carregar clientes: ' + error.message, 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    // CEP: apenas números
    if (name === 'cep') {
      const apenasNumeros = (value || '').replace(/\D/g, '')
      setFormData(prev => ({ ...prev, [name]: apenasNumeros }))
      return
    }
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const buscarCep = async (cepOverride, { silencioso = false } = {}) => {
    const cep = String(cepOverride ?? formData.cep ?? '').replace(/\D/g, '')
    if (cep.length !== 8) {
      if (!silencioso) showNotification('CEP inválido. Digite 8 dígitos.', 'error')
      return
    }

    try {
      setSearchCep(true)
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const data = await response.json()

      if (data.erro) {
        if (!silencioso) showNotification('CEP não encontrado.', 'error')
        return
      }

      setFormData(prev => ({
        ...prev,
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || ''
      }))

      if (!silencioso) showNotification('Endereço encontrado!', 'success')
    } catch (error) {
      console.error('Erro ao buscar CEP:', error)
      if (!silencioso) showNotification('Erro ao buscar CEP. Tente novamente.', 'error')
    } finally {
      setSearchCep(false)
    }
  }

  // Função para fazer upload da foto da fachada
  const handleFotoFachadaUpload = async (file) => {
    if (!file) return

    // Validar se é uma imagem
    if (!file.type.startsWith('image/')) {
      showNotification('Por favor, selecione um arquivo de imagem.', 'error')
      return
    }

    // Validar tamanho (máximo 10MB)
    const maxSize = 10 * 1024 * 1024 // 10MB
    if (file.size > maxSize) {
      showNotification('A imagem deve ter no máximo 10MB', 'error')
      return
    }

    try {
      setUploadingFotoFachada(true)

      // Gerar nome único para o arquivo
      // Se estiver editando, usar o ID do cliente; caso contrário, usar timestamp temporário
      // O arquivo será movido/renomeado após o cliente ser criado
      const clienteId = editingCliente?.id || `temp_${Date.now()}`
      const fileExt = file.name.split('.').pop()
      const timestamp = Date.now()
      const fileName = `${clienteId}/fachada_${timestamp}.${fileExt}`

      // Upload do arquivo para o Supabase Storage
      const { data: uploadData, error: uploadError } = await supabase.storage
        .from('Fachadas')
        .upload(fileName, file, {
          cacheControl: '3600',
          upsert: false
        })

      if (uploadError) {
        if (uploadError.message.includes('Bucket not found')) {
          throw new Error('❌ Bucket não encontrado! Você precisa criar o bucket "Fachadas" no Supabase Storage primeiro.')
        }
        throw uploadError
      }

      // Obter URL pública do arquivo
      const { data: { publicUrl } } = supabase.storage
        .from('Fachadas')
        .getPublicUrl(fileName)

      // Atualizar o campo foto_fachada com a URL
      setFormData(prev => ({
        ...prev,
        foto_fachada: publicUrl
      }))

      // Salvar referência do arquivo para preview
      setFotoFachadaFile({
        file: file,
        url: publicUrl,
        name: file.name
      })

      showNotification('Foto da fachada enviada com sucesso!', 'success')
    } catch (error) {
      console.error('Erro ao fazer upload da foto da fachada:', error)
      showNotification('Erro ao fazer upload: ' + error.message, 'error')
    } finally {
      setUploadingFotoFachada(false)
    }
  }

  const formatCPF = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')
    // Retorna apenas os números (máximo 11)
    return numbers.slice(0, 11)
  }

  const formatCurrency = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')
    // Converte para número e divide por 100
    const amount = parseFloat(numbers) / 100
    // Retorna formatado ou vazio se for 0
    return amount > 0 ? amount.toFixed(2) : ''
  }

  const formatCurrencyInput = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')
    
    if (!numbers) return ''
    
    // Converte para número e divide por 100
    const amount = parseFloat(numbers) / 100
    
    // Formata com separador de milhar e decimal brasileiro
    return amount.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  const parseCurrencyBR = (value) => {
    if (value == null || value === '') return 0
    if (typeof value === 'number') return value
    const cleanValue = String(value)
      .replace(/R\$\s?/gi, '')
      .replace(/\s/g, '')
      .replace(/\./g, '')
      .replace(',', '.')
    return parseFloat(cleanValue) || 0
  }

  const valorLinhaPagamento = (pagamento) => {
    if (typeof pagamento?.valor === 'number') return pagamento.valor
    return parseCurrencyBR(pagamento?.valor)
  }

  const atualizarPagamento = (idx, patch) => {
    setPagamentoValidacaoErro('')
    setPagamentosList((prev) => prev.map((p, i) => (i === idx ? { ...p, ...patch } : p)))
  }

  const adicionarPagamento = () => {
    setPagamentoValidacaoErro('')
    setPagamentosList((prev) => [...prev, novaLinhaPagamento()])
  }

  const removerPagamento = (idx) => {
    setPagamentoValidacaoErro('')
    setPagamentosList((prev) => (prev.length <= 1 ? [novaLinhaPagamento()] : prev.filter((_, i) => i !== idx)))
  }

  const handleFormaPagamentoChange = (idx, forma) => {
    const patch = { forma_pagamento: forma }
    if (forma !== 'financiamento') {
      patch.instituicao_financiadora = ''
      patch.financiamento_terceiro = false
      patch.documento_titular_file = null
      patch.documento_titular_nome = ''
      patch.documento_titular_url = ''
      if (cadastroInstituicao.idx === idx) {
        setCadastroInstituicao({ aberto: false, idx: null, nome: '', salvando: false })
      }
    }
    atualizarPagamento(idx, patch)
  }

  const abrirCadastroInstituicao = (idx) => {
    setCadastroInstituicao({ aberto: true, idx, nome: '', salvando: false })
  }

  const fecharCadastroInstituicao = () => {
    setCadastroInstituicao({ aberto: false, idx: null, nome: '', salvando: false })
  }

  const salvarNovaInstituicao = async (idx) => {
    const nome = (cadastroInstituicao.nome || '').trim()
    if (!nome) {
      showNotification('Informe o nome da instituição financiadora.', 'error')
      return
    }
    setCadastroInstituicao((prev) => ({ ...prev, salvando: true }))
    try {
      const { data, error } = await supabase
        .from('bancos_financiadora')
        .insert([{ nome, ativo: true }])
        .select('id, nome')
        .single()

      if (error) {
        if (error.code === '23505') {
          await carregarInstituicoesFinanciadoras()
          atualizarPagamento(idx, { instituicao_financiadora: nome })
          fecharCadastroInstituicao()
          showNotification('Instituição já cadastrada. Ela foi selecionada.', 'success')
          return
        }
        throw error
      }

      setInstituicoesFinanciadoras((prev) => {
        const jaTem = prev.some((item) => item.id === data.id || item.nome === data.nome)
        return jaTem ? prev : [...prev, data].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
      })
      atualizarPagamento(idx, { instituicao_financiadora: data.nome })
      fecharCadastroInstituicao()
      showNotification('Instituição financiadora cadastrada.', 'success')
    } catch (error) {
      console.error('Erro ao cadastrar instituição financiadora:', error)
      showNotification(error.message || 'Erro ao cadastrar a instituição.', 'error')
      setCadastroInstituicao((prev) => ({ ...prev, salvando: false }))
    }
  }

  const mimeDocumentoPermitido = (file) => {
    const type = String(file?.type || '').toLowerCase()
    const ext = (file?.name.split('.').pop() || '').toLowerCase()
    const mimes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp']
    const exts = ['pdf', 'jpg', 'jpeg', 'png', 'webp']
    return mimes.includes(type) || exts.includes(ext)
  }

  const mimeDocumentoPorArquivo = (file) => {
    const ext = (file?.name.split('.').pop() || '').toLowerCase()
    if (ext === 'pdf') return 'application/pdf'
    if (ext === 'png') return 'image/png'
    if (ext === 'webp') return 'image/webp'
    if (ext === 'jpg' || ext === 'jpeg') return 'image/jpeg'
    return file?.type || 'application/octet-stream'
  }

  const handleDocumentoTitularChange = (idx, file) => {
    if (!file) {
      atualizarPagamento(idx, { documento_titular_file: null, documento_titular_nome: '' })
      return
    }
    if (!mimeDocumentoPermitido(file)) {
      showNotification('Envie PDF, JPG ou PNG do documento do titular.', 'error')
      return
    }
    if (file.size > 10 * 1024 * 1024) {
      showNotification('O arquivo deve ter no máximo 10MB.', 'error')
      return
    }
    atualizarPagamento(idx, { documento_titular_file: file, documento_titular_nome: file.name })
  }

  const uploadDocumentoTitular = async (file, clienteId, prefixo = 'financiamento_titular') => {
    const fileExt = ((file.name.split('.').pop() || 'bin').toLowerCase().match(/^[a-z0-9]+/) || ['bin'])[0]
    const fileName = `${clienteId}/${prefixo}_${Date.now()}.${fileExt}`
    const { error: uploadError } = await supabase.storage
      .from('documentos-clientes')
      .upload(fileName, file, {
        cacheControl: '3600',
        upsert: false,
        contentType: mimeDocumentoPorArquivo(file)
      })
    if (uploadError) {
      if (uploadError.message?.includes('Bucket not found')) {
        throw new Error('Bucket "documentos-clientes" não encontrado. Crie o bucket no Storage para anexar o documento.')
      }
      throw uploadError
    }
    const { data: { publicUrl } } = supabase.storage.from('documentos-clientes').getPublicUrl(fileName)
    return publicUrl
  }

  const handleDocumentoTitularFaturaChange = (file) => {
    if (!file) {
      setDocumentoTitularFaturaFile(null)
      return
    }
    if (!mimeDocumentoPermitido(file)) {
      showNotification('Envie PDF, JPG ou PNG do documento do titular da fatura.', 'error')
      return
    }
    if (file.size > 10 * 1024 * 1024) {
      showNotification('O arquivo deve ter no máximo 10MB.', 'error')
      return
    }
    setDocumentoTitularFaturaFile(file)
  }

  const handleCPFChange = (e) => {
    const { name } = e.target
    const formatted = formatCPF(e.target.value)
    setFormData(prev => ({ ...prev, [name]: formatted }))
  }

  const handleCurrencyChange = (e) => {
    const { name } = e.target
    const formatted = formatCurrencyInput(e.target.value)
    if (name === 'valor_total') setPagamentoValidacaoErro('')
    setFormData(prev => ({ ...prev, [name]: formatted }))
  }

  const recalcularParcelas = () => {
    if (formData.tipo_pagamento === 'financiado') {
      const valorTotal = parseCurrencyBR(formData.valor_total) || 0
      const valorEntrada = parseCurrencyBR(formData.valor_entrada) || 0
      const quantidadeParcelas = parseInt(formData.quantidade_parcelas) || 1
      
      const valorFinanciado = valorTotal - valorEntrada
      const valorParcela = valorFinanciado / quantidadeParcelas
      
      // Formata os valores calculados no padrão brasileiro
      setFormData(prev => ({
        ...prev,
        valor_financiado: valorFinanciado.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        valor_parcela: valorParcela.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }))
    }
  }

  const validarCPF = (cpf) => {
    if (cpf.length !== 11) return false
    
    // Eliminar CPFs inválidos conhecidos
    if (/^(\d)\1{10}$/.test(cpf)) return false
    
    // Validar primeiro dígito verificador
    let soma = 0
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let resto = 11 - (soma % 11)
    let digitoVerificador1 = resto >= 10 ? 0 : resto
    
    if (digitoVerificador1 !== parseInt(cpf.charAt(9))) return false
    
    // Validar segundo dígito verificador
    soma = 0
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i)
    }
    resto = 11 - (soma % 11)
    let digitoVerificador2 = resto >= 10 ? 0 : resto
    
    return digitoVerificador2 === parseInt(cpf.charAt(10))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validações básicas (sempre obrigatórias)
    if (!formData.nome_completo.trim()) {
      setFormTab('pessoais')
      showNotification('Nome completo é obrigatório.', 'error')
      return
    }

    if (formData.fatura_terceiro && !formData.documento_titular_fatura_url && !documentoTitularFaturaFile) {
      setFormTab('pessoais')
      showNotification('Anexe o documento com foto (CNH ou RG) do titular da fatura de energia.', 'error')
      return
    }

    // Validações específicas do modo venda (dados da compra vêm da tabela de formas de pagamento)
    if (modoCadastro === 'venda') {
      if (!validarCPF(formData.cpf)) {
        setFormTab('pessoais')
        showNotification('CPF inválido.', 'error')
        return
      }

      const valorTotalProjeto = parseCurrencyBR(formData.valor_total)
      const totalPagamentos = pagamentosList.reduce((s, p) => s + valorLinhaPagamento(p), 0)

      if (valorTotalProjeto <= 0) {
        const msg = 'O Valor Total do Projeto precisa ser preenchido.'
        setFormTab('financeiro')
        setPagamentoValidacaoErro(msg)
        showNotification(msg, 'error')
        return
      }

      for (const p of pagamentosList) {
        if (!p.forma_pagamento) {
          const msg = 'Selecione a forma de pagamento em todas as linhas.'
          setFormTab('financeiro')
          setPagamentoValidacaoErro(msg)
          showNotification(msg, 'error')
          return
        }
        if (valorLinhaPagamento(p) <= 0) {
          const msg = 'Informe o valor de cada forma de pagamento.'
          setFormTab('financeiro')
          setPagamentoValidacaoErro(msg)
          showNotification(msg, 'error')
          return
        }
        if (p.forma_pagamento === 'financiamento' && !p.instituicao_financiadora) {
          const msg = 'Selecione a instituição financiadora.'
          setFormTab('financeiro')
          setPagamentoValidacaoErro(msg)
          showNotification(msg, 'error')
          return
        }
        if (p.forma_pagamento === 'financiamento' && p.financiamento_terceiro && !p.documento_titular_url && !p.documento_titular_file) {
          const msg = 'Anexe o documento com foto (CNH ou RG) do titular do financiamento.'
          setFormTab('financeiro')
          setPagamentoValidacaoErro(msg)
          showNotification(msg, 'error')
          return
        }
      }

      if (Math.abs(valorTotalProjeto - totalPagamentos) > 0.01) {
        const somaFormatada = totalPagamentos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        const totalFormatado = valorTotalProjeto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        const msg = `A soma das formas de pagamento (${somaFormatada}) deve ser exatamente igual ao Valor Total do Projeto (${totalFormatado}).`
        setFormTab('financeiro')
        setPagamentoValidacaoErro(msg)
        showNotification(msg, 'error')
        return
      }

      setPagamentoValidacaoErro('')
    }

    // Validações específicas do modo resumido
    if (modoCadastro === 'resumido') {
      if (!formData.telefone.trim()) {
        setFormTab('pessoais')
        showNotification('Telefone é obrigatório no modo resumido.', 'error')
        return
      }
    }

    try {
      setLoading(true)

      // Função auxiliar para garantir que strings vazias em campos UUID sejam null
      const sanitizeUUID = (value) => {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          return null
        }
        // Se for um UUID válido, retornar; caso contrário, null
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
        if (typeof value === 'string' && !uuidRegex.test(value)) {
          return null
        }
        return value
      }

      // Determinar id_proposta: se estiver editando, manter o original; se criando novo, usar dadosIniciais
      let idProposta = null
      if (editingCliente) {
        // Ao editar, preservar o id_proposta original do cliente
        idProposta = sanitizeUUID(editingCliente.id_proposta)
      } else {
        // Ao criar novo, usar id_proposta dos dados iniciais (se vier via esteira)
        idProposta = sanitizeUUID(dadosIniciais?.proposta_id)
      }

      // Preparar dados para salvar
      const dataToSave = {
        nome_completo: formData.nome_completo,
        telefone: formData.telefone || null,
        cep: (formData.cep || '').replace(/\D/g, '') || null,
        logradouro: formData.logradouro || null,
        numero: formData.numero || null,
        complemento: formData.complemento || null,
        bairro: formData.bairro || null,
        cidade: formData.cidade || null,
        estado: formData.estado || null,
        link_localizacao: formData.link_localizacao || null,
        foto_fachada: formData.foto_fachada || null,
        fatura_terceiro: !!formData.fatura_terceiro,
        documento_titular_fatura_url: formData.fatura_terceiro ? (formData.documento_titular_fatura_url || null) : null,
        empresa_id: userEmpresa?.id || userEmpresa || null, // Incluir empresa_id do usuário logado
        ...(modoCadastro === 'venda' ? (() => {
          const valorTotalProjeto = parseCurrencyBR(formData.valor_total)
          const temFinanciamento = pagamentosList.some((p) => (
            p.forma_pagamento === 'financiamento' || p.forma_pagamento === 'aprazo' || p.forma_pagamento === 'cartao'
          ))
          const tipoPagamento = temFinanciamento || pagamentosList.length > 1 ? 'financiado' : 'avista'
          return {
            cpf: formData.cpf || null,
            rg: formData.rg || null,
            data_nascimento: formData.data_nascimento || null,
            email: formData.email || null,
            tipo_pagamento: tipoPagamento,
            valor_total: valorTotalProjeto,
            valor_entrada: null,
            valor_financiado: null,
            quantidade_parcelas: null,
            valor_parcela: null,
            data_compra: new Date().toISOString().split('T')[0],
            observacoes: formData.observacoes || null,
            majoracao: formData.majoracao ? parseCurrencyBR(formData.majoracao) : null,
            indicacao: formData.indicacao,
            cpf_indicador: formData.indicacao ? (formData.cpf_indicador || null) : null,
            nome_indicador: null,
            // Ao editar/atualizar um cliente existente, preservar o valor atual de venda_hangsix.
            // Ao criar no modo venda, marcar como venda HangSix.
            venda_hangsix: editingCliente ? !!editingCliente.venda_hangsix : true
          }
        })() : {
          cpf: (formData.cpf && String(formData.cpf).replace(/\D/g, '').length === 11)
            ? String(formData.cpf).replace(/\D/g, '')
            : `TEMP${Date.now().toString().slice(-8)}${Math.floor(Math.random() * 100).toString().padStart(2, '0')}`.slice(0, 11),
          rg: formData.rg || null,
          data_nascimento: formData.data_nascimento || null,
          email: formData.email || null,
          tipo_pagamento: 'avista',
          valor_total: 0,
          ativo: true
        }),
        id_proposta: idProposta, // UUID sanitizado (null se vazio)
        ativo: modoCadastro === 'venda' ? true : true // Sempre ativo ao criar/atualizar
      }

      // Ao criar: definir id_responsavel para o usuário logado (Especialista vê clientes cadastrados direto por ele)
      if (!editingCliente && userId) {
        dataToSave.id_responsavel = userId
      }
      // Ao editar: não enviar id_responsavel para preservar o valor já gravado

      // Garantir que empresa_id está presente e válido
      if (!dataToSave.empresa_id) {
        const empresaId = userEmpresa?.id || userEmpresa
        if (empresaId) {
          dataToSave.empresa_id = empresaId
        } else {
          console.error('⚠️ Empresa do usuário não encontrada!')
          showNotification('Erro: Empresa do usuário não identificada. Não é possível cadastrar o cliente.', 'error')
          return
        }
      }
      
      // Lista de campos UUID conhecidos na tabela clientes_cadastro
      const uuidFields = ['id_proposta', 'empresa_id', 'id', 'id_responsavel']
      
      Object.keys(dataToSave).forEach(key => {
        const value = dataToSave[key]
        const isUrlField = /url/i.test(key)
        const isUUIDField = !isUrlField && (
          uuidFields.includes(key) ||
          /^id_/.test(key) ||
          /_id$/.test(key) ||
          key.includes('uuid')
        )
        
        if (isUUIDField) {
          // NÃO remover empresa_id se for válido
          if (key === 'empresa_id' && value) {
            // Validar se é UUID válido, mas não remover
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
            if (typeof value === 'string' && !uuidRegex.test(value)) {
              console.warn(`⚠️ empresa_id inválido: "${value}"`)
            }
            return // Preservar empresa_id
          }
          
          // Se for string vazia, converter para null
          if (typeof value === 'string' && value.trim() === '') {
            console.warn(`⚠️ Campo UUID vazio detectado e convertido para null: ${key}`)
            dataToSave[key] = null
          }
          // Se for string mas não for UUID válido, converter para null
          else if (typeof value === 'string' && value.trim() !== '') {
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
            if (!uuidRegex.test(value)) {
              console.warn(`⚠️ Campo UUID inválido detectado e convertido para null: ${key} = "${value}"`)
              dataToSave[key] = null
            }
          }
        }
      })
      
      // Remover o campo 'id' se existir (não deve ser enviado no insert/update)
      if (dataToSave.id !== undefined) {
        delete dataToSave.id
      }

      // Log para debug (remover em produção se necessário)
      console.log('📤 Dados a serem salvos:', JSON.stringify(dataToSave, null, 2))

      let clienteId = null

      if (editingCliente) {
        // Atualizar
        const { error } = await supabase
          .from('clientes_cadastro')
          .update(dataToSave)
          .eq('id', editingCliente.id)

        if (error) throw error
        clienteId = editingCliente.id
        showNotification('Cliente atualizado com sucesso!', 'success')
      } else {
        // Criar
        const { data: newCliente, error } = await supabase
          .from('clientes_cadastro')
          .insert([dataToSave])
          .select()
          .single()

        if (error) throw error
        clienteId = newCliente.id

        // Se há uma foto da fachada que foi enviada antes do cliente ser criado, fazer upload novamente com o ID correto
        if (fotoFachadaFile?.file && fotoFachadaFile?.url && fotoFachadaFile.url.includes('/temp_')) {
          try {
            const fileExt = fotoFachadaFile.file.name.split('.').pop()
            const timestamp = Date.now()
            const fileName = `${clienteId}/fachada_${timestamp}.${fileExt}`

            // Upload do arquivo para o Supabase Storage com o ID correto do cliente
            const { data: uploadData, error: uploadError } = await supabase.storage
              .from('Fachadas')
              .upload(fileName, fotoFachadaFile.file, {
                cacheControl: '3600',
                upsert: false
              })

            if (!uploadError) {
              // Obter URL pública do arquivo
              const { data: { publicUrl } } = supabase.storage
                .from('Fachadas')
                .getPublicUrl(fileName)

              // Atualizar o cliente com a URL correta
              await supabase
                .from('clientes_cadastro')
                .update({ foto_fachada: publicUrl })
                .eq('id', clienteId)

              // Atualizar o formData com a URL correta
              setFormData(prev => ({
                ...prev,
                foto_fachada: publicUrl
              }))
            }
          } catch (error) {
            console.error('Erro ao fazer reupload da foto com ID correto:', error)
            // Não interromper o fluxo, apenas logar o erro
          }
        }

        // NÃO atualizar o status da proposta aqui
        // Será atualizado apenas quando o usuário confirmar no modal de sucesso
      }

      if (clienteId && formData.fatura_terceiro && documentoTitularFaturaFile) {
        try {
          const url = await uploadDocumentoTitular(documentoTitularFaturaFile, clienteId, 'fatura_titular')
          const { error: faturaDocError } = await supabase
            .from('clientes_cadastro')
            .update({ documento_titular_fatura_url: url, fatura_terceiro: true })
            .eq('id', clienteId)
          if (faturaDocError) throw faturaDocError
          setFormData((prev) => ({ ...prev, documento_titular_fatura_url: url }))
          setDocumentoTitularFaturaFile(null)
        } catch (e) {
          console.error('Erro ao anexar documento do titular da fatura:', e)
          showNotification(
            `Cliente salvo, mas houve erro ao anexar o documento da fatura${e?.message ? `: ${e.message}` : '.'}`,
            'error'
          )
        }
      }

      // Criar processo de homologação automaticamente quando venda_hangsix = true
      if (dataToSave.venda_hangsix === true && clienteId) {
        try {
          const { data: existente } = await supabase.from('homologacao').select('id').eq('cliente_id', clienteId).maybeSingle()
          if (!existente) {
            const empresaId = dataToSave.empresa_id || userEmpresa?.id || userEmpresa || null
            await supabase.from('homologacao').insert([{ cliente_id: clienteId, empresa_id: empresaId }])
          }
        } catch (e) {
          console.error('Erro ao criar processo de homologação:', e)
        }
      }

      // Salvar formas de pagamento (clientes_pagamentos) no modo venda
      if (clienteId && modoCadastro === 'venda') {
        try {
          await supabase.from('clientes_pagamentos').delete().eq('cliente_id', clienteId)
          if (pagamentosList.length > 0) {
            const rows = []
            for (const p of pagamentosList) {
              let documentoUrl = p.documento_titular_url || null
              if (p.forma_pagamento === 'financiamento' && p.financiamento_terceiro && p.documento_titular_file) {
                documentoUrl = await uploadDocumentoTitular(p.documento_titular_file, clienteId)
              }
              if (p.forma_pagamento !== 'financiamento' || !p.financiamento_terceiro) {
                documentoUrl = null
              }
              rows.push({
                cliente_id: clienteId,
                forma_pagamento: p.forma_pagamento,
                valor: valorLinhaPagamento(p) || 0,
                data_vencimento: null,
                instituicao_financiadora: p.forma_pagamento === 'financiamento' ? (p.instituicao_financiadora || null) : null,
                financiamento_terceiro: p.forma_pagamento === 'financiamento' ? !!p.financiamento_terceiro : false,
                documento_titular_url: documentoUrl
              })
            }
            const { error: errPag } = await supabase.from('clientes_pagamentos').insert(rows)
            if (errPag) throw errPag

            // Registrar na movimentação (Financeiro) com tipo de entrada "Venda" — apenas ao criar novo cliente
            if (!editingCliente && userId) {
              const { data: tipoVenda, error: errTipo } = await supabase
                .from('tipo_entrada_saida')
                .select('id')
                .eq('nome', 'Venda')
                .maybeSingle()
              if (!errTipo && tipoVenda?.id) {
                const movRows = rows.map((p) => ({
                  id_responsavel: userId,
                  id_tipo_entrada_saida: tipoVenda.id,
                  quantidade: 1,
                  valor_unitario: p.valor,
                  total: p.valor,
                  data_cadastro: new Date().toISOString().split('T')[0],
                  status: 0,
                  pago: false
                }))
                const { error: errMov } = await supabase.from('movimentacao').insert(movRows)
                if (errMov) console.error('Erro ao registrar movimentação (Venda):', errMov)
              }
            }
          }
        } catch (e) {
          console.error('Erro ao salvar formas de pagamento:', e)
          showNotification(`Cliente salvo, mas houve erro ao gravar formas de pagamento: ${e.message || e}`, 'error')
        }
      }

      // Salvar Kit Solar se houver dados preenchidos (cadastro completo ou resumido)
      const hasKitSolarData = (kitSolarData.inversores || []).some(linhaKitTemDado) || (kitSolarData.modulos || []).some(linhaKitTemDado)

      if (hasKitSolarData) {
        try {
          const kitData = {
            id_empresa: userEmpresa?.id || userEmpresa,
            ...montarPayloadKitSolar(kitSolarData)
          }

          // Verificar se já existe registro do Kit Solar para este cliente
          const { data: existingKit, error: checkError } = await supabase
            .from('kit_solar_cliente')
            .select('id')
            .eq('id_cliente', clienteId)
            .single()

          if (checkError && checkError.code !== 'PGRST116') {
            console.error('Erro ao verificar Kit Solar existente:', checkError)
            showNotification('Erro ao verificar Kit Solar existente: ' + checkError.message, 'error')
          } else if (existingKit) {
            // Atualizar Kit Solar existente
            kitData.updated_by = userId
            const { error: updateError } = await supabase
              .from('kit_solar_cliente')
              .update(kitData)
              .eq('id_cliente', clienteId)

            if (updateError) {
              console.error('Erro ao atualizar Kit Solar:', updateError)
              showNotification('Erro ao atualizar Kit Solar: ' + updateError.message, 'error')
            }
          } else {
            // Criar novo Kit Solar
            const { error: insertError } = await supabase
              .from('kit_solar_cliente')
              .insert([{
                id_cliente: clienteId,
                ...kitData,
                created_by: userId,
                updated_by: userId // Também definir updated_by para o trigger funcionar
              }])

            if (insertError) {
              console.error('Erro ao criar Kit Solar:', insertError)
              showNotification('Erro ao criar Kit Solar: ' + insertError.message, 'error')
            }
          }
        } catch (error) {
          console.error('Erro ao salvar Kit Solar:', error)
          showNotification('Erro ao salvar Kit Solar: ' + error.message, 'error')
        }
      }


      // Resetar formulário e recarregar lista
      const formReset = { ...formData }
      resetForm()
      await loadClientes()

      // Mostrar modal de sucesso com opções
      // Guardar proposta_id para atualizar depois da confirmação
      setSuccessModal({
        show: true,
        clienteId: clienteId,
        viaEsteira: !!dadosIniciais?.proposta_id,
        propostaId: dadosIniciais?.proposta_id || null
      })
    } catch (error) {
      console.error('Erro ao salvar cliente:', error)
      if (error.code === '23505') {
        showNotification('CPF já cadastrado no sistema.', 'error')
      } else {
        showNotification('Erro ao salvar cliente: ' + error.message, 'error')
      }
    } finally {
      setLoading(false)
    }
  }

  const resetForm = () => {
    setFormData({
      nome_completo: '',
      cpf: '',
      rg: '',
      data_nascimento: '',
      telefone: '',
      email: '',
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      link_localizacao: '',
      foto_fachada: '',
      tipo_pagamento: 'avista',
      valor_total: '',
      valor_entrada: '',
      valor_financiado: '',
      quantidade_parcelas: '',
      valor_parcela: '',
      data_compra: new Date().toISOString().split('T')[0],
      observacoes: '',
      
      majoracao: '',
      indicacao: false,
      cpf_indicador: '',
      nome_indicador: '',
      ativo: true,
      venda_hangsix: false,
      fatura_terceiro: false,
      documento_titular_fatura_url: ''
    })
    setModoCadastro(permitirVendaEmpresa ? 'venda' : 'resumido')
    setFormTab('pessoais')
    setEditingCliente(null)
    setFormAbertoManualmente(false)
    setShowForm(false)
    // Resetar dados do kit solar
    setKitSolarData(kitSolarVazio())
    // Resetar foto da fachada
    setFotoFachadaFile(null)
    setDocumentoTitularFaturaFile(null)
    // Resetar formas de pagamento
    setPagamentosList([novaLinhaPagamento()])
    setPagamentoValidacaoErro('')
    
    // NÃO chamar onBack se veio via esteira - permanecer na tela de Gestão de Clientes
    // O usuário escolhe manualmente no modal de sucesso
  }

  const handleEdit = (cliente) => {
    applyEditWithMode(cliente, 'venda')
  }

  const applyEditWithMode = (cliente, modo) => {
    const formatValueToBR = (value) => {
      if (!value) return ''
      return parseFloat(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }

    setModoCadastro(modo)
    setFormData({
      nome_completo: cliente.nome_completo || '',
      cpf: cliente.cpf || '',
      rg: cliente.rg || '',
      data_nascimento: cliente.data_nascimento || '',
      telefone: cliente.telefone || '',
      email: cliente.email || '',
      cep: (cliente.cep || '').replace(/\D/g, ''),
      logradouro: cliente.logradouro || '',
      numero: cliente.numero || '',
      complemento: cliente.complemento || '',
      bairro: cliente.bairro || '',
      cidade: cliente.cidade || '',
      estado: cliente.estado || '',
      link_localizacao: cliente.link_localizacao || '',
      foto_fachada: cliente.foto_fachada || '',
      tipo_pagamento: cliente.tipo_pagamento || 'avista',
      valor_total: formatValueToBR(cliente.valor_total),
      valor_entrada: formatValueToBR(cliente.valor_entrada),
      valor_financiado: formatValueToBR(cliente.valor_financiado),
      quantidade_parcelas: cliente.quantidade_parcelas || '',
      valor_parcela: formatValueToBR(cliente.valor_parcela),
      data_compra: cliente.data_compra || '',
      observacoes: cliente.observacoes || '',
      
      majoracao: formatValueToBR(cliente.majoracao),
      indicacao: cliente.indicacao || false,
      cpf_indicador: cliente.cpf_indicador || '',
      nome_indicador: cliente.nome_indicador || '',
      ativo: cliente.ativo !== false,
      venda_hangsix: !!cliente.venda_hangsix,
      fatura_terceiro: !!cliente.fatura_terceiro,
      documento_titular_fatura_url: cliente.documento_titular_fatura_url || ''
    })
    setEditingCliente(cliente)
    setFormAbertoManualmente(false)
    setFormTab('pessoais')
    setShowForm(true)
    setDocumentoTitularFaturaFile(null)
    // Carregar formas de pagamento do cliente ao editar
    if (modo === 'venda' && cliente?.id) {
      supabase
        .from('clientes_pagamentos')
        .select('id, forma_pagamento, valor, instituicao_financiadora, financiamento_terceiro, documento_titular_url')
        .eq('cliente_id', cliente.id)
        .order('created_at', { ascending: true })
        .then(({ data, error }) => {
          const aplicar = (rows) => {
            if (rows && rows.length > 0) {
              setPagamentosList(rows.map((p) => ({
                ...novaLinhaPagamento(),
                id: p.id,
                forma_pagamento: mapearFormaPagamentoLegado(p.forma_pagamento),
                valor: Number(p.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                instituicao_financiadora: mapearInstituicaoSalva(p.instituicao_financiadora),
                financiamento_terceiro: !!p.financiamento_terceiro,
                documento_titular_url: p.documento_titular_url || '',
                documento_titular_nome: p.documento_titular_url ? 'Documento anexado' : ''
              })))
            } else {
              setPagamentosList([novaLinhaPagamento()])
            }
            setPagamentoValidacaoErro('')
          }

          if (error) {
            supabase
              .from('clientes_pagamentos')
              .select('id, forma_pagamento, valor, data_vencimento')
              .eq('cliente_id', cliente.id)
              .order('created_at', { ascending: true })
              .then(({ data: legado }) => aplicar(legado || []))
            return
          }
          aplicar(data)
        })
    } else {
      setPagamentosList([novaLinhaPagamento()])
    }

    if (cliente?.id) {
      supabase
        .from('kit_solar_cliente')
        .select('marca_inversor, modelo_inversor, potencia_inversor, quantidade_inversor, marca_modulo, modelo_modulo, potencia_modulo, quantidade_modulo, inversores, modulos')
        .eq('id_cliente', cliente.id)
        .maybeSingle()
        .then(({ data, error }) => {
          if (error || !data) {
            setKitSolarData(mapearKitSolarForm(cliente))
            return
          }
          setKitSolarData(mapearKitSolarForm(data))
        })
    } else {
      setKitSolarData(kitSolarVazio())
    }
  }

  // Função para abrir modal de detalhes do cliente
  const openClienteModal = (cliente) => {
    setClienteModalData(cliente)
    setShowClienteModal(true)
  }

  // Função para fechar modal de detalhes do cliente
  const closeClienteModal = () => {
    setShowClienteModal(false)
    setClienteModalData(null)
  }

  const handleDelete = async (clienteId) => {
    setConfirmModal({
      show: true,
      title: 'Excluir Cliente',
      message: 'Tem certeza que deseja excluir este cliente? Esta ação não pode ser desfeita.',
      type: 'danger',
      onConfirm: async () => {
        setConfirmModal({ show: false, title: '', message: '', onConfirm: null })

    try {
      setLoading(true)
      const { error } = await supabase
            .from('clientes_cadastro')
        .delete()
        .eq('id', clienteId)

      if (error) throw error
      showNotification('Cliente excluído com sucesso!', 'success')
      loadClientes()
    } catch (error) {
      console.error('Erro ao excluir cliente:', error)
      showNotification('Erro ao excluir cliente: ' + error.message, 'error')
    } finally {
      setLoading(false)
    }
      }
    })
  }

  const handleKitSolar = async (cliente) => {
    try {
      // Buscar dados do Kit Solar do cliente
      const { data: kitData, error } = await supabase
        .from('kit_solar_cliente')
        .select('*')
        .eq('id_cliente', cliente.id)
        .single()

      if (error && error.code !== 'PGRST116') {
        console.error('Erro ao buscar Kit Solar:', error)
        showNotification('Erro ao carregar Kit Solar: ' + error.message, 'error')
        return
      }

      // Preparar dados para o modal
      setKitSolarData(mapearKitSolarForm(kitData || {}))

      setCurrentClienteForKit(cliente)
      setShowKitSolarModal(true)
    } catch (error) {
      console.error('Erro ao abrir Kit Solar:', error)
      showNotification('Erro ao abrir Kit Solar: ' + error.message, 'error')
    }
  }

  const abrirProjetoPdf = async (cliente) => {
    projetoPdfClienteRef.current = cliente.id
    setClienteParaProjetoDxf(cliente)
    setProjetoDxfForm(aplicarMemoriaFormularioUnifilar(formularioInicialUnifilar(cliente)))
    setShowProjetoDxfModal(true)
    try {
      const { data, error } = await supabase
        .from('kit_solar_cliente')
        .select('marca_inversor, modelo_inversor, potencia_inversor, quantidade_inversor, marca_modulo, modelo_modulo, potencia_modulo, quantidade_modulo, inversores, modulos')
        .eq('id_cliente', cliente.id)
        .maybeSingle()
      if (projetoPdfClienteRef.current !== cliente.id) return
      if (error && error.code !== 'PGRST116') {
        console.warn('Unifilar: não foi possível carregar o kit.', error.message)
        return
      }
      if (!data) return
      const kit = mapearKitSolarForm(data)
      setProjetoDxfForm((prev) => (
        prev._clienteId === cliente.id
          ? preservarCamposSalvosUnifilar(preencherComKit(prev, kit), prev)
          : prev
      ))
    } catch (error) {
      console.warn('Unifilar: falha ao ler o kit.', error?.message)
    }
  }

  const atualizarCampoProjeto = (campo, valor) => {
    setProjetoDxfForm((prev) => {
      const next = aplicarCampoUnifilar(prev, campo, valor)
      salvarMemoriaFormularioUnifilar(next)
      return next
    })
  }

  const atualizarInversorProjeto = (index, campo, valor) => {
    setProjetoDxfForm((prev) => {
      const next = atualizarInversorUnifilar(prev, index, campo, valor)
      salvarMemoriaFormularioUnifilar(next)
      return next
    })
  }

  const gerarProjetoPdf = () => {
    if (!String(projetoDxfForm.cliente || '').trim()) {
      showNotification('Informe o nome do cliente para gerar o projeto.', 'error')
      return
    }
    setGerandoProjetoDxf(true)
    try {
      salvarMemoriaFormularioUnifilar(projetoDxfForm)
      baixarPdfUnifilar({
        ...projetoDxfForm,
        empresa: userEmpresa?.nome || userEmpresa?.empresa || userEmpresa?.razao_social || ''
      })
      setShowProjetoDxfModal(false)
      setClienteParaProjetoDxf(null)
      showNotification('Unifilar e diagrama de blocos gerados. Os dois PDFs foram baixados.', 'success')
    } catch (err) {
      console.error('Erro ao gerar unifilar:', err)
      showNotification(err.message || 'Erro ao gerar o diagrama unifilar.', 'error')
    } finally {
      setGerandoProjetoDxf(false)
    }
  }

  const atualizarLinhaKit = (campo, idx, patch) => {
    setKitSolarData((prev) => ({
      ...prev,
      [campo]: (prev[campo] || []).map((linha, i) => (i === idx ? { ...linha, ...patch } : linha))
    }))
  }

  const adicionarLinhaKit = (campo) => {
    setKitSolarData((prev) => ({
      ...prev,
      [campo]: [...(prev[campo] || []), novaLinhaKit()]
    }))
  }

  const removerLinhaKit = (campo, idx) => {
    setKitSolarData((prev) => {
      const lista = (prev[campo] || []).filter((_, i) => i !== idx)
      return { ...prev, [campo]: lista.length ? lista : [novaLinhaKit()] }
    })
  }

  const aplicarModeloNaLista = (campo, item) => {
    setKitSolarData((prev) => {
      const lista = [...(prev[campo] || [])]
      let idx = lista.findIndex((linha) => !linhaKitTemDado(linha))
      if (idx < 0) {
        lista.push(novaLinhaKit())
        idx = lista.length - 1
      }
      lista[idx] = {
        ...lista[idx],
        marca: item.marca || '',
        modelo: item.modelo || '',
        potencia: item.potencia != null && item.potencia !== '' ? item.potencia : lista[idx].potencia,
        daLista: true
      }
      return { ...prev, [campo]: lista }
    })
  }

  const abrirCadastroKitModelo = (tipo = 'inversor', prefill = {}) => {
    setCadastroKitModelo({
      aberto: true,
      tipo,
      marca: prefill.marca || '',
      modelo: prefill.modelo || '',
      potencia: prefill.potencia || '',
      salvando: false
    })
  }

  const fecharCadastroKitModelo = () => {
    setCadastroKitModelo({
      aberto: false,
      tipo: 'inversor',
      marca: '',
      modelo: '',
      potencia: '',
      salvando: false
    })
  }

  const salvarCadastroKitModelo = async () => {
    const marca = (cadastroKitModelo.marca || '').trim()
    const modelo = (cadastroKitModelo.modelo || '').trim()
    if (!marca || !modelo) {
      showNotification('Informe marca e modelo.', 'error')
      return
    }
    setCadastroKitModelo((prev) => ({ ...prev, salvando: true }))
    const potencia = cadastroKitModelo.potencia === ''
      ? null
      : parseFloat(String(cadastroKitModelo.potencia).replace(',', '.'))
    const potenciaOk = Number.isNaN(potencia) ? null : potencia
    const campo = cadastroKitModelo.tipo === 'modulo' ? 'modulos' : 'inversores'
    const tabela = cadastroKitModelo.tipo === 'modulo' ? 'modulos' : 'inversores'
    try {
      const { data, error } = await supabase
        .from(tabela)
        .insert([{ marca, modelo, potencia: potenciaOk }])
        .select('id, marca, modelo, potencia')
        .single()
      if (error) throw error
      await carregarCatalogoKitSolar()
      aplicarModeloNaLista(campo, data)
      fecharCadastroKitModelo()
      showNotification(`${cadastroKitModelo.tipo === 'modulo' ? 'Módulo' : 'Inversor'} cadastrado.`, 'success')
    } catch (err) {
      if (err.code === '23505') {
        showNotification('Já existe um cadastro com esta marca e modelo.', 'error')
        setCadastroKitModelo((prev) => ({ ...prev, salvando: false }))
        return
      }
      aplicarModeloNaLista(campo, { marca, modelo, potencia: potenciaOk })
      fecharCadastroKitModelo()
      showNotification(
        `${cadastroKitModelo.tipo === 'modulo' ? 'Módulo' : 'Inversor'} incluído no kit. O catálogo geral não pôde ser atualizado.`,
        'warning'
      )
    }
  }

  const formularioCadastroKitModelo = cadastroKitModelo.aberto && podeCadastrarKitModelo && (
    <div className="cliente-cadastro-novo-kit-modelo">
      <div className="cliente-cadastro-kit-modelo-tipos">
        <button
          type="button"
          className={`cliente-cadastro-kit-modelo-tipo${cadastroKitModelo.tipo === 'inversor' ? ' is-active' : ''}`}
          onClick={() => setCadastroKitModelo((prev) => ({ ...prev, tipo: 'inversor' }))}
        >
          Inversor
        </button>
        <button
          type="button"
          className={`cliente-cadastro-kit-modelo-tipo${cadastroKitModelo.tipo === 'modulo' ? ' is-active' : ''}`}
          onClick={() => setCadastroKitModelo((prev) => ({ ...prev, tipo: 'modulo' }))}
        >
          Módulo
        </button>
      </div>
      <div className="cliente-cadastro-nova-instituicao">
        <input
          type="text"
          className="form-control"
          placeholder="Marca"
          value={cadastroKitModelo.marca}
          maxLength={150}
          autoFocus
          onChange={(e) => setCadastroKitModelo((prev) => ({ ...prev, marca: e.target.value }))}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Modelo"
          value={cadastroKitModelo.modelo}
          maxLength={150}
          onChange={(e) => setCadastroKitModelo((prev) => ({ ...prev, modelo: e.target.value }))}
        />
        <input
          type="number"
          className="form-control"
          placeholder={cadastroKitModelo.tipo === 'modulo' ? 'Potência (W)' : 'Potência (kW)'}
          step="0.01"
          min="0"
          value={cadastroKitModelo.potencia}
          onChange={(e) => setCadastroKitModelo((prev) => ({ ...prev, potencia: e.target.value }))}
        />
        <button
          type="button"
          className="cliente-cadastro-btn-salvar-instituicao"
          disabled={cadastroKitModelo.salvando}
          onClick={salvarCadastroKitModelo}
        >
          {cadastroKitModelo.salvando ? 'Salvando...' : 'Salvar'}
        </button>
        <button
          type="button"
          className="cliente-cadastro-btn-cancelar-instituicao"
          disabled={cadastroKitModelo.salvando}
          onClick={fecharCadastroKitModelo}
        >
          Cancelar
        </button>
      </div>
    </div>
  )

  const renderBlocoKit = (campo, { titulo, itemLabel, unidade, catalogo, labelMarca, placeholder, labelModelo, labelPotencia, labelQuantidade, botaoAdicionar, idPrefix = '' }) => (
    <div className="kit-solar-bloco">
      <h5 className="kit-solar-bloco-titulo">{titulo}</h5>
      {(kitSolarData[campo] || []).map((linha, idx) => (
        <div className="kit-solar-linha" key={linha.key}>
          <div className="kit-solar-linha-topo">
            <span>{itemLabel} {idx + 1}</span>
            {(kitSolarData[campo] || []).length > 1 && (
              <button
                type="button"
                className="kit-solar-linha-remover"
                onClick={() => removerLinhaKit(campo, idx)}
              >
                Remover
              </button>
            )}
          </div>
          <KitModeloBusca
            label={labelMarca}
            inputId={`${idPrefix}${campo}_marca_${idx}`}
            value={linha.marca}
            itens={catalogo}
            unidadePotencia={unidade}
            placeholder={placeholder}
            buscarRemoto={campo === 'inversores' ? buscarInversoresSolarStack : buscarModulosSolarStack}
            nomeItem={itemLabel.toLowerCase()}
            podeCadastrar={podeCadastrarKitModelo}
            onCadastrar={(termo) => abrirCadastroKitModelo(campo === 'modulos' ? 'modulo' : 'inversor', { marca: termo })}
            onSelect={(item) => {
              atualizarLinhaKit(campo, idx, {
                marca: item.marca || '',
                modelo: item.modelo || '',
                potencia: item.potencia != null && item.potencia !== '' ? item.potencia : linha.potencia,
                daLista: true
              })
              gravarModeloKitLocal(campo, item)
            }}
          />
          <div className="row g-3 mt-1">
            <div className="col-md-4">
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  id={`${idPrefix}${campo}_modelo_${idx}`}
                  placeholder=" "
                  value={linha.modelo}
                  readOnly
                  title="Selecione o modelo na lista de pesquisa"
                />
                <label htmlFor={`${idPrefix}${campo}_modelo_${idx}`}>{labelModelo}</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-floating">
                <input
                  type="number"
                  className="form-control"
                  id={`${idPrefix}${campo}_potencia_${idx}`}
                  placeholder=" "
                  step="0.01"
                  min="0"
                  value={linha.potencia}
                  readOnly
                  title="A potência vem do modelo selecionado"
                />
                <label htmlFor={`${idPrefix}${campo}_potencia_${idx}`}>{labelPotencia}</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-floating">
                <input
                  type="number"
                  className="form-control"
                  id={`${idPrefix}${campo}_quantidade_${idx}`}
                  placeholder=" "
                  min="1"
                  value={linha.quantidade}
                  onChange={(e) => atualizarLinhaKit(campo, idx, { quantidade: e.target.value })}
                />
                <label htmlFor={`${idPrefix}${campo}_quantidade_${idx}`}>{labelQuantidade}</label>
              </div>
            </div>
          </div>
        </div>
      ))}
      <button
        type="button"
        className="cliente-cadastro-btn-add-pagamento"
        onClick={() => adicionarLinhaKit(campo)}
      >
        <i className="bi bi-plus-lg" /> {botaoAdicionar}
      </button>
    </div>
  )

  const handleSaveKitSolar = async () => {
    try {
      setLoading(true)

      const kitData = {
        id_empresa: userEmpresa?.id || userEmpresa,
        ...montarPayloadKitSolar(kitSolarData),
        updated_by: userId
      }

      // Verificar se já existe registro do Kit Solar para este cliente
      const { data: existingKit, error: checkError } = await supabase
        .from('kit_solar_cliente')
        .select('id')
        .eq('id_cliente', currentClienteForKit.id)
        .single()

      if (checkError && checkError.code !== 'PGRST116') {
        console.error('Erro ao verificar Kit Solar existente:', checkError)
        showNotification('Erro ao verificar Kit Solar: ' + checkError.message, 'error')
        return
      }

      if (existingKit) {
        // Atualizar Kit Solar existente
        const { error: updateError } = await supabase
          .from('kit_solar_cliente')
          .update(kitData)
          .eq('id_cliente', currentClienteForKit.id)

        if (updateError) {
          console.error('Erro ao atualizar Kit Solar:', updateError)
          showNotification('Erro ao atualizar Kit Solar: ' + updateError.message, 'error')
          return
        }
      } else {
        // Criar novo Kit Solar
        const { error: insertError } = await supabase
          .from('kit_solar_cliente')
          .insert([{
            id_cliente: currentClienteForKit.id,
            ...kitData,
            created_by: userId // Adicionar usuário criador
          }])

        if (insertError) {
          console.error('Erro ao criar Kit Solar:', insertError)
          showNotification('Erro ao criar Kit Solar: ' + insertError.message, 'error')
          return
        }
      }

      showNotification('Kit Solar salvo com sucesso!', 'success')
      setShowKitSolarModal(false)
      await loadClientes() // Recarregar lista para mostrar atualizações
    } catch (error) {
      console.error('Erro ao salvar Kit Solar:', error)
      showNotification('Erro ao salvar Kit Solar: ' + error.message, 'error')
    } finally {
      setLoading(false)
    }
  }

  const closeKitSolarModal = () => {
    setShowKitSolarModal(false)
    setCurrentClienteForKit(null)
    setKitSolarData(kitSolarVazio())
    fecharCadastroKitModelo()
  }

  // Função para formatar endereço completo
  const formatarEndereco = (cliente) => {
    const partes = []
    if (cliente.logradouro) partes.push(cliente.logradouro)
    if (cliente.numero) partes.push(`N° ${cliente.numero}`)
    if (cliente.complemento) partes.push(cliente.complemento)
    if (cliente.bairro) partes.push(`Bairro: ${cliente.bairro}`)
    if (cliente.cep) partes.push(`CEP: ${cliente.cep}`)
    if (cliente.cidade) partes.push(`Cidade: ${cliente.cidade}`)
    if (cliente.estado) partes.push(`${cliente.estado}`)
    
    return partes.length > 0 ? partes.join(', ') : 'Endereço não informado'
  }

  // Constrói o PDF da procuração (para download ou envio Clicksign). Retorna { pdf, nomeArquivo }.
  const buildProcuracaoOutorgadoTexto = (procurador) => {
    if (!procurador) {
      return `OUTORGADO: R DE S BARROS JUNIOR LTDA com sede legal na Travessa WE 29, N° 02, Bairro: Cidade nova IV, CEP: 67133-120, Cidade: Ananindeua/PA, inscrito no CNPJ no 44.376.302.0001-34 e WALLAFE SOUSA BARROS, portador do CPF N° 918.950.222-15 CFT, residente e domiciliado(a) na Rua Zumbi dos palmares número 131 Ananindeua-PA CEP: 67032031`
    }
    const cpfProc = procurador.cpf
      ? String(procurador.cpf).replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      : 'N/A'
    const partesEndereco = []
    if (procurador.endereco) partesEndereco.push(procurador.endereco)
    if (procurador.numero) partesEndereco.push(`N° ${procurador.numero}`)
    if (procurador.bairro) partesEndereco.push(`Bairro: ${procurador.bairro}`)
    if (procurador.cep) partesEndereco.push(`CEP: ${procurador.cep}`)
    if (procurador.cidade) partesEndereco.push(`Cidade: ${procurador.cidade}`)
    const endereco = partesEndereco.length > 0 ? partesEndereco.join(', ') : 'endereço não informado'
    return `OUTORGADO: ${procurador.nome_procurador}, portador(a) do CPF N° ${cpfProc}, residente e domiciliado(a) na ${endereco}.`
  }

  const buildProcuracaoPdf = (cliente, procurador = null) => {
    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const margin = 20
    let currentY = 30
    const primaryColor = [33, 37, 41]
    const textColor = [51, 51, 51]
    pdf.setFontSize(18)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...primaryColor)
    pdf.text('PROCURAÇÃO', pageWidth / 2, currentY, { align: 'center' })
    currentY += 20
    currentY += 10
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const nomeCliente = cliente.nome_completo || 'Nome não informado'
    const cpfCliente = cliente.cpf ? String(cliente.cpf).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : 'N/A'
    const enderecoCliente = formatarEndereco(cliente)
    const textoOutorgante = `OUTORGANTE: ${nomeCliente} portador(a) do CPF N° ${cpfCliente} RG N° ${cliente.rg || 'N/A'}, residente e domiciliado na ${enderecoCliente}`
    const linesOutorgante = pdf.splitTextToSize(textoOutorgante, pageWidth - (margin * 2))
    pdf.text(linesOutorgante, margin, currentY)
    currentY += linesOutorgante.length * 7
    currentY += 10
    const textoOutorgado = buildProcuracaoOutorgadoTexto(procurador)
    const linesOutorgado = pdf.splitTextToSize(textoOutorgado, pageWidth - (margin * 2))
    pdf.text(linesOutorgado, margin, currentY)
    currentY += linesOutorgado.length * 7
    currentY += 10
    pdf.setFont('helvetica', 'bold')
    pdf.text('PODERES:', margin, currentY)
    currentY += 7
    pdf.setFont('helvetica', 'normal')
    const textoPoderes = `Representar o Outorgante perante a Equatorial Energia, podendo para tanto requerer e assinar tudo que for necessário, apresentar, juntar e retirar documentos e multas, fazer declarações, assinar projeto elétrico, assinar contrato de fornecimento, fazer troca de titularidade, solicitar ligação nova, solicitar religação e ou qualquer serviço ligado a área comercial da Concessionária. A procuração tem validade de 1 (um) ano a contar da expedição da mesma.`
    const linesPoderes = pdf.splitTextToSize(textoPoderes, pageWidth - (margin * 2))
    pdf.text(linesPoderes, margin, currentY)
    currentY += linesPoderes.length * 7
    currentY += 20
    const dataAtual = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    pdf.text(`Ananindeua/PA, ${dataAtual}`, margin, currentY)
    currentY += 20
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.5)
    pdf.line(margin, currentY, pageWidth - margin, currentY)
    currentY += 5
    pdf.setFontSize(10)
    pdf.text('Assinatura do Outorgante', margin, currentY)
    const nomeArquivo = `Procuração_${nomeCliente.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`
    return { pdf, nomeArquivo }
  }

  const gerarProcuracaoPDF = (cliente, procurador = null) => {
    try {
      const { pdf, nomeArquivo } = buildProcuracaoPdf(cliente, procurador)
      pdf.save(nomeArquivo)
      showNotification('Procuração gerada com sucesso!', 'success')
      setShowDocumentosModal(false)
    } catch (error) {
      console.error('Erro ao gerar PDF da procuração:', error)
      showNotification('Erro ao gerar procuração: ' + error.message, 'error')
    }
  }

  const escapeHtmlProc = (s) => String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

  const fetchProcuradoresAtivos = async () => {
    const { data, error } = await supabase
      .from('procuradores')
      .select('*')
      .eq('ativo', true)
      .order('nome_procurador', { ascending: true })
    if (error) throw error
    return data || []
  }

  const cadastrarProcuradorSwal = async () => {
    const { value: formValues } = await Swal.fire({
      title: 'Novo procurador',
      width: 520,
      html: `
        <div style="text-align:left;">
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Nome completo *</label>
          <input id="proc-nome" class="swal2-input" placeholder="Nome do procurador" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">CPF</label>
          <input id="proc-cpf" class="swal2-input" placeholder="Somente números (11 dígitos)" maxlength="11" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">CEP</label>
          <div style="display:flex;gap:6px;margin:0 0 8px;">
            <input id="proc-cep" class="swal2-input" placeholder="00000-000" maxlength="9" style="margin:0;flex:1;box-sizing:border-box;">
            <button type="button" id="proc-buscar-cep" class="swal2-styled" style="margin:0;background:#0d6efd;white-space:nowrap;">🔍 Buscar</button>
          </div>
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Endereço</label>
          <input id="proc-endereco" class="swal2-input" placeholder="Logradouro" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
          <div style="display:flex;gap:6px;">
            <div style="flex:0 0 35%;">
              <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Número</label>
              <input id="proc-numero" class="swal2-input" placeholder="N°" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
            </div>
            <div style="flex:1;">
              <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Bairro</label>
              <input id="proc-bairro" class="swal2-input" placeholder="Bairro" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
            </div>
          </div>
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Cidade</label>
          <input id="proc-cidade" class="swal2-input" placeholder="Cidade/UF" style="margin:0;width:100%;box-sizing:border-box;">
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd',
      didOpen: () => {
        const btn = document.getElementById('proc-buscar-cep')
        if (btn) {
          btn.addEventListener('click', async () => {
            const cep = (document.getElementById('proc-cep').value || '').replace(/\D/g, '')
            if (cep.length !== 8) {
              Swal.showValidationMessage('CEP inválido. Digite 8 dígitos.')
              return
            }
            Swal.resetValidationMessage()
            btn.textContent = '🔄'
            try {
              const resp = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
              const data = await resp.json()
              if (data.erro) {
                Swal.showValidationMessage('CEP não encontrado.')
                return
              }
              if (data.logradouro) document.getElementById('proc-endereco').value = data.logradouro
              if (data.bairro) document.getElementById('proc-bairro').value = data.bairro
              const cidadeUf = data.localidade && data.uf ? `${data.localidade}/${data.uf}` : (data.localidade || '')
              if (cidadeUf) document.getElementById('proc-cidade').value = cidadeUf
            } catch (e) {
              Swal.showValidationMessage('Erro ao buscar CEP.')
            } finally {
              btn.textContent = '🔍 Buscar'
            }
          })
        }
      },
      preConfirm: () => {
        const nome = (document.getElementById('proc-nome').value || '').trim()
        if (!nome) {
          Swal.showValidationMessage('Informe o nome do procurador.')
          return false
        }
        return {
          nome_procurador: nome,
          cpf: (document.getElementById('proc-cpf').value || '').replace(/\D/g, '') || null,
          cep: (document.getElementById('proc-cep').value || '').trim() || null,
          endereco: (document.getElementById('proc-endereco').value || '').trim() || null,
          numero: (document.getElementById('proc-numero').value || '').trim() || null,
          bairro: (document.getElementById('proc-bairro').value || '').trim() || null,
          cidade: (document.getElementById('proc-cidade').value || '').trim() || null
        }
      }
    })

    if (!formValues) return null

    try {
      const { data, error } = await supabase
        .from('procuradores')
        .insert({ ...formValues, ativo: true })
        .select()
        .single()
      if (error) throw error
      await loadProcuradores()
      await Swal.fire({ icon: 'success', title: 'Procurador cadastrado!', timer: 1200, showConfirmButton: false })
      return data
    } catch (err) {
      console.error('Erro ao cadastrar procurador:', err)
      await Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível cadastrar: ' + (err.message || 'erro desconhecido') })
      return null
    }
  }

  const abrirModalProcurador = async (cliente) => {
    if (!cliente) return
    setShowDocumentosModal(false)
    let lista = []
    try {
      lista = await fetchProcuradoresAtivos()
    } catch (err) {
      console.error('Erro ao carregar procuradores:', err)
      lista = procuradores
    }

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const optionsHtml = lista.length > 0
        ? `<select id="proc-select" class="swal2-select" style="width:100%;margin:0;">${lista.map(p => `<option value="${p.id}">${escapeHtmlProc(p.nome_procurador)}${p.cpf ? ` – ${formatCPFDisplay(p.cpf)}` : ''}</option>`).join('')}</select>`
        : `<p style="color:#6c757d;margin:0;">Nenhum procurador cadastrado. Clique em "Cadastrar novo" para adicionar.</p>`

      const result = await Swal.fire({
        title: '📋 Gerar Procuração',
        width: 520,
        html: `
          <p style="margin:0 0 12px;text-align:left;"><strong>Cliente:</strong> ${escapeHtmlProc(cliente.nome_completo || '–')}</p>
          <label style="display:block;text-align:left;font-size:0.9rem;font-weight:600;margin:0 0 4px;">Selecione o procurador (outorgado)</label>
          ${optionsHtml}
        `,
        focusConfirm: false,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Gerar Procuração',
        denyButtonText: '➕ Cadastrar novo',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#0d6efd',
        denyButtonColor: '#198754',
        preConfirm: () => {
          const sel = document.getElementById('proc-select')
          if (!sel || !sel.value) {
            Swal.showValidationMessage('Selecione um procurador ou cadastre um novo.')
            return false
          }
          return sel.value
        }
      })

      if (result.isConfirmed) {
        const procurador = lista.find(p => String(p.id) === String(result.value))
        if (procurador) {
          gerarProcuracaoPDF(cliente, procurador)
        } else {
          showNotification('Procurador selecionado não encontrado.', 'error')
        }
        return
      }

      if (result.isDenied) {
        await cadastrarProcuradorSwal()
        try {
          lista = await fetchProcuradoresAtivos()
        } catch (err) {
          console.error('Erro ao recarregar procuradores:', err)
        }
        continue
      }

      // Cancelado ou fechado
      return
    }
  }

  const formatarDataEnvio = (iso) => {
    if (!iso) return ''
    return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
  }

  const enviarParaClicksign = async (cliente, sendVia, email, phone, modoEnvio, anexos = []) => {
    const cpfDigits = String(cliente.cpf || '').replace(/\D/g, '')
    if (cpfDigits.length !== 11) {
      showNotification('Cliente precisa ter CPF válido (11 dígitos) para enviar à Clicksign.', 'error')
      return
    }
    if ((sendVia === 'email' || sendVia === 'both') && (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim()))) {
      showNotification('Informe o e-mail do signatário.', 'error')
      return
    }
    const phoneDigits = String(phone || '').replace(/\D/g, '')
    if ((sendVia === 'whatsapp' || sendVia === 'both') && (phoneDigits.length < 10 || phoneDigits.length > 11)) {
      showNotification('Informe o telefone do signatário (10 ou 11 dígitos) para envio por WhatsApp.', 'error')
      return
    }
    const envioAnexos = modoEnvio === 'anexos'
    const arquivosValidos = Array.isArray(anexos) ? anexos.filter(f => f instanceof File && f.type === 'application/pdf') : []
    if (envioAnexos && arquivosValidos.length === 0) {
      showNotification('Selecione ao menos um documento PDF para enviar.', 'error')
      return
    }
    setSendingClicksign(true)
    setClicksignProgressMsg(envioAnexos ? 'Preparando documentos…' : 'Gerando contrato…')
    setShowClicksignModal(false)
    setClienteClicksign(null)
    setClicksignEmailInput('')
    setClicksignPhoneInput('')
    try {
      await new Promise((r) => setTimeout(r, 40))
      let bytes
      let filename
      const nomeCliente = (cliente.nome_completo || 'Cliente').replace(/\s+/g, '_')
      const dataStr = new Date().toISOString().split('T')[0]

      if (envioAnexos) {
        const mergedPdf = await PDFDocument.create()
        for (const file of arquivosValidos) {
          const anexoBuf = await file.arrayBuffer()
          const pdfAnexo = await PDFDocument.load(anexoBuf)
          const pagesAnexo = await mergedPdf.copyPages(pdfAnexo, pdfAnexo.getPageIndices())
          pagesAnexo.forEach(p => mergedPdf.addPage(p))
        }
        const mergedBytes = await mergedPdf.save({ useObjectStreams: false })
        bytes = mergedBytes
        filename = `Documentos_${nomeCliente}_${dataStr}.pdf`
      } else {
        const { pdf: pdfProc } = buildProcuracaoPdf(cliente)
        const { pdf: pdfCont } = await buildContratoPdf(cliente, { scale: 1.4, jpegQuality: 0.8 })
        setClicksignProgressMsg('Unindo procuração e contrato…')
        const [pdfProcDoc, pdfContDoc] = await Promise.all([
          PDFDocument.load(pdfProc.output('arraybuffer')),
          PDFDocument.load(pdfCont.output('arraybuffer'))
        ])
        const mergedPdf = await PDFDocument.create()
        const pagesProc = await mergedPdf.copyPages(pdfProcDoc, pdfProcDoc.getPageIndices())
        pagesProc.forEach(p => mergedPdf.addPage(p))
        const pagesCont = await mergedPdf.copyPages(pdfContDoc, pdfContDoc.getPageIndices())
        pagesCont.forEach(p => mergedPdf.addPage(p))
        const mergedBytes = await mergedPdf.save({ useObjectStreams: false })
        bytes = mergedBytes
        filename = `Procuração_e_Contrato_${nomeCliente}_${dataStr}.pdf`
      }

      setClicksignProgressMsg('Enviando arquivo…')
      const bucket = 'clicksign-uploads'
      const storagePath = `temp/${Date.now()}-${Math.random().toString(36).slice(2, 11)}.pdf`
      const blob = new Blob([bytes], { type: 'application/pdf' })
      const { error: uploadErr } = await supabase.storage.from(bucket).upload(storagePath, blob, {
        contentType: 'application/pdf',
        upsert: false
      })
      if (uploadErr) {
        console.error('Clicksign: falha ao enviar PDF para Storage', uploadErr)
        showNotification('Falha ao enviar PDF. Crie o bucket "clicksign-uploads" no Storage (Supabase) e tente novamente.', 'error')
        setSendingClicksign(false)
        return
      }

      const signer = {
        name: cliente.nome_completo || 'Cliente',
        documentation: cpfDigits
      }
      if (sendVia === 'email' || sendVia === 'both') signer.email = String(email).trim().toLowerCase()
      if (sendVia === 'whatsapp' || sendVia === 'both') signer.phone_number = phoneDigits
      setClicksignProgressMsg('Criando envelope na Clicksign…')
      const result = await enviarProcuracaoParaClicksign({
        storage_path: storagePath,
        storage_bucket: bucket,
        filename,
        send_via: sendVia,
        signer
      })
      if (result.success) {
        try {
          await supabase.from('procuracao_clicksign_envios').insert({
            cliente_id: cliente.id,
            document_key: result.document_key || null,
            clicksign_document_id: result.document_id || null,
            signing_url: result.signing_url || null,
            send_via: sendVia
          })
          loadProcuracaoEnvios()
        } catch (e) {
          console.error('Erro ao registrar envio:', e)
        }
        setClicksignResult({ url: result.signing_url, message: result.message })
      } else {
        showNotification(result.error || 'Falha ao enviar para Clicksign.', 'error')
      }
    } catch (err) {
      console.error('Clicksign:', err)
      showNotification('Erro ao enviar procuração para assinatura: ' + (err.message || 'erro desconhecido'), 'error')
    } finally {
      setSendingClicksign(false)
      setClicksignProgressMsg('Enviando para assinatura…')
    }
  }

  const openEnviarClicksign = (cliente) => {
    setClienteClicksign(cliente)
    setClicksignSendVia('whatsapp')
    setClicksignModoEnvio('procuracao_contrato')
    setClicksignEmailInput((cliente.email || '').trim())
    setClicksignPhoneInput(String(cliente.telefone || '').replace(/\D/g, ''))
    setClicksignAnexos([])
    if (clicksignFileInputRef.current) clicksignFileInputRef.current.value = ''
    setShowClicksignModal(true)
  }

  const removeClicksignAnexo = (index) => {
    setClicksignAnexos(prev => prev.filter((_, i) => i !== index))
  }

  const clicksignFileInputRef = useRef(null)
  const closeClicksignModal = () => {
    setShowClicksignModal(false)
    setClienteClicksign(null)
    setClicksignEmailInput('')
    setClicksignPhoneInput('')
    setClicksignModoEnvio('procuracao_contrato')
    setClicksignAnexos([])
    if (clicksignFileInputRef.current) clicksignFileInputRef.current.value = ''
  }

  const closeClicksignHub = () => setClicksignHubCliente(null)

  const handleBaixarDocumentoAssinado = async (cliente) => {
    const envio = enviosProcuracaoPorCliente[cliente.id]
    if (!envio?.signed_at) {
      showNotification('Só é possível baixar após a assinatura.', 'warning')
      return
    }
    if (!envio.document_key || !envio.clicksign_document_id) {
      showNotification(
        'Registro do envio à Clicksign está incompleto (falta ID do envelope ou do documento). Se o envio for antigo, pode ser necessário reenviar.',
        'error'
      )
      return
    }
    setBaixandoAssinadoClienteId(cliente.id)
    try {
      const r = await baixarPdfAssinadoClicksign({
        envelopeId: envio.document_key,
        documentId: envio.clicksign_document_id
      })
      if (!r.success) {
        showNotification(r.error || 'Não foi possível baixar o PDF assinado.', 'error')
        return
      }
      const bin = atob(r.pdf_base64)
      const arr = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i)
      const blob = new Blob([arr], { type: 'application/pdf' })
      const nomeSan = (cliente.nome_completo || 'cliente').replace(/[/\\?%*:|"<>]/g, '-').slice(0, 80)
      saveAs(blob, r.filename || `Assinado_${nomeSan}.pdf`)
      showNotification('PDF assinado baixado.', 'success')
    } catch (e) {
      console.error(e)
      showNotification(e?.message || 'Erro ao baixar o documento.', 'error')
    } finally {
      setBaixandoAssinadoClienteId(null)
    }
  }

  /** Ícone Clicksign (mesmo padrão Cadastrar Clientes): ✓ verde | ⏳/✉️ amarelo escuro */
  const fecharAcoesMenu = useCallback(() => setAcoesMenuClienteId(null), [])

  const montarItensAcoesCliente = (cliente) => {
    const itens = [
      {
        key: 'documentos',
        icon: '📎',
        label: 'Anexar / ver documentos',
        onClick: () => {
          setClienteSelecionado(cliente)
          setShowDocumentos(true)
        }
      },
      {
        key: 'gerar',
        icon: '📄',
        label: 'Gerar documentos',
        onClick: () => {
          setClienteParaDocumento(cliente)
          setShowDocumentosModal(true)
        }
      },
      {
        key: 'juridicos',
        icon: '⚖️',
        label: 'Aluguel / União estável',
        onClick: () => setClienteDocsJuridicos(cliente)
      }
    ]
    if (canEnviarClicksign) {
      const envio = enviosProcuracaoPorCliente[cliente.id]
      const assinado = !!envio?.signed_at
      const jaEnviado = !!envio && !assinado
      itens.push({
        key: 'clicksign',
        icon: assinado ? '✓' : jaEnviado ? '⏳' : '✉️',
        label: assinado ? 'Clicksign — baixar PDF' : jaEnviado ? 'Clicksign — reenviar' : 'Clicksign — enviar assinatura',
        detalhe: assinado && envio?.signed_at
          ? `Assinado em ${formatarDataEnvio(envio.signed_at)}`
          : (jaEnviado ? `Enviado em ${formatarDataEnvio(envio.created_at)}` : null),
        onClick: () => setClicksignHubCliente(cliente)
      })
    }
    itens.push(
      {
        key: 'os',
        icon: '🔧',
        label: 'Criar ordem de serviço',
        onClick: () => {
          setClienteParaNovaOrdem(cliente)
          setShowNovaOrdemModal(true)
        }
      },
      {
        key: 'editar',
        icon: '✏️',
        label: 'Editar cliente',
        onClick: () => handleEdit(cliente)
      },
      {
        key: 'kit',
        icon: '☀️',
        label: 'Kit solar',
        onClick: () => handleKitSolar(cliente)
      },
      {
        key: 'projeto',
        icon: '📐',
        label: 'Gerar projeto PDF',
        detalhe: 'Unifilar e diagrama de blocos',
        onClick: () => abrirProjetoPdf(cliente)
      },
      {
        key: 'excluir',
        icon: '🗑️',
        label: 'Excluir cliente',
        perigo: true,
        onClick: () => handleDelete(cliente.id)
      }
    )
    return itens
  }

  // Busca os dados da empresa (CONTRATADA) onde o cliente foi cadastrado.
  const getEmpresaContratada = async (empresaId) => {
    if (!empresaId) return null
    try {
      const { data, error } = await supabase
        .from('empresa')
        .select('*')
        .eq('id', empresaId)
        .single()
      if (error) {
        console.warn('Contrato: não foi possível carregar a empresa contratada.', error.message)
        return null
      }
      return data
    } catch (e) {
      console.warn('Contrato: erro ao carregar empresa contratada.', e && e.message)
      return null
    }
  }

  // Resolve os campos da CONTRATADA, com fallback para os dados da HangSix.
  const resolverEmpresaContrato = (empresa) => {
    const enderecoBruto = (empresa && empresa.endereco) ? String(empresa.endereco).trim() : ''
    const enderecoLower = enderecoBruto.toLowerCase()
    const enderecoValido = enderecoBruto && !enderecoLower.startsWith('http') && !enderecoLower.includes('www.')
    return {
      empresaNome: (empresa && (empresa.empresa || empresa.razao_social)) || 'HangSix Energia Solar',
      empresaRazaoSocial: (empresa && (empresa.razao_social || empresa.empresa)) || 'HangSix Energia Solar',
      empresaCnpj: (empresa && empresa.cnpj) || '44.376.302/0001-34',
      empresaEndereco: enderecoValido ? enderecoBruto : 'Tv. WE29, Nº 2, Cidade Nova IV, CEP: 67133-120, Ananindeua - PA',
      empresaEmail: (empresa && empresa.email) || 'hangsixsolar@gmail.com',
      empresaTelefone: (empresa && (empresa.contato || empresa.telefone || empresa.celular)) || '(91) 9 9253-3339',
      empresaLogo: (empresa && (empresa.logo || empresa.logo_url)) || undefined,
      corPrimaria: (empresa && empresa.cor_primaria_contrato) || undefined,
      corDestaque: (empresa && empresa.cor_destaque_contrato) || undefined
    }
  }

  // Converte a logo (URL) em data URI para o PDF e para o HTML baixado.
  const fetchImageAsDataUrl = async (url) => {
    if (!url) return null
    try {
      const res = await fetch(url, { mode: 'cors' })
      if (!res.ok) return null
      const blob = await res.blob()
      return await new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = () => resolve(null)
        reader.readAsDataURL(blob)
      })
    } catch (e) {
      console.warn('Contrato: não foi possível carregar a logo da empresa.', e && e.message)
      return null
    }
  }

  // Normaliza os dados do contrato: cliente completo (kit + valor) e empresa contratada.
  const getDadosContrato = async (cliente) => {
    let dadosCliente = { ...cliente }
    if (cliente && cliente.id) {
      const { data: clienteCompleto, error } = await supabase
        .from('clientes_cadastro')
        .select(`
          *,
          kit_solar_cliente (
            marca_inversor,
            modelo_inversor,
            potencia_inversor,
            quantidade_inversor,
            marca_modulo,
            modelo_modulo,
            potencia_modulo,
            quantidade_modulo,
            inversores,
            modulos
          )
        `)
        .eq('id', cliente.id)
        .single()
      if (!error && clienteCompleto) {
        dadosCliente = { ...clienteCompleto }
        const kitRel = dadosCliente.kit_solar_cliente
        const kitUnico = Array.isArray(kitRel) ? kitRel[0] : kitRel
        if (kitUnico && typeof kitUnico === 'object') {
          dadosCliente.marca_inversor = kitUnico.marca_inversor
          dadosCliente.modelo_inversor = kitUnico.modelo_inversor
          dadosCliente.potencia_inversor = kitUnico.potencia_inversor
          dadosCliente.quantidade_inversor = kitUnico.quantidade_inversor
          dadosCliente.marca_modulo = kitUnico.marca_modulo
          dadosCliente.modelo_modulo = kitUnico.modelo_modulo
          dadosCliente.potencia_modulo = kitUnico.potencia_modulo
          dadosCliente.quantidade_modulo = kitUnico.quantidade_modulo
          dadosCliente.inversores = kitUnico.inversores
          dadosCliente.modulos = kitUnico.modulos
        }
      } else {
        if (error) console.warn('Contrato: busca completa do cliente falhou, usando dados da lista.', error.message)
        if (cliente.kit_solar_cliente) {
          const k = Array.isArray(cliente.kit_solar_cliente) ? cliente.kit_solar_cliente[0] : cliente.kit_solar_cliente
          if (k && typeof k === 'object') {
            dadosCliente.marca_inversor = dadosCliente.marca_inversor ?? k.marca_inversor
            dadosCliente.modelo_inversor = dadosCliente.modelo_inversor ?? k.modelo_inversor
            dadosCliente.potencia_inversor = dadosCliente.potencia_inversor ?? k.potencia_inversor
            dadosCliente.quantidade_inversor = dadosCliente.quantidade_inversor ?? k.quantidade_inversor
            dadosCliente.marca_modulo = dadosCliente.marca_modulo ?? k.marca_modulo
            dadosCliente.modelo_modulo = dadosCliente.modelo_modulo ?? k.modelo_modulo
            dadosCliente.potencia_modulo = dadosCliente.potencia_modulo ?? k.potencia_modulo
            dadosCliente.quantidade_modulo = dadosCliente.quantidade_modulo ?? k.quantidade_modulo
            dadosCliente.inversores = dadosCliente.inversores ?? k.inversores
            dadosCliente.modulos = dadosCliente.modulos ?? k.modulos
          }
        }
        dadosCliente.valor_total = dadosCliente.valor_total ?? cliente.valor_total
      }
    }

    const empresa = await getEmpresaContratada(dadosCliente.empresa_id || (cliente && cliente.empresa_id))

    const nomeCliente = dadosCliente.nome_completo || 'Nome não informado'
    const cpfDigits = String(dadosCliente.cpf || '').replace(/[^0-9]/g, '')
    const cpfCliente = cpfDigits.length === 11
      ? `${cpfDigits.slice(0, 3)}.${cpfDigits.slice(3, 6)}.${cpfDigits.slice(6, 9)}-${cpfDigits.slice(9)}`
      : (dadosCliente.cpf || 'N/A')

    const kitRel = dadosCliente.kit_solar_cliente
    const kit = (Array.isArray(kitRel) ? kitRel[0] : kitRel) || {}
    const inversoresKit = Array.isArray(kit.inversores) && kit.inversores.length
      ? kit.inversores
      : (Array.isArray(dadosCliente.inversores) && dadosCliente.inversores.length
        ? dadosCliente.inversores
        : [{
          marca: kit.marca_inversor || dadosCliente.marca_inversor,
          modelo: kit.modelo_inversor || dadosCliente.modelo_inversor,
          potencia: kit.potencia_inversor ?? dadosCliente.potencia_inversor,
          quantidade: kit.quantidade_inversor ?? dadosCliente.quantidade_inversor
        }])
    const modulosKit = Array.isArray(kit.modulos) && kit.modulos.length
      ? kit.modulos
      : (Array.isArray(dadosCliente.modulos) && dadosCliente.modulos.length
        ? dadosCliente.modulos
        : [{
          marca: kit.marca_modulo || dadosCliente.marca_modulo,
          modelo: kit.modelo_modulo || dadosCliente.modelo_modulo,
          potencia: kit.potencia_modulo ?? dadosCliente.potencia_modulo,
          quantidade: kit.quantidade_modulo ?? dadosCliente.quantidade_modulo
        }])
    const hasKit = inversoresKit.some(linhaKitTemDado) || modulosKit.some(linhaKitTemDado)
    let kitSolarHtml
    if (hasKit) {
      const textoInversores = inversoresKit.filter(linhaKitTemDado).map((linha) => formatarLinhaKitTexto(linha, 'kW')).join('; ')
      const textoModulos = modulosKit.filter(linhaKitTemDado).map((linha) => formatarLinhaKitTexto(linha, 'W')).join('; ')
      kitSolarHtml = `Inversor(es): ${textoInversores || '-'}.<br>Módulo(s) fotovoltaico(s): ${textoModulos || '-'}.`
    } else {
      kitSolarHtml = 'Kit solar não cadastrado para este cliente no momento da emissão deste instrumento.'
    }

    const valorProjetoRaw = dadosCliente.valor_total
    const valorProjeto = valorProjetoRaw != null && valorProjetoRaw !== ''
      ? (typeof valorProjetoRaw === 'number' ? valorProjetoRaw : parseFloat(String(valorProjetoRaw).split('.').join('').replace(',', '.')) || 0)
      : 0
    const valorProjetoFormatado = valorProjeto > 0
      ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorProjeto)
      : 'Não informado'
    const valorTexto = valorProjetoFormatado === 'Não informado'
      ? 'O valor total do projeto não foi informado no cadastro do sistema.'
      : `O valor total do projeto é de ${valorProjetoFormatado}.`

    const multaValor = valorProjeto > 0 ? valorProjeto * 0.5 : 0
    const multaFormatada = multaValor > 0
      ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(multaValor)
      : null
    const multaTexto = multaFormatada
      ? `50% (cinquenta por cento) do valor total do projeto, correspondente a ${multaFormatada}`
      : '50% (cinquenta por cento) do valor total do projeto'

    return { dadosCliente, empresa, nomeCliente, cpfCliente, kitSolarHtml, valorTexto, multaTexto }
  }

  // Renderiza um HTML em PDF A4 multipágina (html2canvas + jsPDF).
  // Captura bloco a bloco (cabeçalho, cada seção, assinaturas, rodapé) e move o
  // bloco inteiro para a próxima página quando não couber, evitando cortes no meio
  // de uma seção (ex.: "4. PRAZO DE ENTREGA E HOMOLOGAÇÃO").
  const renderHtmlToA4Pdf = async (html, opcoes = {}) => {
    const scale = opcoes.scale ?? 2
    const jpegQuality = opcoes.jpegQuality ?? 0.95
    const concurrency = Math.max(1, opcoes.concurrency ?? 3)
    const wrapper = document.createElement('div')
    wrapper.style.position = 'fixed'
    wrapper.style.left = '-10000px'
    wrapper.style.top = '0'
    wrapper.style.width = '794px'
    wrapper.style.padding = '0'
    wrapper.style.background = '#ffffff'
    wrapper.style.boxSizing = 'border-box'
    wrapper.innerHTML = html
    document.body.appendChild(wrapper)
    try {
      const imgs = Array.from(wrapper.querySelectorAll('img'))
      await Promise.all(imgs.map((img) => (img.complete ? Promise.resolve() : new Promise((res) => { img.onload = res; img.onerror = res }))))

      const root = wrapper.querySelector('.contrato-root') || wrapper
      const blocos = Array.from(root.children).filter((el) => el.tagName !== 'STYLE')

      const canvases = new Array(blocos.length)
      for (let i = 0; i < blocos.length; i += concurrency) {
        const batch = blocos.slice(i, i + concurrency).map((bloco, offset) =>
          html2canvas(bloco, { scale, useCORS: true, backgroundColor: '#ffffff', logging: false, imageTimeout: 8000 })
            .then((canvas) => { canvases[i + offset] = canvas })
        )
        await Promise.all(batch)
      }

      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageW = pdf.internal.pageSize.getWidth()
      const pageH = pdf.internal.pageSize.getHeight()
      const marginX = 12
      const marginY = 14
      const contentW = pageW - marginX * 2
      const usableH = pageH - marginY * 2
      const gap = 3
      let currentY = marginY

      for (const canvas of canvases) {
        if (!canvas || !canvas.width || !canvas.height) continue
        let imgW = contentW
        let imgH = (canvas.height * imgW) / canvas.width
        if (imgH > usableH) {
          const ratio = usableH / imgH
          imgH = usableH
          imgW = contentW * ratio
        }
        if (currentY + imgH > pageH - marginY && currentY > marginY) {
          pdf.addPage()
          currentY = marginY
        }
        const imgData = canvas.toDataURL('image/jpeg', jpegQuality)
        pdf.addImage(imgData, 'JPEG', marginX, currentY, imgW, imgH)
        currentY += imgH + gap
      }
      return pdf
    } finally {
      document.body.removeChild(wrapper)
    }
  }

  // Monta o HTML do contrato (fonte única do PDF e do arquivo .html).
  const montarHtmlContratoCliente = async (cliente) => {
    const dados = await getDadosContrato(cliente)
    const empresaResolvida = resolverEmpresaContrato(dados.empresa)
    const temLogo = !!empresaResolvida.empresaLogo
    const logoDataUrl = temLogo ? await fetchImageAsDataUrl(empresaResolvida.empresaLogo) : null
    const html = buildContratoHtml({
      ...empresaResolvida,
      empresaLogo: logoDataUrl || empresaResolvida.empresaLogo,
      semLogo: !temLogo,
      clienteNome: dados.nomeCliente,
      clienteCpf: dados.cpfCliente,
      kitSolarHtml: dados.kitSolarHtml,
      valorTexto: dados.valorTexto,
      multaTexto: dados.multaTexto
    })
    return { html, nomeCliente: dados.nomeCliente }
  }

  // Constrói o PDF do contrato (para download ou envio Clicksign). Retorna { pdf, nomeArquivo }.
  const buildContratoPdf = async (cliente, opcoesPdf = {}) => {
    const { html, nomeCliente } = await montarHtmlContratoCliente(cliente)
    const pdf = await renderHtmlToA4Pdf(html, opcoesPdf)
    return { pdf, nomeArquivo: nomeArquivoContrato(nomeCliente, 'pdf') }
  }

  const gerarContratoPDF = async (cliente) => {
    setGerandoContratoPdf(true)
    try {
      const { pdf, nomeArquivo } = await buildContratoPdf(cliente)
      pdf.save(nomeArquivo)
      showNotification('Contrato gerado com sucesso!', 'success')
      setShowDocumentosModal(false)
    } catch (error) {
      console.error('Erro ao gerar PDF do contrato:', error)
      showNotification('Erro ao gerar contrato: ' + error.message, 'error')
    } finally {
      setGerandoContratoPdf(false)
    }
  }

  // Gera e baixa o mesmo contrato em HTML editável (navegador ou Word).
  const gerarContratoHtml = async (cliente) => {
    setGerandoContratoPdf(true)
    try {
      const { html, nomeCliente } = await montarHtmlContratoCliente(cliente)
      const documento = wrapContratoHtmlDocumento(html, `Contrato - ${nomeCliente || 'Cliente'}`)
      const blob = new Blob([documento], { type: 'text/html;charset=utf-8' })
      saveAs(blob, nomeArquivoContrato(nomeCliente, 'html'))
      showNotification('Contrato em HTML gerado com sucesso!', 'success')
      setShowDocumentosModal(false)
    } catch (error) {
      console.error('Erro ao gerar HTML do contrato:', error)
      showNotification('Erro ao gerar contrato: ' + error.message, 'error')
    } finally {
      setGerandoContratoPdf(false)
    }
  }

  // Gerar contrato em Word (.docx) para edição
  const gerarContratoWord = async (cliente) => {
    try {
      const dados = await getDadosContrato(cliente)
      const emp = resolverEmpresaContrato(dados.empresa)
      const nomeCliente = dados.nomeCliente
      const cpfCliente = dados.cpfCliente
      const textoValor = dados.valorTexto
      // kitSolarHtml usa <br> para separar inversor/módulo; converte em parágrafos do Word.
      const kitParagrafos = String(dados.kitSolarHtml).split('<br>').map((linha) => linha.trim()).filter(Boolean)

      const p = (text, bold = false, align = null) => new Paragraph({
        children: [new TextRun({ text, bold })],
        alignment: align === 'center' ? AlignmentType.CENTER : undefined,
        spacing: { after: 120 }
      })
      const pEmpty = () => new Paragraph({ spacing: { after: 120 } })
      const pSection = (text) => new Paragraph({
        children: [new TextRun({ text, bold: true, size: 24 })],
        spacing: { before: 240, after: 120 }
      })

      const children = [
        p('CONTRATO DE PROJETO E INSTALAÇÃO FOTOVOLTAICO', true, 'center'),
        p('Instrumento Particular de Prestação de Serviços', false, 'center'),
        pEmpty(),
        pSection('1. PARTES CONTRATANTES'),
        p(`CONTRATADA: ${emp.empresaRazaoSocial}, inscrita no CNPJ sob nº ${emp.empresaCnpj}, com sede na ${emp.empresaEndereco}, doravante denominada CONTRATADA.`),
        p(`CONTRATANTE: ${nomeCliente}, inscrito(a) no CPF/CNPJ sob nº ${cpfCliente}, doravante denominado(a) CONTRATANTE.`),
        pEmpty(),
        pSection('2. OBJETO DO CONTRATO'),
        p('O presente instrumento tem por objeto a prestação de serviços de instalação de sistema fotovoltaico, incluindo a homologação junto à concessionária de energia elétrica, monitoramento do sistema pelo período de 1 (um) ano, e o fornecimento de garantia dos equipamentos (módulos fotovoltaicos e inversor) em estrita conformidade com as políticas e prazos estabelecidos pelos respectivos fabricantes.'),
        pSection('2.1. ESPECIFICAÇÃO DO KIT SOLAR'),
        ...kitParagrafos.map((linha) => p(linha)),
        pSection('2.2. VALOR DO PROJETO'),
        p(textoValor),
        pEmpty(),
        pSection('3. OBRIGAÇÕES DA CONTRATADA'),
        p('1. Fornecimento e instalação de materiais elétricos estritamente necessários à execução do serviço e instalação do projeto (quadro de string DC, quadro de paralelo AC);'),
        p('2. Fornecimento e instalação de estrutura metálica para suporte de módulos fotovoltaicos;'),
        p('3. Conexão elétrica entre módulos, quadros DC, inversor e quadro de baixa tensão;'),
        p('4. Teste de funcionalidade e entrega de conformidade da usina;'),
        p('5. Avaliação do projeto de ajuste, caso seja necessário;'),
        p('6. Tratamento do processo de homologação do sistema junto à Concessionária de Energia Elétrica (Equatorial) e solicitação de aumento de carga (de monofásico para bifásico).'),
        pEmpty(),
        pSection('4. PRAZO DE ENTREGA E HOMOLOGAÇÃO'),
        p('O prazo global estabelecido para a conclusão da entrega do kit solar, instalação e a devida homologação do sistema fotovoltaico é de 90 (noventa) dias, contados a partir da assinatura deste instrumento.'),
        p('Parágrafo Único: Excluem-se expressamente do cômputo deste prazo os períodos de atraso decorrentes única e exclusivamente dos trâmites, análises, vistorias e aprovações de responsabilidade da concessionária de energia elétrica local (Equatorial), bem como as hipóteses previstas na Cláusula 9 deste instrumento.'),
        pEmpty(),
        pSection('5. ITENS EXCLUÍDOS DO CONTRATO'),
        p('Estão expressamente excluídos do escopo de fornecimento e responsabilidade da CONTRATADA:'),
        p('1. Obras civis: intervenções na estrutura de edifícios, fundações, terraplenagem, armação, drenagem, ampliação, inovação ou restauração no imóvel;'),
        p('2. Fornecimento de telhas, exceto na hipótese de alguma unidade vir a ser danificada por culpa dos técnicos no momento exato da instalação;'),
        p('3. Obras de transmissão de energia em linha aérea: o cabeamento que liga a residência até a rede da concessionária, sendo tais procedimentos de responsabilidade exclusiva da concessionária de energia;'),
        p('4. Estrutura mecânica de reforço do telhado (mesmo onde previsto no laudo de vistoria);'),
        p('5. Implantação e custeio de poste auxiliar, quando necessário e indicado na vistoria técnica;'),
        p('6. Cálculo estrutural do telhado (quando não previsto especificamente no item 2.1).'),
        pEmpty(),
        pSection('6. RESPONSABILIDADES DA CONTRATANTE'),
        p('Manter o ponto de conexão de internet ligado ao sistema fotovoltaico sempre ativo, devendo realizar todos os procedimentos e medidas indicadas pela CONTRATADA para restabelecer o pleno funcionamento em caso de falha de conexão;'),
        p('Armazenar o material entregue em local seguro, sendo de sua total e exclusiva responsabilidade prevenir a ocorrência de roubo, furto, extravio e danos aos materiais após a entrega e durante a execução da instalação;'),
        p('Responsabilizar-se civil e integralmente por quaisquer ocorrências de roubo e furto após a entrega dos materiais no local e durante a prestação do serviço.'),
        pEmpty(),
        pSection('7. GARANTIA E MANUTENÇÃO'),
        p('A CONTRATADA garante a perfeita execução dos serviços e a integridade técnica da instalação realizada.'),
        p('A CONTRATADA concede garantia de 1 (um) ano sobre a instalação executada, contada a partir da data de conclusão e comissionamento do sistema fotovoltaico, cobrindo eventuais vícios ou defeitos decorrentes exclusivamente da execução dos serviços de instalação por ela realizados.'),
        p('A garantia legal e contratual dos equipamentos (placas/módulos e inversores) é de responsabilidade direta e exclusiva dos respectivos fabricantes.'),
        p('A ancoragem dos módulos (via Parafuso M10/HUCK) dar-se-á estritamente nas ripas de apoio das telhas. Não é de responsabilidade da CONTRATADA a intervenção, perfuração ou fixação em caibros (pernamancas), por se tratarem de componentes da estrutura vital do telhado, ficando a garantia da instalação restrita à metodologia padrão aqui descrita.'),
        p('Será oferecida ao CONTRATANTE 1 (uma) manutenção preventiva gratuita, a ser realizada dentro do período de 1 (um) ano após a conclusão da instalação.'),
        pEmpty(),
        pSection('8. DANOS COBERTOS'),
        p('Os danos causados aos equipamentos serão cobertos pela CONTRATADA única e exclusivamente caso sejam decorrentes de transporte inadequado sob sua responsabilidade, má instalação ou intercorrências provocadas diretamente durante o processo de instalação.'),
        p('Quaisquer danos posteriores à entrega e comissionamento do sistema são de responsabilidade integral do CONTRATANTE.'),
        pEmpty(),
        pSection('9. SUSPENSÃO DE PRAZOS'),
        p('Os prazos contratuais, incluindo o prazo global de 90 dias, serão suspensos sempre que ocorrerem atrasos decorrentes de condutas ou fatos não imputáveis à CONTRATADA, voltando a correr pelo tempo restante assim que for completamente corrigida ou cessada a circunstância impeditiva. São exemplos de causas de suspensão:'),
        p('a) Estudo de rede realizado pela concessionária de energia elétrica;'),
        p('b) Necessidade de obras de ajuste de estrutura ou reformas no imóvel;'),
        p('c) Caso fortuito, força maior ou dificuldades supervenientes de acesso seguro ao imóvel;'),
        p('d) Interrupções no fornecimento local de água ou energia elétrica superiores a 2 (duas) horas por dia;'),
        p('e) Atrasos motivados por atos do CONTRATANTE, entes públicos ou da própria concessionária;'),
        p('f) Alteração ou modificação do projeto original por solicitação do CONTRATANTE;'),
        p('g) Recusa ou atraso na homologação por ausência do CONTRATANTE ou de responsável no imóvel;'),
        p('h) Existência de débitos financeiros em aberto do imóvel junto à concessionária de energia elétrica;'),
        p('i) Alteração ou substituição de Unidades Consumidoras que não tenham sido informadas por escrito no prazo adequado.'),
        pEmpty(),
        pSection('10. CANCELAMENTO'),
        p(`Caso o CONTRATANTE opte por cancelar o presente contrato, em qualquer fase de sua execução, ficará obrigado a pagar à CONTRATADA uma multa correspondente a ${dados.multaTexto}, a título de indenização pelos custos, despesas e prejuízos decorrentes do cancelamento.`),
        p('Parágrafo Único: A multa de cancelamento é devida independentemente do estágio de avanço do projeto (projeto, aquisição de materiais, instalação ou homologação), e deverá ser quitada pelo CONTRATANTE no prazo de até 10 (dez) dias úteis contados da comunicação formal do cancelamento.'),
        pEmpty(),
        pSection('11. CONTATO E SUPORTE'),
        p(`Qualquer dúvida, solicitação de suporte técnico ou atendimento referente ao sistema fotovoltaico poderá ser formalizada através do telefone ${emp.empresaTelefone} ou pelo e-mail ${emp.empresaEmail}.`),
        pEmpty(),
        pSection('12. DISPOSIÇÕES FINAIS E FORO'),
        p('As partes elegem, de comum acordo, o foro da Comarca de Ananindeua - PA para dirimir quaisquer dúvidas, controvérsias ou litígios oriundos da interpretação ou execução deste contrato, com renúncia expressa a qualquer outro, por mais privilegiado que seja.'),
        p('E, por estarem assim justas e contratadas, as partes assinam o presente instrumento em duas vias de igual teor e forma.'),
        pEmpty(),
        p('CONTRATANTE:', true),
        pEmpty(),
        p(nomeCliente),
        p(`CPF/CNPJ: ${cpfCliente}`),
        pEmpty(),
        p('CONTRATADA:', true),
        p(emp.empresaNome),
        pEmpty(),
        p(emp.empresaNome.toUpperCase(), false, 'center'),
        p(`CNPJ: ${emp.empresaCnpj}`, false, 'center'),
        p(emp.empresaEndereco, false, 'center'),
        p(`Telefone: ${emp.empresaTelefone} | E-mail: ${emp.empresaEmail}`, false, 'center')
      ]

      const doc = new Document({
        sections: [{ properties: {}, children }]
      })

      const blob = await Packer.toBlob(doc)
      const nomeArquivo = `Contrato_${nomeCliente.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.docx`
      saveAs(blob, nomeArquivo)
      showNotification('Contrato em Word gerado com sucesso!', 'success')
      setShowDocumentosModal(false)
    } catch (error) {
      console.error('Erro ao gerar contrato em Word:', error)
      showNotification('Erro ao gerar contrato em Word: ' + error.message, 'error')
    }
  }

  const formatCPFDisplay = (cpf) => {
    if (!cpf) return ''
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }

  const formatCurrencyDisplay = (value) => {
    if (!value) return 'R$ 0,00'
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value)
  }

  // Filtrar clientes baseado nos filtros
  const clientesFiltrados = clientes.filter(cliente => {
    // Filtro por nome
    if (filtroNome && filtroNome.trim() !== '') {
      const nomeCliente = cliente.nome_completo?.toLowerCase() || ''
      const nomeFiltro = filtroNome.toLowerCase().trim()
      if (!nomeCliente.includes(nomeFiltro)) {
        return false
      }
    }
    
    // Filtro por empresa (apenas para administradores)
    if (userRole === 'administrador' && filtroEmpresa && filtroEmpresa !== '') {
      if (cliente.empresa_id !== filtroEmpresa) {
        return false
      }
    }
    
    // Filtro por CPF do cliente (apenas dígitos)
    if (filtroCpf.trim()) {
      const cpfCliente = (cliente.cpf || '').replace(/\D/g, '')
      const cpfFiltro = filtroCpf.replace(/\D/g, '')
      if (!cpfCliente.includes(cpfFiltro)) {
        return false
      }
    }
    
    return true
  })
  
  const totalClientes = clientesFiltrados.length
  
  // Nome da empresa do usuário logado
  const nomeEmpresa = userEmpresa?.empresa || 'Empresa'

  if (showForm) {
    const formTabs = modoCadastro === 'venda'
      ? [
          { id: 'pessoais', icon: 'bi-person-badge', label: 'Dados Pessoais' },
          { id: 'local', icon: 'bi-geo-alt', label: 'Local da Instalação' },
          { id: 'financeiro', icon: 'bi-wallet2', label: 'Financeiro e Venda' },
          { id: 'kit', icon: 'bi-sun', label: 'Kit Solar' }
        ]
      : [
          { id: 'pessoais', icon: 'bi-person-badge', label: 'Dados Pessoais' },
          { id: 'local', icon: 'bi-geo-alt', label: 'Local da Instalação' },
          { id: 'kit', icon: 'bi-sun', label: 'Kit Solar' }
        ]
    const abaAtiva = formTabs.some((t) => t.id === formTab) ? formTab : 'pessoais'
    const tabIndex = Math.max(0, formTabs.findIndex((t) => t.id === abaAtiva))
    const isLastTab = tabIndex >= formTabs.length - 1

    return (
      <div className="clientes-ii-container cliente-cadastro-shell">
        <div className="cliente-cadastro-toolbar">
          <button onClick={resetForm} className="btn-back">
            Voltar
          </button>
        </div>

        <form onSubmit={handleSubmit} className="cliente-cadastro-form" noValidate>
          <div className="cliente-cadastro-card">
            <nav className="cliente-cadastro-nav" aria-label="Etapas do cadastro">
              {formTabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  className={`cliente-cadastro-nav-btn${abaAtiva === tab.id ? ' is-active' : ''}`}
                  onClick={() => setFormTab(tab.id)}
                >
                  <i className={`bi ${tab.icon}`} aria-hidden="true" />
                  {tab.label}
                </button>
              ))}
            </nav>

            <div className="cliente-cadastro-card-body">
                {abaAtiva === 'pessoais' && (
                  <>
                    <div className="cliente-cadastro-pane-header">
                      <h4>Informações Pessoais</h4>
                      <p>Insira os dados básicos de identificação do cliente.</p>
                    </div>
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="nome_completo"
                            name="nome_completo"
                            placeholder=" "
                            value={formData.nome_completo}
                            onChange={handleInputChange}
                            required
                          />
                          <label htmlFor="nome_completo">Nome Completo *</label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="cpf"
                            name="cpf"
                            placeholder=" "
                            value={formatCPFDisplay(formData.cpf)}
                            onChange={handleCPFChange}
                            required={modoCadastro === 'venda'}
                            maxLength="14"
                          />
                          <label htmlFor="cpf">{modoCadastro === 'venda' ? 'CPF *' : 'CPF'}</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="rg"
                            name="rg"
                            placeholder=" "
                            value={formData.rg}
                            onChange={handleInputChange}
                            maxLength="20"
                          />
                          <label htmlFor="rg">RG</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="date"
                            className="form-control"
                            id="data_nascimento"
                            name="data_nascimento"
                            placeholder=" "
                            value={formData.data_nascimento}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="data_nascimento">Data de Nascimento</label>
                        </div>
                      </div>
                      <div className="col-md-6" />
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="tel"
                            className="form-control"
                            id="telefone"
                            name="telefone"
                            placeholder=" "
                            value={formData.telefone}
                            onChange={handleInputChange}
                            required={modoCadastro === 'resumido'}
                          />
                          <label htmlFor="telefone">
                            {modoCadastro === 'resumido' ? 'Telefone / WhatsApp *' : 'Telefone / WhatsApp'}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder=" "
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="email">Endereço de E-mail</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <label className="cliente-cadastro-check cliente-cadastro-check--campo" htmlFor="fatura_terceiro">
                          <input
                            type="checkbox"
                            id="fatura_terceiro"
                            name="fatura_terceiro"
                            checked={!!formData.fatura_terceiro}
                            onChange={(e) => {
                              const checked = e.target.checked
                              setFormData((prev) => ({
                                ...prev,
                                fatura_terceiro: checked,
                                documento_titular_fatura_url: checked ? prev.documento_titular_fatura_url : ''
                              }))
                              if (!checked) {
                                setDocumentoTitularFaturaFile(null)
                                const fileInput = document.getElementById('documento_titular_fatura')
                                if (fileInput) fileInput.value = ''
                              }
                            }}
                          />
                          <span>A fatura de energia está em nome de outra pessoa?</span>
                        </label>
                      </div>
                      {formData.fatura_terceiro && (
                        <div className="col-12">
                          <div className="cliente-cadastro-upload-terceiro">
                            <label className="form-label text-muted small fw-medium mb-2" htmlFor="documento_titular_fatura">
                              Anexar Documento com foto (CNH ou RG do titular da fatura)
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              id="documento_titular_fatura"
                              accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp"
                              onChange={(e) => handleDocumentoTitularFaturaChange(e.target.files?.[0] || null)}
                            />
                            {(documentoTitularFaturaFile || formData.documento_titular_fatura_url) && (
                              <small className="text-muted d-block mt-2">
                                {documentoTitularFaturaFile
                                  ? `Arquivo selecionado: ${documentoTitularFaturaFile.name}`
                                  : (
                                    <a href={formData.documento_titular_fatura_url} target="_blank" rel="noreferrer">
                                      Ver documento anexado
                                    </a>
                                  )}
                              </small>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {abaAtiva === 'local' && (
                  <>
                    <div className="cliente-cadastro-pane-header">
                      <h4>Local da Instalação</h4>
                      <p>Endereço onde o serviço será realizado. Digite o CEP para busca automática.</p>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="cliente-cadastro-cep-group">
                          <div className="form-floating">
                            <input
                              type="text"
                              className="form-control"
                              id="cep"
                              name="cep"
                              placeholder=" "
                              value={formatCepDisplay(formData.cep)}
                              onChange={(e) => {
                                const digits = e.target.value.replace(/\D/g, '').slice(0, 8)
                                setFormData((prev) => ({ ...prev, cep: digits }))
                                if (digits.length === 8) buscarCep(digits, { silencioso: true })
                              }}
                              onPaste={(e) => {
                                e.preventDefault()
                                const colado = (e.clipboardData?.getData('text') || '').replace(/\D/g, '').slice(0, 8)
                                setFormData((prev) => ({ ...prev, cep: colado }))
                                if (colado.length === 8) buscarCep(colado, { silencioso: true })
                              }}
                            />
                            <label htmlFor="cep">CEP</label>
                          </div>
                          <button
                            type="button"
                            className="cliente-cadastro-cep-btn"
                            onClick={() => buscarCep()}
                            disabled={searchCep}
                            title="Buscar CEP"
                          >
                            {searchCep ? (
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            ) : (
                              <i className="bi bi-search" aria-hidden="true" />
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="logradouro"
                            name="logradouro"
                            placeholder=" "
                            value={formData.logradouro}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="logradouro">Logradouro (Rua, Av.)</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="numero"
                            name="numero"
                            placeholder=" "
                            value={formData.numero}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="numero">Número</label>
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="complemento"
                            name="complemento"
                            placeholder=" "
                            value={formData.complemento}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="complemento">Complemento (Apto, Bloco, etc)</label>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="bairro"
                            name="bairro"
                            placeholder=" "
                            value={formData.bairro}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="bairro">Bairro</label>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="cidade"
                            name="cidade"
                            placeholder=" "
                            value={formData.cidade}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="cidade">Cidade</label>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            id="estado"
                            name="estado"
                            value={formData.estado}
                            onChange={handleInputChange}
                          >
                            <option value="">UF</option>
                            {estados.map((uf) => (
                              <option key={uf} value={uf}>{uf}</option>
                            ))}
                          </select>
                          <label htmlFor="estado">Estado</label>
                        </div>
                      </div>
                      <div className="col-12 mt-2">
                        <div className="form-floating">
                          <input
                            type="url"
                            className="form-control"
                            id="link_localizacao"
                            name="link_localizacao"
                            placeholder=" "
                            value={formData.link_localizacao}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="link_localizacao">Link do Google Maps (Opcional)</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <label htmlFor="foto_fachada" className="form-label text-muted small fw-medium mb-1">
                          Foto da Fachada (Opcional)
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="foto_fachada"
                          name="foto_fachada"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0]
                            if (file) handleFotoFachadaUpload(file)
                          }}
                          disabled={uploadingFotoFachada}
                        />
                        {uploadingFotoFachada && (
                          <small className="text-info d-block mt-2">Enviando imagem...</small>
                        )}
                        {(formData.foto_fachada || fotoFachadaFile?.url) && (
                          <div className="mt-3">
                            <img
                              src={formData.foto_fachada || fotoFachadaFile?.url}
                              alt="Foto da fachada"
                              className="cliente-cadastro-fachada-preview"
                              onError={(e) => { e.target.style.display = 'none' }}
                            />
                            {formData.foto_fachada && (
                              <div className="mt-2">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={() => {
                                    setFormData((prev) => ({ ...prev, foto_fachada: '' }))
                                    setFotoFachadaFile(null)
                                    const fileInput = document.getElementById('foto_fachada')
                                    if (fileInput) fileInput.value = ''
                                  }}
                                >
                                  Remover foto
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {abaAtiva === 'financeiro' && modoCadastro === 'venda' && (
                  <>
                    <div className="cliente-cadastro-pane-header">
                      <h4>Dados Financeiros e Venda</h4>
                      <p>Configuração de pagamentos e detalhes comerciais do projeto.</p>
                    </div>

                    <div className="cliente-cadastro-resumo-financeiro">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-floating">
                            <input
                              type="text"
                              className="form-control fw-semibold"
                              id="valor_total"
                              name="valor_total"
                              placeholder=" "
                              value={formData.valor_total}
                              onChange={handleCurrencyChange}
                            />
                            <label htmlFor="valor_total">Valor Total do Projeto (R$)</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating">
                            <input
                              type="text"
                              className="form-control"
                              id="majoracao"
                              name="majoracao"
                              placeholder=" "
                              value={formData.majoracao}
                              onChange={handleCurrencyChange}
                            />
                            <label htmlFor="majoracao">Valor da Majoração (R$)</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="fw-bold m-0">Composição de Pagamento</h6>
                      <button
                        type="button"
                        className="cliente-cadastro-btn-add-pagamento"
                        onClick={adicionarPagamento}
                      >
                        <i className="bi bi-plus-lg" /> Adicionar Pagamento
                      </button>
                    </div>

                    <div className="cliente-cadastro-pagamentos-container">
                      {pagamentosList.map((p, idx) => (
                        <div key={p.key || p.id || idx} className="cliente-cadastro-pagamento-card">
                          {pagamentosList.length > 1 && (
                            <button
                              type="button"
                              className="cliente-cadastro-pagamento-remove"
                              title="Remover este pagamento"
                              onClick={() => removerPagamento(idx)}
                            >
                              <i className="bi bi-trash" />
                            </button>
                          )}
                          <div className="row g-3">
                            <div className="col-md-6">
                              <label className="form-label text-muted small fw-medium mb-1" htmlFor={`forma_pagamento_${idx}`}>
                                Forma de Pagamento
                              </label>
                              <select
                                className="form-select"
                                id={`forma_pagamento_${idx}`}
                                value={p.forma_pagamento}
                                onChange={(e) => handleFormaPagamentoChange(idx, e.target.value)}
                              >
                                <option value="" disabled>Selecione...</option>
                                {FORMAS_PAGAMENTO_CADASTRO.map((opcao) => (
                                  <option key={opcao.value} value={opcao.value}>{opcao.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label text-muted small fw-medium mb-1" htmlFor={`valor_pagamento_${idx}`}>
                                Valor
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id={`valor_pagamento_${idx}`}
                                placeholder="R$ 0,00"
                                value={typeof p.valor === 'number'
                                  ? p.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                  : (p.valor || '')}
                                onChange={(e) => atualizarPagamento(idx, { valor: formatCurrencyInput(e.target.value) })}
                              />
                            </div>
                          </div>

                          {p.forma_pagamento === 'financiamento' && (
                            <div className="cliente-cadastro-financiamento-box">
                              <div className="row g-3 align-items-end">
                                <div className="col-md-6">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <label className="form-label text-muted small fw-medium mb-0" htmlFor={`instituicao_${idx}`}>
                                      Instituição Financiadora
                                    </label>
                                    <button
                                      type="button"
                                      className="cliente-cadastro-btn-add-instituicao"
                                      onClick={() => abrirCadastroInstituicao(idx)}
                                    >
                                      <i className="bi bi-plus-lg" /> Cadastrar
                                    </button>
                                  </div>
                                  <select
                                    className="form-select"
                                    id={`instituicao_${idx}`}
                                    value={p.instituicao_financiadora}
                                    onChange={(e) => atualizarPagamento(idx, { instituicao_financiadora: e.target.value })}
                                  >
                                    <option value="" disabled>Selecione a parceira...</option>
                                    {instituicoesFinanciadoras.map((opcao) => (
                                      <option key={opcao.id || opcao.nome} value={opcao.nome}>{opcao.nome}</option>
                                    ))}
                                    {p.instituicao_financiadora && !instituicoesFinanciadoras.some((opcao) => opcao.nome === p.instituicao_financiadora) && (
                                      <option value={p.instituicao_financiadora}>{p.instituicao_financiadora}</option>
                                    )}
                                  </select>
                                  {cadastroInstituicao.aberto && cadastroInstituicao.idx === idx && (
                                    <div className="cliente-cadastro-nova-instituicao">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nome da instituição"
                                        value={cadastroInstituicao.nome}
                                        maxLength={200}
                                        autoFocus
                                        onChange={(e) => setCadastroInstituicao((prev) => ({ ...prev, nome: e.target.value }))}
                                        onKeyDown={(e) => {
                                          if (e.key === 'Enter') {
                                            e.preventDefault()
                                            salvarNovaInstituicao(idx)
                                          }
                                          if (e.key === 'Escape') fecharCadastroInstituicao()
                                        }}
                                      />
                                      <button
                                        type="button"
                                        className="cliente-cadastro-btn-salvar-instituicao"
                                        disabled={cadastroInstituicao.salvando}
                                        onClick={() => salvarNovaInstituicao(idx)}
                                      >
                                        {cadastroInstituicao.salvando ? 'Salvando...' : 'Salvar'}
                                      </button>
                                      <button
                                        type="button"
                                        className="cliente-cadastro-btn-cancelar-instituicao"
                                        disabled={cadastroInstituicao.salvando}
                                        onClick={fecharCadastroInstituicao}
                                      >
                                        Cancelar
                                      </button>
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <label className="cliente-cadastro-check cliente-cadastro-check--campo" htmlFor={`financiamento_terceiro_${idx}`}>
                                    <input
                                      type="checkbox"
                                      id={`financiamento_terceiro_${idx}`}
                                      checked={!!p.financiamento_terceiro}
                                      onChange={(e) => {
                                        const checked = e.target.checked
                                        atualizarPagamento(idx, checked
                                          ? { financiamento_terceiro: true }
                                          : {
                                            financiamento_terceiro: false,
                                            documento_titular_file: null,
                                            documento_titular_nome: '',
                                            documento_titular_url: ''
                                          })
                                      }}
                                    />
                                    <span>Financiamento em nome de terceiro</span>
                                  </label>
                                </div>
                              </div>
                              {p.financiamento_terceiro && (
                                <div className="cliente-cadastro-upload-terceiro">
                                  <label className="form-label text-muted small fw-medium mb-2" htmlFor={`doc_titular_${idx}`}>
                                    Anexar Documento com foto (CNH ou RG do titular do financiamento)
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    id={`doc_titular_${idx}`}
                                    accept=".pdf,image/jpeg,image/png"
                                    onChange={(e) => handleDocumentoTitularChange(idx, e.target.files?.[0] || null)}
                                  />
                                  {(p.documento_titular_nome || p.documento_titular_url) && (
                                    <small className="text-muted d-block mt-2">
                                      {p.documento_titular_file
                                        ? `Arquivo selecionado: ${p.documento_titular_nome}`
                                        : (
                                          <a href={p.documento_titular_url} target="_blank" rel="noreferrer">
                                            Ver documento anexado
                                          </a>
                                        )}
                                    </small>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    <div className="cliente-cadastro-outras-info">
                      <div className="row g-3 align-items-end">
                        <div className={formData.indicacao ? 'col-md-8' : 'col-12'}>
                          <label className="cliente-cadastro-check cliente-cadastro-check--campo" htmlFor="indicacao">
                            <input
                              type="checkbox"
                              id="indicacao"
                              name="indicacao"
                              checked={formData.indicacao}
                              onChange={(e) => {
                                const checked = e.target.checked
                                setFormData((prev) => ({
                                  ...prev,
                                  indicacao: checked,
                                  cpf_indicador: checked ? prev.cpf_indicador : '',
                                  nome_indicador: ''
                                }))
                              }}
                            />
                            <span>Cliente foi indicado por parceiro?</span>
                          </label>
                        </div>
                        {formData.indicacao && (
                          <div className="col-md-4">
                            <div className="form-floating">
                              <input
                                type="text"
                                className="form-control"
                                id="cpf_indicador"
                                name="cpf_indicador"
                                placeholder=" "
                                value={formatCPFDisplay(formData.cpf_indicador)}
                                onChange={handleCPFChange}
                                maxLength="14"
                              />
                              <label htmlFor="cpf_indicador">CPF do Parceiro</label>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          id="observacoes"
                          name="observacoes"
                          placeholder=" "
                          style={{ height: 100 }}
                          value={formData.observacoes}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="observacoes">Observações Gerais</label>
                      </div>
                    </div>

                    {pagamentoValidacaoErro && (
                      <div className="cliente-cadastro-alerta-soma" role="alert">
                        <i className="bi bi-exclamation-triangle-fill" />
                        <span>{pagamentoValidacaoErro}</span>
                      </div>
                    )}
                  </>
                )}

                {abaAtiva === 'kit' && (
                  <>
                    <div className="cliente-cadastro-pane-header cliente-cadastro-pane-header--kit">
                      <div>
                        <h4>Kit Solar</h4>
                        <p>Adicione quantos modelos de inversor e módulo forem necessários.</p>
                      </div>
                      {podeCadastrarKitModelo && (
                        <button
                          type="button"
                          className="cliente-cadastro-btn-add-instituicao"
                          onClick={() => abrirCadastroKitModelo('inversor')}
                        >
                          <i className="bi bi-plus-lg" /> Cadastrar inversor ou módulo
                        </button>
                      )}
                    </div>
                    {formularioCadastroKitModelo}
                    {renderBlocoKit('inversores', {
                      titulo: 'Inversores',
                      itemLabel: 'Inversor',
                      unidade: 'kW',
                      catalogo: catalogoInversores,
                      labelMarca: 'Marca do Inversor',
                      placeholder: 'Pesquisar marca ou modelo do inversor...',
                      labelModelo: 'Modelo do Inversor',
                      labelPotencia: 'Potência do Inversor (kW)',
                      labelQuantidade: 'Quantidade de Inversor',
                      botaoAdicionar: 'Adicionar inversor'
                    })}
                    {renderBlocoKit('modulos', {
                      titulo: 'Módulos',
                      itemLabel: 'Módulo',
                      unidade: 'W',
                      catalogo: catalogoModulos,
                      labelMarca: 'Marca do Módulo',
                      placeholder: 'Pesquisar marca ou modelo do módulo...',
                      labelModelo: 'Modelo do Módulo',
                      labelPotencia: 'Potência do Módulo (W)',
                      labelQuantidade: 'Quantidade de Módulo',
                      botaoAdicionar: 'Adicionar módulo'
                    })}
                  </>
                )}
              </div>

              <div className="cliente-cadastro-footer">
                <button
                  type="button"
                  className="cliente-cadastro-btn-outline"
                  onClick={resetForm}
                  disabled={loading}
                >
                  Cancelar
                </button>
                {!isLastTab && (
                  <button
                    type="button"
                    className="cliente-cadastro-btn-outline"
                    onClick={() => setFormTab(formTabs[tabIndex + 1].id)}
                  >
                    Continuar <i className="bi bi-arrow-right ms-1" />
                  </button>
                )}
                <button
                  type="submit"
                  className="cliente-cadastro-btn-primary"
                  disabled={loading}
                >
                  {loading
                    ? 'Salvando...'
                    : editingCliente
                      ? 'Atualizar cadastro'
                      : 'Concluir Cadastro'}
                  {!loading && <i className="bi bi-arrow-right ms-2" />}
                </button>
              </div>
            </div>
        </form>

        {/* Modal de Mensagens no Formulário */}
        {messageModal.show && (
          <div className="modal-overlay-mensagem" onClick={closeMessageModal}>
            <div 
              className={`modal-mensagem modal-${messageModal.type}`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-mensagem-header">
                <h3>{messageModal.title}</h3>
                <button onClick={closeMessageModal} className="btn-close-modal-msg">✕</button>
              </div>
              <div className="modal-mensagem-body">
                <div className={`icon-${messageModal.type}`}>
                  {messageModal.type === 'success' ? '✅' : '❌'}
                </div>
                <p>{messageModal.message}</p>
              </div>
              <div className="modal-mensagem-footer">
                <button onClick={closeMessageModal} className="btn btn-primary">
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="clientes-ii-container">
      <div className="clientes-ii-header">
        <h2>💼 Gestão de Clientes</h2>
        <div className="header-actions">
          <button onClick={() => {
            setEditingCliente(null)
            setFormAbertoManualmente(true)
            setFormTab('pessoais')
            setModoCadastro(permitirVendaEmpresa ? 'venda' : 'resumido')
            setShowForm(true)
            setPagamentosList([novaLinhaPagamento()])
            setPagamentoValidacaoErro('')
          }} className="btn btn-primary">
            ➕ Novo Cliente
          </button>
          {onBack && (
            <button onClick={onBack} className="btn-back">
              Voltar
            </button>
          )}
        </div>
      </div>

      {loading && <div className="loading">Carregando...</div>}

      {/* Filtros */}
      <div className="filtros-container" style={{
        marginBottom: '1.5rem',
        padding: '1.5rem',
        background: '#f8f9fa',
        borderRadius: '12px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ marginBottom: '1rem', fontSize: '1.1rem', fontWeight: '600', color: '#495057' }}>
          🔍 Filtros de Busca
        </h3>
        <div className={`filtros-grid ${userRole === 'administrador' ? 'filtros-grid--admin' : ''}`}>
          {userRole === 'administrador' && (
            <div>
              <label htmlFor="filtro-empresa" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#495057' }}>
                Empresa:
              </label>
              <select
                id="filtro-empresa"
                value={filtroEmpresa}
                onChange={(e) => setFiltroEmpresa(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #ced4da',
                  borderRadius: '6px',
                  fontSize: '0.95rem'
                }}
              >
                <option value="">Todas as empresas</option>
                {empresas.map(empresa => (
                  <option key={empresa.id} value={empresa.id}>
                    {empresa.empresa}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div>
            <label htmlFor="filtro-nome" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#495057' }}>
              Nome do Cliente:
            </label>
            <input
              type="text"
              id="filtro-nome"
              value={filtroNome}
              onChange={(e) => setFiltroNome(e.target.value)}
              placeholder="Digite o nome do cliente..."
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>
          <div>
            <label htmlFor="filtro-cpf" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#495057' }}>
              CPF do cliente
            </label>
            <input
              id="filtro-cpf"
              type="text"
              value={filtroCpf}
              onChange={(e) => setFiltroCpf(e.target.value)}
              placeholder="Digite o CPF ou parte dele..."
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>
        </div>
        {(filtroEmpresa || filtroNome || filtroCpf.trim()) && (
          <div style={{ marginTop: '1rem', padding: '0.75rem', background: '#e7f3ff', borderRadius: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.9rem', color: '#0056b3' }}>
              {totalClientes} {totalClientes === 1 ? 'cliente encontrado' : 'clientes encontrados'}
            </span>
            <button
              onClick={() => {
                setFiltroEmpresa('')
                setFiltroNome('')
                setFiltroCpf('')
              }}
              style={{
                padding: '0.4rem 0.8rem',
                background: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              Limpar Filtros
            </button>
          </div>
        )}
      </div>

        {clientesFiltrados.length === 0 ? (
          <div className="empty-state">
            <p>📋 {clientes.length === 0 ? 'Nenhum cliente cadastrado.' : 'Nenhum cliente encontrado com os filtros aplicados.'}</p>
            <button onClick={() => {
              setEditingCliente(null)
              setFormAbertoManualmente(true)
              setFormTab('pessoais')
              setModoCadastro(permitirVendaEmpresa ? 'venda' : 'resumido')
              setShowForm(true)
            }} className="btn btn-primary">
              Cadastrar Primeiro Cliente
            </button>
          </div>
        ) : (
        <>
        <div className="table-container">
          <div className="clientes-desktop">
            <div className="table-wrapper">
              <table className="clientes-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Telefone</th>
                    <th>Cadastrado por</th>
                    <th>Processo</th>
                    <th>Valor Total</th>
                    <th>Pagamento</th>
                    <th>Majoração</th>
                    <th>Origem</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {clientesFiltrados.map(cliente => (
                    <tr key={cliente.id} className={!cliente.ativo ? 'row-inactive' : ''}>
                      <td className="cliente-nome">
                        <div className="nome-badges">
                          <button 
                            onClick={() => openClienteModal(cliente)} 
                            className="nome-button"
                            title="Clique para ver detalhes do cliente"
                          >
                            <span className="nome-text">{cliente.nome_completo}</span>
                          </button>
                          <div className="badges-inline">
                            {cliente.indicacao && <span className="badge-mini badge-indicacao">Indicado</span>}
                            {cliente.venda_hangsix && <span className="badge-mini badge-hangsix">{nomeEmpresa}</span>}
                          </div>
                        </div>
                        {cliente.indicacao && cliente.nome_indicador && (
                          <small className="indicador-info">Por: {cliente.nome_indicador}</small>
                        )}
                      </td>
                      <td className="cliente-cpf">{formatCPFDisplay(cliente.cpf)}</td>
                      <td className="cliente-telefone">{cliente.telefone || '-'}</td>
                      <td className="cliente-cadastrado-por">
                        <button
                          type="button"
                          className="cliente-cadastrado-por-texto"
                          onClick={() => abrirResponsavelModal(cliente)}
                          title={cliente.responsavel_nome ? 'Alterar quem cadastrou este cliente' : 'Definir quem cadastrou este cliente'}
                        >
                          {cliente.responsavel_nome || 'Definir'}
                        </button>
                      </td>
                      <td className="cliente-processo">
                        <ColunaProcessoCliente cliente={cliente} />
                      </td>
                      <td className="cliente-valor">{formatCurrencyDisplay(cliente.valor_total)}</td>
                      <td className="cliente-pagamento">
                        {cliente.tipo_pagamento === 'avista' ? 'À Vista' : `${cliente.quantidade_parcelas || '?'}x`}
                      </td>
                      <td className="cliente-majoracao">
                        {cliente.majoracao ? formatCurrencyDisplay(cliente.majoracao) : '-'}
                      </td>
                      <td className="cliente-origem">
                        {cliente.id_proposta ? (
                          <span className="badge-origem" title={`Proposta #${cliente.id_proposta}`}>
                            📋 #{cliente.id_proposta}
                          </span>
                        ) : (
                          <span className="sem-origem">-</span>
                        )}
                      </td>
                      <td className="cliente-status">
                        <StatusEtapaCliente cliente={cliente} />
                      </td>
                      <td className="cliente-acoes">
                        {!listaMobile && (
                          <ClienteAcoesDropdown
                            aberto={acoesMenuClienteId === cliente.id}
                            onToggle={() => setAcoesMenuClienteId((atual) => atual === cliente.id ? null : cliente.id)}
                            onClose={fecharAcoesMenu}
                            itens={montarItensAcoesCliente(cliente)}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

          {/* Mobile: cards */}
          <div className="clientes-cards-mobile">
            {clientesFiltrados.map(cliente => (
              <div key={cliente.id} className={`cliente-card-mobile ${!cliente.ativo ? 'row-inactive' : ''}`}>
                <div className="cliente-card-mobile-campos">
                  <div className="cliente-card-mobile-linha">
                    <span className="cliente-card-mobile-label">Nome</span>
                    <span className="cliente-card-mobile-nome">{cliente.nome_completo || '–'}</span>
                  </div>
                  <div className="cliente-card-mobile-linha">
                    <span className="cliente-card-mobile-label">CPF</span>
                    <span className="cliente-card-mobile-cpf">{formatCPFDisplay(cliente.cpf)}</span>
                  </div>
                  <div className="cliente-card-mobile-linha">
                    <span className="cliente-card-mobile-label">Cadastrado por</span>
                    <button
                      type="button"
                      className="cliente-cadastrado-por-texto"
                      onClick={() => abrirResponsavelModal(cliente)}
                      title={cliente.responsavel_nome ? 'Alterar quem cadastrou este cliente' : 'Definir quem cadastrou este cliente'}
                    >
                      {cliente.responsavel_nome || 'Definir'}
                    </button>
                  </div>
                  <div className="cliente-card-mobile-linha cliente-card-mobile-processo">
                    <span className="cliente-card-mobile-label">Processo</span>
                    <div className="cliente-card-mobile-processo-valor">
                      <ColunaProcessoCliente cliente={cliente} />
                    </div>
                  </div>
                  <div className="cliente-card-mobile-linha">
                    <span className="cliente-card-mobile-label">Status</span>
                    <StatusEtapaCliente cliente={cliente} />
                  </div>
                  <div className="cliente-card-mobile-linha">
                    <span className="cliente-card-mobile-label">Valor</span>
                    <span className="cliente-card-mobile-valor">{formatCurrencyDisplay(cliente.valor_total)}</span>
                  </div>
                </div>
                <div className="cliente-card-mobile-acoes">
                  {listaMobile && (
                    <ClienteAcoesDropdown
                      aberto={acoesMenuClienteId === cliente.id}
                      onToggle={() => setAcoesMenuClienteId((atual) => atual === cliente.id ? null : cliente.id)}
                      onClose={fecharAcoesMenu}
                      itens={montarItensAcoesCliente(cliente)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
        )}
                
      {/* Modal de Mensagens */}
      {messageModal.show && (
        <div className="modal-overlay-mensagem" onClick={closeMessageModal}>
          <div 
            className={`modal-mensagem modal-${messageModal.type}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-mensagem-header">
              <h3>{messageModal.title}</h3>
              <button onClick={closeMessageModal} className="btn-close-modal-msg">✕</button>
            </div>
            <div className="modal-mensagem-body">
              <div className={`icon-${messageModal.type}`}>
                {messageModal.type === 'success' ? '✅' : '❌'}
              </div>
              <p>{messageModal.message}</p>
            </div>
            <div className="modal-mensagem-footer">
              <button onClick={closeMessageModal} className="btn btn-primary">
                OK
              </button>
            </div>
          </div>
                  </div>
                )}
                
      {/* Modal de Documentos */}
      {showDocumentos && clienteSelecionado && (
        <DocumentosCliente
          cliente={clienteSelecionado}
          onClose={() => {
            setShowDocumentos(false)
            setClienteSelecionado(null)
          }}
        />
      )}

      <DocumentosJuridicosModal
        open={!!clienteDocsJuridicos}
        cliente={clienteDocsJuridicos}
        canEnviarClicksign={canEnviarClicksign}
        onNotify={showNotification}
        onClose={() => setClienteDocsJuridicos(null)}
      />

      {/* Modal Nova Ordem de Serviço (aberto a partir da Gestão de Clientes) */}
      {showNovaOrdemModal && clienteParaNovaOrdem && (
        <NovaOrdemServicoModal
          open={showNovaOrdemModal}
          onClose={() => {
            setShowNovaOrdemModal(false)
            setClienteParaNovaOrdem(null)
          }}
          initialCliente={clienteParaNovaOrdem}
          userRole={userRole}
          userEmpresa={userEmpresa}
          userId={userId}
          onSaved={() => {
            setShowNovaOrdemModal(false)
            setClienteParaNovaOrdem(null)
          }}
        />
      )}

      {/* Modal de Geração de Documentos */}
      {showDocumentosModal && clienteParaDocumento && (
        <div className="modal-overlay" onClick={() => !gerandoContratoPdf && setShowDocumentosModal(false)}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()}>
            <div className="modal-documentos-header">
              <h2>📄 Gerar Documentos</h2>
              <button 
                onClick={() => !gerandoContratoPdf && setShowDocumentosModal(false)} 
                className="btn-close-modal"
                title="Fechar"
                disabled={gerandoContratoPdf}
              >
                ✕
              </button>
            </div>
            <div className="modal-documentos-body">
              <p className="modal-documentos-cliente">
                <strong>Cliente:</strong> {clienteParaDocumento.nome_completo}
              </p>
              <div className="documentos-opcoes">
                <button
                  onClick={() => abrirModalProcurador(clienteParaDocumento)}
                  className="btn-documento-opcao"
                  title="Gerar Procuração"
                >
                  <div className="documento-icon">📋</div>
                  <div className="documento-info">
                    <h3>Gerar Procuração</h3>
                    <p>Gera documento de procuração para a Equatorial Energia</p>
                  </div>
                </button>
                <div className="documento-opcao-grupo" style={{ marginTop: '0.5rem' }}>
                  <span className="documento-opcao-label" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#495057' }}>Gerar Contrato</span>
                  <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => gerarContratoPDF(clienteParaDocumento)}
                      className="btn-documento-opcao"
                      title="Contrato em PDF"
                      style={{ flex: '1 1 140px' }}
                      disabled={gerandoContratoPdf}
                    >
                      <div className="documento-icon">📄</div>
                      <div className="documento-info">
                        <h3>PDF</h3>
                        <p>Contrato em PDF para impressão</p>
                      </div>
                    </button>
                    <button
                      onClick={() => gerarContratoHtml(clienteParaDocumento)}
                      className="btn-documento-opcao"
                      title="Contrato em HTML para editar"
                      style={{ flex: '1 1 140px' }}
                      disabled={gerandoContratoPdf}
                    >
                      <div className="documento-icon">🌐</div>
                      <div className="documento-info">
                        <h3>HTML</h3>
                        <p>Mesmo conteúdo do PDF, para editar</p>
                      </div>
                    </button>
                    <button
                      onClick={() => gerarContratoWord(clienteParaDocumento)}
                      className="btn-documento-opcao"
                      title="Contrato em Word para editar"
                      style={{ flex: '1 1 140px' }}
                      disabled={gerandoContratoPdf}
                    >
                      <div className="documento-icon">📝</div>
                      <div className="documento-info">
                        <h3>Word</h3>
                        <p>Documento em Word para editar</p>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-documentos-footer">
              <button
                onClick={() => setShowDocumentosModal(false)}
                className="btn btn-secondary"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal hub Clicksign: baixar assinado ou enviar/reenviar */}
      {clicksignHubCliente && (
        <div className="modal-overlay" onClick={closeClicksignHub}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
            <div className="modal-documentos-header">
              <h2>✉️ Assinatura (Clicksign)</h2>
              <button type="button" className="btn-close-modal" onClick={closeClicksignHub} title="Fechar" aria-label="Fechar">✕</button>
            </div>
            <div className="modal-documentos-body">
              <p className="modal-documentos-cliente"><strong>Cliente:</strong> {clicksignHubCliente.nome_completo}</p>
              {(() => {
                const c = clicksignHubCliente
                const envio = enviosProcuracaoPorCliente[c.id]
                const assinado = !!envio?.signed_at
                const jaEnviado = !!envio && !assinado
                if (assinado) {
                  const dataAss = envio?.signed_at ? formatarDataEnvio(envio.signed_at) : ''
                  return (
                    <>
                      <div className="cadastrar-clicksign-hub-banner cadastrar-clicksign-hub-banner--assinado">
                        ✓ Documento assinado{dataAss ? ` em ${dataAss}` : ''}.
                      </div>
                      <div className="cadastrar-clicksign-hub-acoes">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => handleBaixarDocumentoAssinado(c)}
                          disabled={baixandoAssinadoClienteId === c.id}
                        >
                          {baixandoAssinadoClienteId === c.id ? 'Baixando…' : '⬇️ Baixar PDF assinado'}
                        </button>
                      </div>
                    </>
                  )
                }
                return (
                  <>
                    <div className="cadastrar-clicksign-hub-banner cadastrar-clicksign-hub-banner--pendente">
                      {jaEnviado
                        ? `⏳ Aguardando assinatura. Enviado em ${formatarDataEnvio(envio.created_at)}.`
                        : '⏳ Nenhum documento enviado para assinatura ainda.'}
                    </div>
                    <div className="cadastrar-clicksign-hub-acoes">
                      <button
                        type="button"
                        className="btn btn-cadastrar-clicksign btn-cadastrar-clicksign--pendente"
                        style={{ padding: '0.55rem 1rem', fontSize: '0.95rem', width: '100%' }}
                        disabled={sendingClicksign}
                        onClick={() => {
                          closeClicksignHub()
                          openEnviarClicksign(c)
                        }}
                      >
                        {jaEnviado ? '✉️ Reenviar para assinatura' : '✉️ Enviar para assinatura'}
                      </button>
                    </div>
                  </>
                )
              })()}
            </div>
            <div className="modal-documentos-footer">
              <button type="button" className="btn btn-secondary w-100" onClick={closeClicksignHub}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Enviar procuração para assinatura (Clicksign) */}
      {showClicksignModal && clienteClicksign && (
        <div className="modal-overlay" onClick={closeClicksignModal}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
            <div className="modal-documentos-header">
              <h2>✉️ Enviar procuração para assinatura (Clicksign)</h2>
              <button type="button" className="btn-close-modal" onClick={closeClicksignModal} title="Fechar">✕</button>
            </div>
            <div className="modal-documentos-body">
              <p className="modal-documentos-cliente"><strong>Cliente:</strong> {clienteClicksign.nome_completo}</p>
              {enviosProcuracaoPorCliente[clienteClicksign.id] && (
                <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#0d6efd' }}>
                  ✓ Já enviado em {formatarDataEnvio(enviosProcuracaoPorCliente[clienteClicksign.id].created_at)}. Deseja reenviar?
                </p>
              )}
              <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#6c757d' }}>O que deseja enviar para assinatura?</p>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', marginBottom: '0.5rem' }}>
                  <input type="radio" name="clicksign-modo" value="procuracao_contrato" checked={clicksignModoEnvio === 'procuracao_contrato'} onChange={() => setClicksignModoEnvio('procuracao_contrato')} />
                  <span>Procuração + contrato</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="radio" name="clicksign-modo" value="anexos" checked={clicksignModoEnvio === 'anexos'} onChange={() => setClicksignModoEnvio('anexos')} />
                  <span>Documentos anexados (apenas os PDFs que eu escolher)</span>
                </label>
              </div>
              {clicksignModoEnvio === 'anexos' && (
                <div className="mb-3">
                  <label className="form-label">📎 Anexar documentos (PDF)</label>
                  <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '0.5rem' }}>Selecione um ou mais PDFs. Eles serão mesclados na ordem e enviados para assinatura.</p>
                  <input
                    ref={clicksignFileInputRef}
                    type="file"
                    accept="application/pdf"
                    multiple
                    className="form-control form-control-sm"
                    onChange={(e) => {
                      const files = e.target.files ? Array.from(e.target.files) : []
                      setClicksignAnexos(prev => [...prev, ...files])
                    }}
                  />
                  {clicksignAnexos.length > 0 ? (
                    <ul style={{ marginTop: '0.5rem', marginBottom: 0, paddingLeft: '1.25rem', fontSize: '0.9rem' }}>
                      {clicksignAnexos.map((file, index) => (
                        <li key={`${file.name}-${index}`} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                          <span title={file.name} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{file.name}</span>
                          <button type="button" className="btn btn-sm btn-outline-danger" style={{ padding: '0.15rem 0.4rem', fontSize: '0.8rem' }} onClick={() => removeClicksignAnexo(index)}>Remover</button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p style={{ fontSize: '0.85rem', color: '#dc3545', marginTop: '0.35rem', marginBottom: 0 }}>É necessário anexar ao menos um PDF.</p>
                  )}
                </div>
              )}
              <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#6c757d' }}>Como o link será enviado ao signatário?</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', cursor: 'pointer' }}>
                  <input type="radio" name="clicksign-send-via" value="email" checked={clicksignSendVia === 'email'} onChange={() => setClicksignSendVia('email')} />
                  <span>📧 E-mail</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', cursor: 'pointer' }}>
                  <input type="radio" name="clicksign-send-via" value="whatsapp" checked={clicksignSendVia === 'whatsapp'} onChange={() => setClicksignSendVia('whatsapp')} />
                  <span>📱 WhatsApp</span>
                </label>
              </div>
              {clicksignSendVia === 'email' && (
                <div className="mb-3">
                  <label className="form-label">E-mail do signatário</label>
                  <input type="email" className="form-control" value={clicksignEmailInput} onChange={(e) => setClicksignEmailInput(e.target.value)} placeholder="email@exemplo.com" />
                </div>
              )}
              {clicksignSendVia === 'whatsapp' && (
                <div className="mb-3">
                  <label className="form-label">Telefone (WhatsApp)</label>
                  <input type="tel" className="form-control" value={clicksignPhoneInput} onChange={(e) => setClicksignPhoneInput(e.target.value.replace(/\D/g, ''))} placeholder="11999999999" maxLength={11} />
                  <small className="text-muted">Apenas números, com DDD (10 ou 11 dígitos). A Clicksign envia o convite só pelo WhatsApp.</small>
                </div>
              )}
            </div>
            <div className="modal-documentos-footer">
              <button type="button" className="btn btn-secondary" onClick={closeClicksignModal}>Cancelar</button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={sendingClicksign || (clicksignModoEnvio === 'anexos' && clicksignAnexos.length === 0)}
                onClick={() => enviarParaClicksign(clienteClicksign, clicksignSendVia, clicksignEmailInput, clicksignPhoneInput, clicksignModoEnvio, clicksignAnexos)}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Gerando contrato PDF (spinner) */}
      {gerandoContratoPdf && (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '320px', textAlign: 'center' }}>
            <div className="modal-documentos-body" style={{ padding: '2rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <span className="spinner-border text-primary" role="status" aria-hidden="true" style={{ width: '3rem', height: '3rem' }} />
              </div>
              <p style={{ margin: 0, fontSize: '1rem', color: '#495057' }}>Gerando contrato…</p>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Enviando (spinner) — exibido enquanto a requisição está em andamento */}
      {sendingClicksign && (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '360px', textAlign: 'center' }}>
            <div className="modal-documentos-body" style={{ padding: '2rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <span className="spinner-border text-primary" role="status" aria-hidden="true" style={{ width: '3rem', height: '3rem' }} />
              </div>
              <p style={{ margin: 0, fontSize: '1rem', color: '#495057' }}>{clicksignProgressMsg}</p>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Sucesso Clicksign (link de assinatura) */}
      {clicksignResult && (
        <div className="modal-overlay" onClick={() => setClicksignResult(null)}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            <div className="modal-documentos-header">
              <h2>✅ Procuração enviada para assinatura</h2>
              <button type="button" className="btn-close-modal" onClick={() => setClicksignResult(null)} title="Fechar">✕</button>
            </div>
            <div className="modal-documentos-body">
              <p style={{ marginBottom: '1rem', color: '#495057' }}>{clicksignResult.message}</p>
              {clicksignResult.url && (
                <>
                  <p style={{ marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '600' }}>Link para o cliente assinar:</p>
                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    <input type="text" readOnly value={clicksignResult.url} className="form-control" style={{ flex: '1', minWidth: '200px', fontSize: '0.85rem' }} />
                    <button type="button" className="btn btn-outline-primary" onClick={() => { navigator.clipboard.writeText(clicksignResult.url); showNotification('Link copiado!', 'success') }}>Copiar link</button>
                  </div>
                </>
              )}
            </div>
            <div className="modal-documentos-footer">
              <button type="button" className="btn btn-primary" onClick={() => setClicksignResult(null)}>OK</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Assinatura realizada com sucesso (Realtime) */}
      {assinaturaSucessoModal.show && (
        <div className="modal-overlay" onClick={() => setAssinaturaSucessoModal({ show: false, clienteNome: '' })}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <div className="modal-documentos-header">
              <h2>✅ Assinatura realizada com sucesso</h2>
              <button type="button" className="btn-close-modal" onClick={() => setAssinaturaSucessoModal({ show: false, clienteNome: '' })} title="Fechar">✕</button>
            </div>
            <div className="modal-documentos-body">
              <p style={{ marginBottom: 0, color: '#495057', fontSize: '1rem' }}>
                O documento de <strong>{assinaturaSucessoModal.clienteNome}</strong> foi assinado com sucesso.
              </p>
            </div>
            <div className="modal-documentos-footer">
              <button type="button" className="btn btn-primary" onClick={() => setAssinaturaSucessoModal({ show: false, clienteNome: '' })}>OK</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Gerar Projeto PDF */}
      {showResponsavelModal && (
        <div className="modal-overlay" onClick={fecharResponsavelModal}>
          <div className="modal-documentos-geracao" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px' }}>
            <div className="modal-documentos-header">
              <h2>{clienteParaResponsavel?.id_responsavel ? 'Alterar quem cadastrou' : 'Definir quem cadastrou'}</h2>
              <button
                type="button"
                onClick={fecharResponsavelModal}
                className="btn-close-modal"
                title="Fechar"
              >
                ✕
              </button>
            </div>
            <div className="modal-documentos-body">
              {clienteParaResponsavel && (
                <p className="mb-2 text-muted small">
                  Cliente: <strong>{clienteParaResponsavel.nome_completo}</strong>
                </p>
              )}
              <div className="mb-3">
                <label className="form-label">Responsável pelo cadastro</label>
                <select
                  className="form-control"
                  value={responsavelSelecionadoId}
                  onChange={(e) => setResponsavelSelecionadoId(e.target.value)}
                  disabled={carregandoResponsaveis || salvandoResponsavel}
                >
                  <option value="">
                    {carregandoResponsaveis ? 'Carregando usuários...' : 'Selecione um usuário'}
                  </option>
                  {usuariosResponsaveis.map(u => (
                    <option key={u.id} value={u.id}>{u.nome}</option>
                  ))}
                </select>
                {!carregandoResponsaveis && usuariosResponsaveis.length === 0 && (
                  <small className="text-muted">Nenhum usuário ativo encontrado.</small>
                )}
              </div>
            </div>
            <div className="modal-documentos-footer">
              <button
                type="button"
                onClick={fecharResponsavelModal}
                className="btn btn-secondary"
                disabled={salvandoResponsavel}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={salvarResponsavel}
                disabled={salvandoResponsavel || !responsavelSelecionadoId}
                className="btn btn-primary"
              >
                {salvandoResponsavel ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showProjetoDxfModal && (
        <div className="modal-overlay" onClick={() => !gerandoProjetoDxf && setShowProjetoDxfModal(false)}>
          <div className="modal-documentos-geracao modal-projeto-unifilar" onClick={(e) => e.stopPropagation()}>
            <div className="modal-documentos-header">
              <h2>📐 Gerar Projeto PDF</h2>
              <button
                type="button"
                onClick={() => !gerandoProjetoDxf && setShowProjetoDxfModal(false)}
                className="btn-close-modal"
                title="Fechar"
              >
                ✕
              </button>
            </div>
            <div className="modal-documentos-body">
              <p className="mb-3 text-muted small">
                A geração baixa dois PDFs, com os mesmos dados e o mesmo rodapé: o diagrama unifilar e o diagrama de blocos. A quarta coluna do rodapé fica livre para a assinatura do gov.br ou do certificado digital. Vmp, Imp, corrente e os outros campos preenchidos ficam salvos para o próximo projeto.
                {clienteParaProjetoDxf?.nome_completo ? ` Cliente: ${clienteParaProjetoDxf.nome_completo}.` : ''}
              </p>
              {(projetoDxfForm.avisos || []).length > 0 && (
                <div className="projeto-unifilar-aviso">
                  {projetoDxfForm.avisos.map((texto) => <p key={texto}>{texto}</p>)}
                </div>
              )}
              <div className="projeto-unifilar-grid">
                <div className="span-2">
                  <label className="form-label">Cliente</label>
                  <input type="text" className="form-control" value={projetoDxfForm.cliente} onChange={(e) => atualizarCampoProjeto('cliente', e.target.value)} />
                </div>
                <div className="span-2">
                  <label className="form-label">Endereço</label>
                  <input type="text" className="form-control" value={projetoDxfForm.endereco} onChange={(e) => atualizarCampoProjeto('endereco', e.target.value)} />
                </div>
                <div>
                  <label className="form-label">Cidade</label>
                  <input type="text" className="form-control" value={projetoDxfForm.cidade} onChange={(e) => atualizarCampoProjeto('cidade', e.target.value)} />
                </div>
                <div>
                  <label className="form-label">UF</label>
                  <input type="text" className="form-control" value={projetoDxfForm.uf} maxLength={2} onChange={(e) => atualizarCampoProjeto('uf', e.target.value.toUpperCase())} />
                </div>
                <div className="span-2">
                  <label className="form-label">Padrão de entrada</label>
                  <select className="form-control" value={projetoDxfForm.padrao} onChange={(e) => atualizarCampoProjeto('padrao', e.target.value)}>
                    <option value="monofasico">Monofásico 220 V</option>
                    <option value="bifasico">Bifásico 220 V</option>
                    <option value="trifasico">Trifásico 220/380 V</option>
                  </select>
                </div>

                <p className="projeto-unifilar-secao">Módulos</p>
                <div>
                  <label className="form-label">Marca</label>
                  <input type="text" className="form-control" value={projetoDxfForm.marcaModulo} onChange={(e) => atualizarCampoProjeto('marcaModulo', e.target.value)} />
                </div>
                <div>
                  <label className="form-label">Modelo</label>
                  <input type="text" className="form-control" value={projetoDxfForm.modeloModulo} onChange={(e) => atualizarCampoProjeto('modeloModulo', e.target.value)} />
                </div>
                <div>
                  <label className="form-label">Potência (W)</label>
                  <input type="number" min="1" className="form-control" value={projetoDxfForm.potenciaModuloW} onChange={(e) => atualizarCampoProjeto('potenciaModuloW', e.target.value)} />
                </div>
                <div>
                  <label className="form-label">Quantidade</label>
                  <input type="number" min="1" className="form-control" value={projetoDxfForm.qtdModulos} onChange={(e) => atualizarCampoProjeto('qtdModulos', e.target.value)} />
                </div>
                <div>
                  <label className="form-label">Vmp (V)</label>
                  <input type="text" className="form-control" value={projetoDxfForm.vmp} onChange={(e) => atualizarCampoProjeto('vmp', e.target.value)} placeholder="Opcional" />
                </div>
                <div>
                  <label className="form-label">Imp (A)</label>
                  <input type="text" className="form-control" value={projetoDxfForm.imp} onChange={(e) => atualizarCampoProjeto('imp', e.target.value)} placeholder="Opcional" />
                </div>
                <div className="span-2">
                  <label className="form-label">Strings</label>
                  <input type="number" min="1" className="form-control" value={projetoDxfForm.qtdStrings} onChange={(e) => atualizarCampoProjeto('qtdStrings', e.target.value)} />
                  <small className="text-muted">{textoPreviaUnifilar(projetoDxfForm)}</small>
                </div>

                <p className="projeto-unifilar-secao">Inversores e proteção CA</p>
                {inversoresDoFormulario(projetoDxfForm).map((inv, i) => (
                  <React.Fragment key={`inversor-unifilar-${i}`}>
                    {inversoresDoFormulario(projetoDxfForm).length > 1 && (
                      <p className="projeto-unifilar-secao">Inversor {i + 1}</p>
                    )}
                    <div>
                      <label className="form-label">Marca</label>
                      <input type="text" className="form-control" value={inv.marca} onChange={(e) => atualizarInversorProjeto(i, 'marca', e.target.value)} />
                    </div>
                    <div>
                      <label className="form-label">Modelo</label>
                      <input type="text" className="form-control" value={inv.modelo} onChange={(e) => atualizarInversorProjeto(i, 'modelo', e.target.value)} />
                    </div>
                    <div>
                      <label className="form-label">Potência (kW)</label>
                      <input type="number" min="0" step="0.01" className="form-control" value={inv.potenciaKw} onChange={(e) => atualizarInversorProjeto(i, 'potenciaKw', e.target.value)} />
                    </div>
                    <div>
                      <label className="form-label">Corrente de saída (A)</label>
                      <input type="number" min="1" className="form-control" value={inv.correnteA} onChange={(e) => atualizarInversorProjeto(i, 'correnteA', e.target.value)} />
                    </div>
                    <div className="span-2">
                      <label className="form-label">Ligação do inversor</label>
                      <select className="form-control" value={inv.ligacao || 'bifasico'} onChange={(e) => atualizarInversorProjeto(i, 'ligacao', e.target.value)}>
                        <option value="monofasico">Monofásico 220 V</option>
                        <option value="bifasico">Bifásico 220 V</option>
                        <option value="trifasico">Trifásico 220/380 V</option>
                      </select>
                      <small className="text-muted">Não acompanha o padrão de entrada. Define a tensão, a corrente e o tipo do disjuntor deste inversor.</small>
                    </div>
                    <div className="span-2">
                      <label className="form-label">{inversoresDoFormulario(projetoDxfForm).length > 1 ? `Disjuntor do inversor ${i + 1} (A)` : 'Disjuntor do quadro CA (A)'}</label>
                      <input type="number" min="1" className="form-control" value={inv.disjuntorA} onChange={(e) => atualizarInversorProjeto(i, 'disjuntorA', e.target.value)} />
                    </div>
                  </React.Fragment>
                ))}
                {inversoresDoFormulario(projetoDxfForm).length > 1 && (
                  <div className="span-2">
                    <label className="form-label">Disjuntor geral (A)</label>
                    <input type="number" min="1" className="form-control" value={projetoDxfForm.disjuntorA} onChange={(e) => atualizarCampoProjeto('disjuntorA', e.target.value)} />
                    <small className="text-muted">Sugerido pela soma das correntes dos inversores. Cada inversor segue com o próprio disjuntor.</small>
                  </div>
                )}
                {inversoresDoFormulario(projetoDxfForm).length === 1 && (
                  <div className="span-2">
                    <small className="text-muted">A corrente e o disjuntor são sugeridos pela potência e pela ligação do inversor.</small>
                  </div>
                )}
                <div className="span-2">
                  <label className="form-label">Disjuntor do padrão e das outras cargas (A)</label>
                  {opcoesDisjuntorPadrao(projetoDxfForm.padrao) ? (
                    <select className="form-control" value={projetoDxfForm.disjuntorPadrao} onChange={(e) => atualizarCampoProjeto('disjuntorPadrao', e.target.value)}>
                      {opcoesDisjuntorPadrao(projetoDxfForm.padrao).map((ampere) => (
                        <option key={ampere} value={String(ampere)}>{ampere} A</option>
                      ))}
                    </select>
                  ) : (
                    <input type="number" min="1" className="form-control" value={projetoDxfForm.disjuntorPadrao} onChange={(e) => atualizarCampoProjeto('disjuntorPadrao', e.target.value)} />
                  )}
                  <small className="text-muted">Bifásico fica em 63 A. Trifásico usa a lista de 70 A a 300 A. Esse disjuntor aparece abaixo do medidor.</small>
                </div>

              </div>
            </div>
            <div className="modal-documentos-footer">
              <button
                type="button"
                onClick={() => !gerandoProjetoDxf && setShowProjetoDxfModal(false)}
                className="btn btn-secondary"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={gerarProjetoPdf}
                disabled={gerandoProjetoDxf}
                className="btn btn-primary"
              >
                {gerandoProjetoDxf ? 'Gerando...' : 'Gerar e baixar PDF'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação */}
      <ConfirmModal
        show={confirmModal.show}
        title={confirmModal.title}
        message={confirmModal.message}
        type={confirmModal.type}
        onConfirm={confirmModal.onConfirm}
        onCancel={() => setConfirmModal({ show: false, title: '', message: '', onConfirm: null })}
        confirmText={confirmModal.type === 'danger' ? 'Sim, Excluir' : 'Sim'}
        cancelText="Cancelar"
      />

      {/* Modal de Sucesso após Cadastro */}
      {successModal.show && (
        <div className="modal-overlay-success">
          <div className="modal-success-cadastro">
            <div className="modal-success-header">
              <div className="success-icon-large">
                🎉
                </div>
              <h2>Cliente Cadastrado com Sucesso!</h2>
              </div>
              
            <div className="modal-success-body">
              <p className="success-message">
                O cliente foi cadastrado com sucesso no sistema!
                {successModal.viaEsteira && (
                  <>
                    <br/>
                    <strong style={{ color: '#667eea', fontSize: '1.1em' }}>
                      🎯 Esteira iniciada! 
                    </strong>
                    <br/>
                    <span style={{ color: '#667eea', fontSize: '0.95em' }}>
                      Ao confirmar, a proposta será marcada como "Aprovada" ✓
                    </span>
                  </>
                )}
                <br/>
                O que deseja fazer agora?
              </p>

              <div className="success-actions">
                <button
                  onClick={async () => {
                    // Atualizar status da proposta se veio via esteira
                    if (successModal.propostaId) {
                      await atualizarStatusProposta(successModal.propostaId)
                    }
                    
                    const cliente = await supabase
                      .from('clientes_cadastro')
                      .select('*')
                      .eq('id', successModal.clienteId)
                      .single()
                    
                    setClienteSelecionado(cliente.data)
                    setShowDocumentos(true)
                    setSuccessModal({ show: false, clienteId: null, viaEsteira: false, propostaId: null })
                  }}
                  className="btn-success-action btn-success-documentos"
                >
                  <span className="action-icon">📎</span>
                  <span className="action-text">Anexar Documentos</span>
                </button>

                <button
                  onClick={async () => {
                    // Atualizar status da proposta se veio via esteira
                    if (successModal.propostaId) {
                      await atualizarStatusProposta(successModal.propostaId)
                    }
                    
                    setSuccessModal({ show: false, clienteId: null, viaEsteira: false, propostaId: null })
                    setShowForm(false)
                  }}
                  className="btn-success-action btn-success-lista"
                >
                  <span className="action-icon">👥</span>
                  <span className="action-text">Ver Lista de Clientes</span>
                </button>

                {!successModal.viaEsteira && (
                  <button
                    onClick={async () => {
                      // Atualizar status da proposta se veio via esteira (não deveria acontecer aqui, mas por segurança)
                      if (successModal.propostaId) {
                        await atualizarStatusProposta(successModal.propostaId)
                      }
                      
                      setSuccessModal({ show: false, clienteId: null, viaEsteira: false, propostaId: null })
                      if (onBack) onBack()
                    }}
                    className="btn-success-action btn-success-dashboard"
                  >
                    <span className="action-icon">🏠</span>
                    <span className="action-text">Voltar ao Dashboard</span>
                  </button>
                )}
              </div>
            </div>
      </div>
        </div>
      )}

      {/* Modal de Detalhes do Cliente */}
      {showClienteModal && clienteModalData && (
        <ClienteDetalhesModal
          cliente={clienteModalData}
          onClose={closeClienteModal}
          onEdit={() => {
            handleEdit(clienteModalData)
            closeClienteModal()
          }}
          onDelete={() => {
            handleDelete(clienteModalData.id)
            closeClienteModal()
          }}
          onDocumentos={() => {
            setClienteSelecionado(clienteModalData)
            setShowDocumentos(true)
            closeClienteModal()
          }}
        />
      )}

      {/* Modal Kit Solar */}
      {showKitSolarModal && createPortal(
        <div className="modal-overlay" onClick={closeKitSolarModal}>
          <div className="modal-content kit-solar-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>☀️ Kit Solar - {currentClienteForKit?.nome_completo}</h2>
              <div className="kit-solar-modal-header-actions">
                {podeCadastrarKitModelo && (
                  <button
                    type="button"
                    className="cliente-cadastro-btn-add-instituicao"
                    onClick={() => abrirCadastroKitModelo('inversor')}
                  >
                    <i className="bi bi-plus-lg" /> Cadastrar inversor ou módulo
                  </button>
                )}
                <button className="modal-close" onClick={closeKitSolarModal}>×</button>
              </div>
            </div>
            
            <div className="modal-form">
              {formularioCadastroKitModelo}
              {renderBlocoKit('inversores', {
                titulo: 'Inversores',
                itemLabel: 'Inversor',
                unidade: 'kW',
                catalogo: catalogoInversores,
                labelMarca: 'Marca do Inversor',
                placeholder: 'Pesquisar marca ou modelo do inversor...',
                labelModelo: 'Modelo do Inversor',
                labelPotencia: 'Potência do Inversor (kW)',
                labelQuantidade: 'Quantidade de Inversor',
                botaoAdicionar: 'Adicionar inversor',
                idPrefix: 'modal_'
              })}
              {renderBlocoKit('modulos', {
                titulo: 'Módulos',
                itemLabel: 'Módulo',
                unidade: 'W',
                catalogo: catalogoModulos,
                labelMarca: 'Marca do Módulo',
                placeholder: 'Pesquisar marca ou modelo do módulo...',
                labelModelo: 'Modelo do Módulo',
                labelPotencia: 'Potência do Módulo (W)',
                labelQuantidade: 'Quantidade de Módulo',
                botaoAdicionar: 'Adicionar módulo',
                idPrefix: 'modal_'
              })}
            </div>
            
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={closeKitSolarModal}
              >
                Cancelar
              </button>
              <button 
                type="button" 
                className="btn btn-primary" 
                onClick={handleSaveKitSolar}
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar Kit Solar'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  )
}

export default ClientesII

